var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import require$$0, { useRef, useEffect, useState, useCallback } from "react";
import require$$2$1 from "react-dom";
function bt(o) {
  throw new Error('Could not dynamically require "' + o + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Xt = { exports: {} };
(function(o, t) {
  (function(n2) {
    o.exports = n2();
  })(function() {
    return function n2(a, d, m2) {
      function b(S, A) {
        if (!d[S]) {
          if (!a[S]) {
            var P = typeof bt == "function" && bt;
            if (!A && P)
              return P(S, true);
            if (I)
              return I(S, true);
            throw new Error("Cannot find module '" + S + "'");
          }
          A = d[S] = { exports: {} }, a[S][0].call(A.exports, function(T) {
            var V = a[S][1][T];
            return b(V || T);
          }, A, A.exports, n2, a, d, m2);
        }
        return d[S].exports;
      }
      for (var I = typeof bt == "function" && bt, M = 0; M < m2.length; M++)
        b(m2[M]);
      return b;
    }({ 1: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        var y = n2("crypto");
        function C(l2, g) {
          g = L(l2, g);
          var s;
          return (s = g.algorithm !== "passthrough" ? y.createHash(g.algorithm) : new B()).write === void 0 && (s.write = s.update, s.end = s.update), O(g, s).dispatch(l2), s.update || s.end(""), s.digest ? s.digest(g.encoding === "buffer" ? void 0 : g.encoding) : (l2 = s.read(), g.encoding !== "buffer" ? l2.toString(g.encoding) : l2);
        }
        (d = a.exports = C).sha1 = function(l2) {
          return C(l2);
        }, d.keys = function(l2) {
          return C(l2, { excludeValues: true, algorithm: "sha1", encoding: "hex" });
        }, d.MD5 = function(l2) {
          return C(l2, { algorithm: "md5", encoding: "hex" });
        }, d.keysMD5 = function(l2) {
          return C(l2, { algorithm: "md5", encoding: "hex", excludeValues: true });
        };
        var h = y.getHashes ? y.getHashes().slice() : ["sha1", "md5"], E = (h.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
        function L(l2, g) {
          var s = {};
          if (s.algorithm = (g = g || {}).algorithm || "sha1", s.encoding = g.encoding || "hex", s.excludeValues = !!g.excludeValues, s.algorithm = s.algorithm.toLowerCase(), s.encoding = s.encoding.toLowerCase(), s.ignoreUnknown = g.ignoreUnknown === true, s.respectType = g.respectType !== false, s.respectFunctionNames = g.respectFunctionNames !== false, s.respectFunctionProperties = g.respectFunctionProperties !== false, s.unorderedArrays = g.unorderedArrays === true, s.unorderedSets = g.unorderedSets !== false, s.unorderedObjects = g.unorderedObjects !== false, s.replacer = g.replacer || void 0, s.excludeKeys = g.excludeKeys || void 0, l2 === void 0)
            throw new Error("Object argument required.");
          for (var u = 0; u < h.length; ++u)
            h[u].toLowerCase() === s.algorithm.toLowerCase() && (s.algorithm = h[u]);
          if (h.indexOf(s.algorithm) === -1)
            throw new Error('Algorithm "' + s.algorithm + '"  not supported. supported values: ' + h.join(", "));
          if (E.indexOf(s.encoding) === -1 && s.algorithm !== "passthrough")
            throw new Error('Encoding "' + s.encoding + '"  not supported. supported values: ' + E.join(", "));
          return s;
        }
        function _(l2) {
          if (typeof l2 == "function")
            return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(l2)) != null;
        }
        function O(l2, g, s) {
          s = s || [];
          function u(i) {
            return g.update ? g.update(i, "utf8") : g.write(i, "utf8");
          }
          return { dispatch: function(i) {
            return this["_" + ((i = l2.replacer ? l2.replacer(i) : i) === null ? "null" : typeof i)](i);
          }, _object: function(i) {
            var c, p2 = Object.prototype.toString.call(i), j = /\[object (.*)\]/i.exec(p2);
            if (j = (j = j ? j[1] : "unknown:[" + p2 + "]").toLowerCase(), 0 <= (p2 = s.indexOf(i)))
              return this.dispatch("[CIRCULAR:" + p2 + "]");
            if (s.push(i), I !== void 0 && I.isBuffer && I.isBuffer(i))
              return u("buffer:"), u(i);
            if (j === "object" || j === "function" || j === "asyncfunction")
              return p2 = Object.keys(i), l2.unorderedObjects && (p2 = p2.sort()), l2.respectType === false || _(i) || p2.splice(0, 0, "prototype", "__proto__", "constructor"), l2.excludeKeys && (p2 = p2.filter(function(R) {
                return !l2.excludeKeys(R);
              })), u("object:" + p2.length + ":"), c = this, p2.forEach(function(R) {
                c.dispatch(R), u(":"), l2.excludeValues || c.dispatch(i[R]), u(",");
              });
            if (!this["_" + j]) {
              if (l2.ignoreUnknown)
                return u("[" + j + "]");
              throw new Error('Unknown object type "' + j + '"');
            }
            this["_" + j](i);
          }, _array: function(i, R) {
            R = R !== void 0 ? R : l2.unorderedArrays !== false;
            var p2 = this;
            if (u("array:" + i.length + ":"), !R || i.length <= 1)
              return i.forEach(function(x) {
                return p2.dispatch(x);
              });
            var j = [], R = i.map(function(x) {
              var D = new B(), z = s.slice();
              return O(l2, D, z).dispatch(x), j = j.concat(z.slice(s.length)), D.read().toString();
            });
            return s = s.concat(j), R.sort(), this._array(R, false);
          }, _date: function(i) {
            return u("date:" + i.toJSON());
          }, _symbol: function(i) {
            return u("symbol:" + i.toString());
          }, _error: function(i) {
            return u("error:" + i.toString());
          }, _boolean: function(i) {
            return u("bool:" + i.toString());
          }, _string: function(i) {
            u("string:" + i.length + ":"), u(i.toString());
          }, _function: function(i) {
            u("fn:"), _(i) ? this.dispatch("[native]") : this.dispatch(i.toString()), l2.respectFunctionNames !== false && this.dispatch("function-name:" + String(i.name)), l2.respectFunctionProperties && this._object(i);
          }, _number: function(i) {
            return u("number:" + i.toString());
          }, _xml: function(i) {
            return u("xml:" + i.toString());
          }, _null: function() {
            return u("Null");
          }, _undefined: function() {
            return u("Undefined");
          }, _regexp: function(i) {
            return u("regex:" + i.toString());
          }, _uint8array: function(i) {
            return u("uint8array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _uint8clampedarray: function(i) {
            return u("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(i));
          }, _int8array: function(i) {
            return u("int8array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _uint16array: function(i) {
            return u("uint16array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _int16array: function(i) {
            return u("int16array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _uint32array: function(i) {
            return u("uint32array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _int32array: function(i) {
            return u("int32array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _float32array: function(i) {
            return u("float32array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _float64array: function(i) {
            return u("float64array:"), this.dispatch(Array.prototype.slice.call(i));
          }, _arraybuffer: function(i) {
            return u("arraybuffer:"), this.dispatch(new Uint8Array(i));
          }, _url: function(i) {
            return u("url:" + i.toString());
          }, _map: function(i) {
            return u("map:"), i = Array.from(i), this._array(i, l2.unorderedSets !== false);
          }, _set: function(i) {
            return u("set:"), i = Array.from(i), this._array(i, l2.unorderedSets !== false);
          }, _file: function(i) {
            return u("file:"), this.dispatch([i.name, i.size, i.type, i.lastModfied]);
          }, _blob: function() {
            if (l2.ignoreUnknown)
              return u("[blob]");
            throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
          }, _domwindow: function() {
            return u("domwindow");
          }, _bigint: function(i) {
            return u("bigint:" + i.toString());
          }, _process: function() {
            return u("process");
          }, _timer: function() {
            return u("timer");
          }, _pipe: function() {
            return u("pipe");
          }, _tcp: function() {
            return u("tcp");
          }, _udp: function() {
            return u("udp");
          }, _tty: function() {
            return u("tty");
          }, _statwatcher: function() {
            return u("statwatcher");
          }, _securecontext: function() {
            return u("securecontext");
          }, _connection: function() {
            return u("connection");
          }, _zlib: function() {
            return u("zlib");
          }, _context: function() {
            return u("context");
          }, _nodescript: function() {
            return u("nodescript");
          }, _httpparser: function() {
            return u("httpparser");
          }, _dataview: function() {
            return u("dataview");
          }, _signal: function() {
            return u("signal");
          }, _fsevent: function() {
            return u("fsevent");
          }, _tlswrap: function() {
            return u("tlswrap");
          } };
        }
        function B() {
          return { buf: "", write: function(l2) {
            this.buf += l2;
          }, end: function(l2) {
            this.buf += l2;
          }, read: function() {
            return this.buf;
          } };
        }
        d.writeToStream = function(l2, g, s) {
          return s === void 0 && (s = g, g = {}), O(g = L(l2, g), s).dispatch(l2);
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
    }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        (function(y) {
          var C = typeof Uint8Array < "u" ? Uint8Array : Array, h = "+".charCodeAt(0), E = "/".charCodeAt(0), L = "0".charCodeAt(0), _ = "a".charCodeAt(0), O = "A".charCodeAt(0), B = "-".charCodeAt(0), l2 = "_".charCodeAt(0);
          function g(s) {
            return s = s.charCodeAt(0), s === h || s === B ? 62 : s === E || s === l2 ? 63 : s < L ? -1 : s < L + 10 ? s - L + 26 + 26 : s < O + 26 ? s - O : s < _ + 26 ? s - _ + 26 : void 0;
          }
          y.toByteArray = function(s) {
            var u, i;
            if (0 < s.length % 4)
              throw new Error("Invalid string. Length must be a multiple of 4");
            var c = s.length, c = s.charAt(c - 2) === "=" ? 2 : s.charAt(c - 1) === "=" ? 1 : 0, p2 = new C(3 * s.length / 4 - c), j = 0 < c ? s.length - 4 : s.length, R = 0;
            function x(D) {
              p2[R++] = D;
            }
            for (u = 0; u < j; u += 4, 0)
              x((16711680 & (i = g(s.charAt(u)) << 18 | g(s.charAt(u + 1)) << 12 | g(s.charAt(u + 2)) << 6 | g(s.charAt(u + 3)))) >> 16), x((65280 & i) >> 8), x(255 & i);
            return c == 2 ? x(255 & (i = g(s.charAt(u)) << 2 | g(s.charAt(u + 1)) >> 4)) : c == 1 && (x((i = g(s.charAt(u)) << 10 | g(s.charAt(u + 1)) << 4 | g(s.charAt(u + 2)) >> 2) >> 8 & 255), x(255 & i)), p2;
          }, y.fromByteArray = function(s) {
            var u, i, c, p2, j = s.length % 3, R = "";
            function x(D) {
              return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(D);
            }
            for (u = 0, c = s.length - j; u < c; u += 3)
              i = (s[u] << 16) + (s[u + 1] << 8) + s[u + 2], R += x((p2 = i) >> 18 & 63) + x(p2 >> 12 & 63) + x(p2 >> 6 & 63) + x(63 & p2);
            switch (j) {
              case 1:
                R = (R += x((i = s[s.length - 1]) >> 2)) + x(i << 4 & 63) + "==";
                break;
              case 2:
                R = (R = (R += x((i = (s[s.length - 2] << 8) + s[s.length - 1]) >> 10)) + x(i >> 4 & 63)) + x(i << 2 & 63) + "=";
            }
            return R;
          };
        })(d === void 0 ? this.base64js = {} : d);
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
    }, { buffer: 3, lYpoI2: 11 }], 3: [function(n2, a, d) {
      (function(m2, b, h, M, S, A, P, T, V) {
        var y = n2("base64-js"), C = n2("ieee754");
        function h(e, r, f2) {
          if (!(this instanceof h))
            return new h(e, r, f2);
          var v, w, k2, $, J = typeof e;
          if (r === "base64" && J == "string")
            for (e = ($ = e).trim ? $.trim() : $.replace(/^\s+|\s+$/g, ""); e.length % 4 != 0; )
              e += "=";
          if (J == "number")
            v = K(e);
          else if (J == "string")
            v = h.byteLength(e, r);
          else {
            if (J != "object")
              throw new Error("First argument needs to be a number, array or string.");
            v = K(e.length);
          }
          if (h._useTypedArrays ? w = h._augment(new Uint8Array(v)) : ((w = this).length = v, w._isBuffer = true), h._useTypedArrays && typeof e.byteLength == "number")
            w._set(e);
          else if (q2($ = e) || h.isBuffer($) || $ && typeof $ == "object" && typeof $.length == "number")
            for (k2 = 0; k2 < v; k2++)
              h.isBuffer(e) ? w[k2] = e.readUInt8(k2) : w[k2] = e[k2];
          else if (J == "string")
            w.write(e, 0, r);
          else if (J == "number" && !h._useTypedArrays && !f2)
            for (k2 = 0; k2 < v; k2++)
              w[k2] = 0;
          return w;
        }
        function E(e, r, f2, v) {
          return h._charsWritten = yt(function(w) {
            for (var k2 = [], $ = 0; $ < w.length; $++)
              k2.push(255 & w.charCodeAt($));
            return k2;
          }(r), e, f2, v);
        }
        function L(e, r, f2, v) {
          return h._charsWritten = yt(function(w) {
            for (var k2, $, J = [], Y = 0; Y < w.length; Y++)
              $ = w.charCodeAt(Y), k2 = $ >> 8, $ = $ % 256, J.push($), J.push(k2);
            return J;
          }(r), e, f2, v);
        }
        function _(e, r, f2) {
          var v = "";
          f2 = Math.min(e.length, f2);
          for (var w = r; w < f2; w++)
            v += String.fromCharCode(e[w]);
          return v;
        }
        function O(e, r, f2, k2) {
          k2 || (U(typeof f2 == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 1 < e.length, "Trying to read beyond buffer length"));
          var w, k2 = e.length;
          if (!(k2 <= r))
            return f2 ? (w = e[r], r + 1 < k2 && (w |= e[r + 1] << 8)) : (w = e[r] << 8, r + 1 < k2 && (w |= e[r + 1])), w;
        }
        function B(e, r, f2, k2) {
          k2 || (U(typeof f2 == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 3 < e.length, "Trying to read beyond buffer length"));
          var w, k2 = e.length;
          if (!(k2 <= r))
            return f2 ? (r + 2 < k2 && (w = e[r + 2] << 16), r + 1 < k2 && (w |= e[r + 1] << 8), w |= e[r], r + 3 < k2 && (w += e[r + 3] << 24 >>> 0)) : (r + 1 < k2 && (w = e[r + 1] << 16), r + 2 < k2 && (w |= e[r + 2] << 8), r + 3 < k2 && (w |= e[r + 3]), w += e[r] << 24 >>> 0), w;
        }
        function l2(e, r, f2, v) {
          if (v || (U(typeof f2 == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 1 < e.length, "Trying to read beyond buffer length")), !(e.length <= r))
            return v = O(e, r, f2, true), 32768 & v ? -1 * (65535 - v + 1) : v;
        }
        function g(e, r, f2, v) {
          if (v || (U(typeof f2 == "boolean", "missing or invalid endian"), U(r != null, "missing offset"), U(r + 3 < e.length, "Trying to read beyond buffer length")), !(e.length <= r))
            return v = B(e, r, f2, true), 2147483648 & v ? -1 * (4294967295 - v + 1) : v;
        }
        function s(e, r, f2, v) {
          return v || (U(typeof f2 == "boolean", "missing or invalid endian"), U(r + 3 < e.length, "Trying to read beyond buffer length")), C.read(e, r, f2, 23, 4);
        }
        function u(e, r, f2, v) {
          return v || (U(typeof f2 == "boolean", "missing or invalid endian"), U(r + 7 < e.length, "Trying to read beyond buffer length")), C.read(e, r, f2, 52, 8);
        }
        function i(e, r, f2, v, w) {
          if (w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f2 != null, "missing offset"), U(f2 + 1 < e.length, "trying to write beyond buffer length"), At(r, 65535)), w = e.length, !(w <= f2))
            for (var k2 = 0, $ = Math.min(w - f2, 2); k2 < $; k2++)
              e[f2 + k2] = (r & 255 << 8 * (v ? k2 : 1 - k2)) >>> 8 * (v ? k2 : 1 - k2);
        }
        function c(e, r, f2, v, w) {
          if (w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f2 != null, "missing offset"), U(f2 + 3 < e.length, "trying to write beyond buffer length"), At(r, 4294967295)), w = e.length, !(w <= f2))
            for (var k2 = 0, $ = Math.min(w - f2, 4); k2 < $; k2++)
              e[f2 + k2] = r >>> 8 * (v ? k2 : 3 - k2) & 255;
        }
        function p2(e, r, f2, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f2 != null, "missing offset"), U(f2 + 1 < e.length, "Trying to write beyond buffer length"), Lt(r, 32767, -32768)), e.length <= f2 || i(e, 0 <= r ? r : 65535 + r + 1, f2, v, w);
        }
        function j(e, r, f2, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f2 != null, "missing offset"), U(f2 + 3 < e.length, "Trying to write beyond buffer length"), Lt(r, 2147483647, -2147483648)), e.length <= f2 || c(e, 0 <= r ? r : 4294967295 + r + 1, f2, v, w);
        }
        function R(e, r, f2, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f2 != null, "missing offset"), U(f2 + 3 < e.length, "Trying to write beyond buffer length"), Nt(r, 34028234663852886e22, -34028234663852886e22)), e.length <= f2 || C.write(e, r, f2, v, 23, 4);
        }
        function x(e, r, f2, v, w) {
          w || (U(r != null, "missing value"), U(typeof v == "boolean", "missing or invalid endian"), U(f2 != null, "missing offset"), U(f2 + 7 < e.length, "Trying to write beyond buffer length"), Nt(r, 17976931348623157e292, -17976931348623157e292)), e.length <= f2 || C.write(e, r, f2, v, 52, 8);
        }
        d.Buffer = h, d.SlowBuffer = h, d.INSPECT_MAX_BYTES = 50, h.poolSize = 8192, h._useTypedArrays = function() {
          try {
            var e = new ArrayBuffer(0), r = new Uint8Array(e);
            return r.foo = function() {
              return 42;
            }, r.foo() === 42 && typeof r.subarray == "function";
          } catch {
            return false;
          }
        }(), h.isEncoding = function(e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "raw":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return true;
            default:
              return false;
          }
        }, h.isBuffer = function(e) {
          return !(e == null || !e._isBuffer);
        }, h.byteLength = function(e, r) {
          var f2;
          switch (e += "", r || "utf8") {
            case "hex":
              f2 = e.length / 2;
              break;
            case "utf8":
            case "utf-8":
              f2 = ot(e).length;
              break;
            case "ascii":
            case "binary":
            case "raw":
              f2 = e.length;
              break;
            case "base64":
              f2 = xt(e).length;
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              f2 = 2 * e.length;
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return f2;
        }, h.concat = function(e, r) {
          if (U(q2(e), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), e.length === 0)
            return new h(0);
          if (e.length === 1)
            return e[0];
          if (typeof r != "number")
            for (w = r = 0; w < e.length; w++)
              r += e[w].length;
          for (var f2 = new h(r), v = 0, w = 0; w < e.length; w++) {
            var k2 = e[w];
            k2.copy(f2, v), v += k2.length;
          }
          return f2;
        }, h.prototype.write = function(e, r, f2, v) {
          isFinite(r) ? isFinite(f2) || (v = f2, f2 = void 0) : (Y = v, v = r, r = f2, f2 = Y), r = Number(r) || 0;
          var w, k2, $, J, Y = this.length - r;
          switch ((!f2 || Y < (f2 = Number(f2))) && (f2 = Y), v = String(v || "utf8").toLowerCase()) {
            case "hex":
              w = function(et, Q, Z, H) {
                Z = Number(Z) || 0;
                var W = et.length - Z;
                (!H || W < (H = Number(H))) && (H = W), U((W = Q.length) % 2 == 0, "Invalid hex string"), W / 2 < H && (H = W / 2);
                for (var ht = 0; ht < H; ht++) {
                  var Vt = parseInt(Q.substr(2 * ht, 2), 16);
                  U(!isNaN(Vt), "Invalid hex string"), et[Z + ht] = Vt;
                }
                return h._charsWritten = 2 * ht, ht;
              }(this, e, r, f2);
              break;
            case "utf8":
            case "utf-8":
              k2 = this, $ = r, J = f2, w = h._charsWritten = yt(ot(e), k2, $, J);
              break;
            case "ascii":
            case "binary":
              w = E(this, e, r, f2);
              break;
            case "base64":
              k2 = this, $ = r, J = f2, w = h._charsWritten = yt(xt(e), k2, $, J);
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              w = L(this, e, r, f2);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return w;
        }, h.prototype.toString = function(e, r, f2) {
          var v, w, k2, $, J = this;
          if (e = String(e || "utf8").toLowerCase(), r = Number(r) || 0, (f2 = f2 !== void 0 ? Number(f2) : J.length) === r)
            return "";
          switch (e) {
            case "hex":
              v = function(Y, et, Q) {
                var Z = Y.length;
                (!et || et < 0) && (et = 0), (!Q || Q < 0 || Z < Q) && (Q = Z);
                for (var H = "", W = et; W < Q; W++)
                  H += F(Y[W]);
                return H;
              }(J, r, f2);
              break;
            case "utf8":
            case "utf-8":
              v = function(Y, et, Q) {
                var Z = "", H = "";
                Q = Math.min(Y.length, Q);
                for (var W = et; W < Q; W++)
                  Y[W] <= 127 ? (Z += Tt(H) + String.fromCharCode(Y[W]), H = "") : H += "%" + Y[W].toString(16);
                return Z + Tt(H);
              }(J, r, f2);
              break;
            case "ascii":
            case "binary":
              v = _(J, r, f2);
              break;
            case "base64":
              w = J, $ = f2, v = (k2 = r) === 0 && $ === w.length ? y.fromByteArray(w) : y.fromByteArray(w.slice(k2, $));
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              v = function(Y, et, Q) {
                for (var Z = Y.slice(et, Q), H = "", W = 0; W < Z.length; W += 2)
                  H += String.fromCharCode(Z[W] + 256 * Z[W + 1]);
                return H;
              }(J, r, f2);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return v;
        }, h.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        }, h.prototype.copy = function(e, r, f2, v) {
          if (r = r || 0, (v = v || v === 0 ? v : this.length) !== (f2 = f2 || 0) && e.length !== 0 && this.length !== 0) {
            U(f2 <= v, "sourceEnd < sourceStart"), U(0 <= r && r < e.length, "targetStart out of bounds"), U(0 <= f2 && f2 < this.length, "sourceStart out of bounds"), U(0 <= v && v <= this.length, "sourceEnd out of bounds"), v > this.length && (v = this.length);
            var w = (v = e.length - r < v - f2 ? e.length - r + f2 : v) - f2;
            if (w < 100 || !h._useTypedArrays)
              for (var k2 = 0; k2 < w; k2++)
                e[k2 + r] = this[k2 + f2];
            else
              e._set(this.subarray(f2, f2 + w), r);
          }
        }, h.prototype.slice = function(e, r) {
          var f2 = this.length;
          if (e = z(e, f2, 0), r = z(r, f2, f2), h._useTypedArrays)
            return h._augment(this.subarray(e, r));
          for (var v = r - e, w = new h(v, void 0, true), k2 = 0; k2 < v; k2++)
            w[k2] = this[k2 + e];
          return w;
        }, h.prototype.get = function(e) {
          return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e);
        }, h.prototype.set = function(e, r) {
          return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e, r);
        }, h.prototype.readUInt8 = function(e, r) {
          if (r || (U(e != null, "missing offset"), U(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length))
            return this[e];
        }, h.prototype.readUInt16LE = function(e, r) {
          return O(this, e, true, r);
        }, h.prototype.readUInt16BE = function(e, r) {
          return O(this, e, false, r);
        }, h.prototype.readUInt32LE = function(e, r) {
          return B(this, e, true, r);
        }, h.prototype.readUInt32BE = function(e, r) {
          return B(this, e, false, r);
        }, h.prototype.readInt8 = function(e, r) {
          if (r || (U(e != null, "missing offset"), U(e < this.length, "Trying to read beyond buffer length")), !(e >= this.length))
            return 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, h.prototype.readInt16LE = function(e, r) {
          return l2(this, e, true, r);
        }, h.prototype.readInt16BE = function(e, r) {
          return l2(this, e, false, r);
        }, h.prototype.readInt32LE = function(e, r) {
          return g(this, e, true, r);
        }, h.prototype.readInt32BE = function(e, r) {
          return g(this, e, false, r);
        }, h.prototype.readFloatLE = function(e, r) {
          return s(this, e, true, r);
        }, h.prototype.readFloatBE = function(e, r) {
          return s(this, e, false, r);
        }, h.prototype.readDoubleLE = function(e, r) {
          return u(this, e, true, r);
        }, h.prototype.readDoubleBE = function(e, r) {
          return u(this, e, false, r);
        }, h.prototype.writeUInt8 = function(e, r, f2) {
          f2 || (U(e != null, "missing value"), U(r != null, "missing offset"), U(r < this.length, "trying to write beyond buffer length"), At(e, 255)), r >= this.length || (this[r] = e);
        }, h.prototype.writeUInt16LE = function(e, r, f2) {
          i(this, e, r, true, f2);
        }, h.prototype.writeUInt16BE = function(e, r, f2) {
          i(this, e, r, false, f2);
        }, h.prototype.writeUInt32LE = function(e, r, f2) {
          c(this, e, r, true, f2);
        }, h.prototype.writeUInt32BE = function(e, r, f2) {
          c(this, e, r, false, f2);
        }, h.prototype.writeInt8 = function(e, r, f2) {
          f2 || (U(e != null, "missing value"), U(r != null, "missing offset"), U(r < this.length, "Trying to write beyond buffer length"), Lt(e, 127, -128)), r >= this.length || (0 <= e ? this.writeUInt8(e, r, f2) : this.writeUInt8(255 + e + 1, r, f2));
        }, h.prototype.writeInt16LE = function(e, r, f2) {
          p2(this, e, r, true, f2);
        }, h.prototype.writeInt16BE = function(e, r, f2) {
          p2(this, e, r, false, f2);
        }, h.prototype.writeInt32LE = function(e, r, f2) {
          j(this, e, r, true, f2);
        }, h.prototype.writeInt32BE = function(e, r, f2) {
          j(this, e, r, false, f2);
        }, h.prototype.writeFloatLE = function(e, r, f2) {
          R(this, e, r, true, f2);
        }, h.prototype.writeFloatBE = function(e, r, f2) {
          R(this, e, r, false, f2);
        }, h.prototype.writeDoubleLE = function(e, r, f2) {
          x(this, e, r, true, f2);
        }, h.prototype.writeDoubleBE = function(e, r, f2) {
          x(this, e, r, false, f2);
        }, h.prototype.fill = function(e, r, f2) {
          if (r = r || 0, f2 = f2 || this.length, U(typeof (e = typeof (e = e || 0) == "string" ? e.charCodeAt(0) : e) == "number" && !isNaN(e), "value is not a number"), U(r <= f2, "end < start"), f2 !== r && this.length !== 0) {
            U(0 <= r && r < this.length, "start out of bounds"), U(0 <= f2 && f2 <= this.length, "end out of bounds");
            for (var v = r; v < f2; v++)
              this[v] = e;
          }
        }, h.prototype.inspect = function() {
          for (var e = [], r = this.length, f2 = 0; f2 < r; f2++)
            if (e[f2] = F(this[f2]), f2 === d.INSPECT_MAX_BYTES) {
              e[f2 + 1] = "...";
              break;
            }
          return "<Buffer " + e.join(" ") + ">";
        }, h.prototype.toArrayBuffer = function() {
          if (typeof Uint8Array > "u")
            throw new Error("Buffer.toArrayBuffer not supported in this browser");
          if (h._useTypedArrays)
            return new h(this).buffer;
          for (var e = new Uint8Array(this.length), r = 0, f2 = e.length; r < f2; r += 1)
            e[r] = this[r];
          return e.buffer;
        };
        var D = h.prototype;
        function z(e, r, f2) {
          return typeof e != "number" ? f2 : r <= (e = ~~e) ? r : 0 <= e || 0 <= (e += r) ? e : 0;
        }
        function K(e) {
          return (e = ~~Math.ceil(+e)) < 0 ? 0 : e;
        }
        function q2(e) {
          return (Array.isArray || function(r) {
            return Object.prototype.toString.call(r) === "[object Array]";
          })(e);
        }
        function F(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }
        function ot(e) {
          for (var r = [], f2 = 0; f2 < e.length; f2++) {
            var v = e.charCodeAt(f2);
            if (v <= 127)
              r.push(e.charCodeAt(f2));
            else
              for (var w = f2, k2 = (55296 <= v && v <= 57343 && f2++, encodeURIComponent(e.slice(w, f2 + 1)).substr(1).split("%")), $ = 0; $ < k2.length; $++)
                r.push(parseInt(k2[$], 16));
          }
          return r;
        }
        function xt(e) {
          return y.toByteArray(e);
        }
        function yt(e, r, f2, v) {
          for (var w = 0; w < v && !(w + f2 >= r.length || w >= e.length); w++)
            r[w + f2] = e[w];
          return w;
        }
        function Tt(e) {
          try {
            return decodeURIComponent(e);
          } catch {
            return String.fromCharCode(65533);
          }
        }
        function At(e, r) {
          U(typeof e == "number", "cannot write a non-number as a number"), U(0 <= e, "specified a negative value for writing an unsigned value"), U(e <= r, "value is larger than maximum value for type"), U(Math.floor(e) === e, "value has a fractional component");
        }
        function Lt(e, r, f2) {
          U(typeof e == "number", "cannot write a non-number as a number"), U(e <= r, "value larger than maximum allowed value"), U(f2 <= e, "value smaller than minimum allowed value"), U(Math.floor(e) === e, "value has a fractional component");
        }
        function Nt(e, r, f2) {
          U(typeof e == "number", "cannot write a non-number as a number"), U(e <= r, "value larger than maximum allowed value"), U(f2 <= e, "value smaller than minimum allowed value");
        }
        function U(e, r) {
          if (!e)
            throw new Error(r || "Failed assertion");
        }
        h._augment = function(e) {
          return e._isBuffer = true, e._get = e.get, e._set = e.set, e.get = D.get, e.set = D.set, e.write = D.write, e.toString = D.toString, e.toLocaleString = D.toString, e.toJSON = D.toJSON, e.copy = D.copy, e.slice = D.slice, e.readUInt8 = D.readUInt8, e.readUInt16LE = D.readUInt16LE, e.readUInt16BE = D.readUInt16BE, e.readUInt32LE = D.readUInt32LE, e.readUInt32BE = D.readUInt32BE, e.readInt8 = D.readInt8, e.readInt16LE = D.readInt16LE, e.readInt16BE = D.readInt16BE, e.readInt32LE = D.readInt32LE, e.readInt32BE = D.readInt32BE, e.readFloatLE = D.readFloatLE, e.readFloatBE = D.readFloatBE, e.readDoubleLE = D.readDoubleLE, e.readDoubleBE = D.readDoubleBE, e.writeUInt8 = D.writeUInt8, e.writeUInt16LE = D.writeUInt16LE, e.writeUInt16BE = D.writeUInt16BE, e.writeUInt32LE = D.writeUInt32LE, e.writeUInt32BE = D.writeUInt32BE, e.writeInt8 = D.writeInt8, e.writeInt16LE = D.writeInt16LE, e.writeInt16BE = D.writeInt16BE, e.writeInt32LE = D.writeInt32LE, e.writeInt32BE = D.writeInt32BE, e.writeFloatLE = D.writeFloatLE, e.writeFloatBE = D.writeFloatBE, e.writeDoubleLE = D.writeDoubleLE, e.writeDoubleBE = D.writeDoubleBE, e.fill = D.fill, e.inspect = D.inspect, e.toArrayBuffer = D.toArrayBuffer, e;
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
    }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n2, a, d) {
      (function(m2, b, y, M, S, A, P, T, V) {
        var y = n2("buffer").Buffer, C = 4, h = new y(C);
        h.fill(0), a.exports = { hash: function(E, L, _, O) {
          for (var B = L(function(i, c) {
            i.length % C != 0 && (p2 = i.length + (C - i.length % C), i = y.concat([i, h], p2));
            for (var p2, j = [], R = c ? i.readInt32BE : i.readInt32LE, x = 0; x < i.length; x += C)
              j.push(R.call(i, x));
            return j;
          }(E = y.isBuffer(E) ? E : new y(E), O), 8 * E.length), L = O, l2 = new y(_), g = L ? l2.writeInt32BE : l2.writeInt32LE, s = 0; s < B.length; s++)
            g.call(l2, B[s], 4 * s, true);
          return l2;
        } };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 5: [function(n2, a, d) {
      (function(m2, b, y, M, S, A, P, T, V) {
        var y = n2("buffer").Buffer, C = n2("./sha"), h = n2("./sha256"), E = n2("./rng"), L = { sha1: C, sha256: h, md5: n2("./md5") }, _ = 64, O = new y(_);
        function B(i, c) {
          var p2 = L[i = i || "sha1"], j = [];
          return p2 || l2("algorithm:", i, "is not yet supported"), { update: function(R) {
            return y.isBuffer(R) || (R = new y(R)), j.push(R), R.length, this;
          }, digest: function(R) {
            var x = y.concat(j), x = c ? function(D, z, K) {
              y.isBuffer(z) || (z = new y(z)), y.isBuffer(K) || (K = new y(K)), z.length > _ ? z = D(z) : z.length < _ && (z = y.concat([z, O], _));
              for (var q2 = new y(_), F = new y(_), ot = 0; ot < _; ot++)
                q2[ot] = 54 ^ z[ot], F[ot] = 92 ^ z[ot];
              return K = D(y.concat([q2, K])), D(y.concat([F, K]));
            }(p2, c, x) : p2(x);
            return j = null, R ? x.toString(R) : x;
          } };
        }
        function l2() {
          var i = [].slice.call(arguments).join(" ");
          throw new Error([i, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
        }
        O.fill(0), d.createHash = function(i) {
          return B(i);
        }, d.createHmac = B, d.randomBytes = function(i, c) {
          if (!c || !c.call)
            return new y(E(i));
          try {
            c.call(this, void 0, new y(E(i)));
          } catch (p2) {
            c(p2);
          }
        };
        var g, s = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], u = function(i) {
          d[i] = function() {
            l2("sorry,", i, "is not implemented yet");
          };
        };
        for (g in s)
          u(s[g]);
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        var y = n2("./helpers");
        function C(l2, g) {
          l2[g >> 5] |= 128 << g % 32, l2[14 + (g + 64 >>> 9 << 4)] = g;
          for (var s = 1732584193, u = -271733879, i = -1732584194, c = 271733878, p2 = 0; p2 < l2.length; p2 += 16) {
            var j = s, R = u, x = i, D = c, s = E(s, u, i, c, l2[p2 + 0], 7, -680876936), c = E(c, s, u, i, l2[p2 + 1], 12, -389564586), i = E(i, c, s, u, l2[p2 + 2], 17, 606105819), u = E(u, i, c, s, l2[p2 + 3], 22, -1044525330);
            s = E(s, u, i, c, l2[p2 + 4], 7, -176418897), c = E(c, s, u, i, l2[p2 + 5], 12, 1200080426), i = E(i, c, s, u, l2[p2 + 6], 17, -1473231341), u = E(u, i, c, s, l2[p2 + 7], 22, -45705983), s = E(s, u, i, c, l2[p2 + 8], 7, 1770035416), c = E(c, s, u, i, l2[p2 + 9], 12, -1958414417), i = E(i, c, s, u, l2[p2 + 10], 17, -42063), u = E(u, i, c, s, l2[p2 + 11], 22, -1990404162), s = E(s, u, i, c, l2[p2 + 12], 7, 1804603682), c = E(c, s, u, i, l2[p2 + 13], 12, -40341101), i = E(i, c, s, u, l2[p2 + 14], 17, -1502002290), s = L(s, u = E(u, i, c, s, l2[p2 + 15], 22, 1236535329), i, c, l2[p2 + 1], 5, -165796510), c = L(c, s, u, i, l2[p2 + 6], 9, -1069501632), i = L(i, c, s, u, l2[p2 + 11], 14, 643717713), u = L(u, i, c, s, l2[p2 + 0], 20, -373897302), s = L(s, u, i, c, l2[p2 + 5], 5, -701558691), c = L(c, s, u, i, l2[p2 + 10], 9, 38016083), i = L(i, c, s, u, l2[p2 + 15], 14, -660478335), u = L(u, i, c, s, l2[p2 + 4], 20, -405537848), s = L(s, u, i, c, l2[p2 + 9], 5, 568446438), c = L(c, s, u, i, l2[p2 + 14], 9, -1019803690), i = L(i, c, s, u, l2[p2 + 3], 14, -187363961), u = L(u, i, c, s, l2[p2 + 8], 20, 1163531501), s = L(s, u, i, c, l2[p2 + 13], 5, -1444681467), c = L(c, s, u, i, l2[p2 + 2], 9, -51403784), i = L(i, c, s, u, l2[p2 + 7], 14, 1735328473), s = _(s, u = L(u, i, c, s, l2[p2 + 12], 20, -1926607734), i, c, l2[p2 + 5], 4, -378558), c = _(c, s, u, i, l2[p2 + 8], 11, -2022574463), i = _(i, c, s, u, l2[p2 + 11], 16, 1839030562), u = _(u, i, c, s, l2[p2 + 14], 23, -35309556), s = _(s, u, i, c, l2[p2 + 1], 4, -1530992060), c = _(c, s, u, i, l2[p2 + 4], 11, 1272893353), i = _(i, c, s, u, l2[p2 + 7], 16, -155497632), u = _(u, i, c, s, l2[p2 + 10], 23, -1094730640), s = _(s, u, i, c, l2[p2 + 13], 4, 681279174), c = _(c, s, u, i, l2[p2 + 0], 11, -358537222), i = _(i, c, s, u, l2[p2 + 3], 16, -722521979), u = _(u, i, c, s, l2[p2 + 6], 23, 76029189), s = _(s, u, i, c, l2[p2 + 9], 4, -640364487), c = _(c, s, u, i, l2[p2 + 12], 11, -421815835), i = _(i, c, s, u, l2[p2 + 15], 16, 530742520), s = O(s, u = _(u, i, c, s, l2[p2 + 2], 23, -995338651), i, c, l2[p2 + 0], 6, -198630844), c = O(c, s, u, i, l2[p2 + 7], 10, 1126891415), i = O(i, c, s, u, l2[p2 + 14], 15, -1416354905), u = O(u, i, c, s, l2[p2 + 5], 21, -57434055), s = O(s, u, i, c, l2[p2 + 12], 6, 1700485571), c = O(c, s, u, i, l2[p2 + 3], 10, -1894986606), i = O(i, c, s, u, l2[p2 + 10], 15, -1051523), u = O(u, i, c, s, l2[p2 + 1], 21, -2054922799), s = O(s, u, i, c, l2[p2 + 8], 6, 1873313359), c = O(c, s, u, i, l2[p2 + 15], 10, -30611744), i = O(i, c, s, u, l2[p2 + 6], 15, -1560198380), u = O(u, i, c, s, l2[p2 + 13], 21, 1309151649), s = O(s, u, i, c, l2[p2 + 4], 6, -145523070), c = O(c, s, u, i, l2[p2 + 11], 10, -1120210379), i = O(i, c, s, u, l2[p2 + 2], 15, 718787259), u = O(u, i, c, s, l2[p2 + 9], 21, -343485551), s = B(s, j), u = B(u, R), i = B(i, x), c = B(c, D);
          }
          return Array(s, u, i, c);
        }
        function h(l2, g, s, u, i, c) {
          return B((g = B(B(g, l2), B(u, c))) << i | g >>> 32 - i, s);
        }
        function E(l2, g, s, u, i, c, p2) {
          return h(g & s | ~g & u, l2, g, i, c, p2);
        }
        function L(l2, g, s, u, i, c, p2) {
          return h(g & u | s & ~u, l2, g, i, c, p2);
        }
        function _(l2, g, s, u, i, c, p2) {
          return h(g ^ s ^ u, l2, g, i, c, p2);
        }
        function O(l2, g, s, u, i, c, p2) {
          return h(s ^ (g | ~u), l2, g, i, c, p2);
        }
        function B(l2, g) {
          var s = (65535 & l2) + (65535 & g);
          return (l2 >> 16) + (g >> 16) + (s >> 16) << 16 | 65535 & s;
        }
        a.exports = function(l2) {
          return y.hash(l2, C, 16);
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        a.exports = function(y) {
          for (var C, h = new Array(y), E = 0; E < y; E++)
            !(3 & E) && (C = 4294967296 * Math.random()), h[E] = C >>> ((3 & E) << 3) & 255;
          return h;
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 8: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        var y = n2("./helpers");
        function C(L, _) {
          L[_ >> 5] |= 128 << 24 - _ % 32, L[15 + (_ + 64 >> 9 << 4)] = _;
          for (var O, B, l2, g = Array(80), s = 1732584193, u = -271733879, i = -1732584194, c = 271733878, p2 = -1009589776, j = 0; j < L.length; j += 16) {
            for (var R = s, x = u, D = i, z = c, K = p2, q2 = 0; q2 < 80; q2++) {
              g[q2] = q2 < 16 ? L[j + q2] : E(g[q2 - 3] ^ g[q2 - 8] ^ g[q2 - 14] ^ g[q2 - 16], 1);
              var F = h(h(E(s, 5), (F = u, B = i, l2 = c, (O = q2) < 20 ? F & B | ~F & l2 : !(O < 40) && O < 60 ? F & B | F & l2 | B & l2 : F ^ B ^ l2)), h(h(p2, g[q2]), (O = q2) < 20 ? 1518500249 : O < 40 ? 1859775393 : O < 60 ? -1894007588 : -899497514)), p2 = c, c = i, i = E(u, 30), u = s, s = F;
            }
            s = h(s, R), u = h(u, x), i = h(i, D), c = h(c, z), p2 = h(p2, K);
          }
          return Array(s, u, i, c, p2);
        }
        function h(L, _) {
          var O = (65535 & L) + (65535 & _);
          return (L >> 16) + (_ >> 16) + (O >> 16) << 16 | 65535 & O;
        }
        function E(L, _) {
          return L << _ | L >>> 32 - _;
        }
        a.exports = function(L) {
          return y.hash(L, C, 20, true);
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        function y(_, O) {
          var B = (65535 & _) + (65535 & O);
          return (_ >> 16) + (O >> 16) + (B >> 16) << 16 | 65535 & B;
        }
        function C(_, O) {
          var B, l2 = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), g = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), s = new Array(64);
          _[O >> 5] |= 128 << 24 - O % 32, _[15 + (O + 64 >> 9 << 4)] = O;
          for (var u, i, c = 0; c < _.length; c += 16) {
            for (var p2 = g[0], j = g[1], R = g[2], x = g[3], D = g[4], z = g[5], K = g[6], q2 = g[7], F = 0; F < 64; F++)
              s[F] = F < 16 ? _[F + c] : y(y(y((i = s[F - 2], E(i, 17) ^ E(i, 19) ^ L(i, 10)), s[F - 7]), (i = s[F - 15], E(i, 7) ^ E(i, 18) ^ L(i, 3))), s[F - 16]), B = y(y(y(y(q2, E(i = D, 6) ^ E(i, 11) ^ E(i, 25)), D & z ^ ~D & K), l2[F]), s[F]), u = y(E(u = p2, 2) ^ E(u, 13) ^ E(u, 22), p2 & j ^ p2 & R ^ j & R), q2 = K, K = z, z = D, D = y(x, B), x = R, R = j, j = p2, p2 = y(B, u);
            g[0] = y(p2, g[0]), g[1] = y(j, g[1]), g[2] = y(R, g[2]), g[3] = y(x, g[3]), g[4] = y(D, g[4]), g[5] = y(z, g[5]), g[6] = y(K, g[6]), g[7] = y(q2, g[7]);
          }
          return g;
        }
        var h = n2("./helpers"), E = function(_, O) {
          return _ >>> O | _ << 32 - O;
        }, L = function(_, O) {
          return _ >>> O;
        };
        a.exports = function(_) {
          return h.hash(_, C, 32, true);
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        d.read = function(y, C, h, E, c) {
          var _, O, B = 8 * c - E - 1, l2 = (1 << B) - 1, g = l2 >> 1, s = -7, u = h ? c - 1 : 0, i = h ? -1 : 1, c = y[C + u];
          for (u += i, _ = c & (1 << -s) - 1, c >>= -s, s += B; 0 < s; _ = 256 * _ + y[C + u], u += i, s -= 8)
            ;
          for (O = _ & (1 << -s) - 1, _ >>= -s, s += E; 0 < s; O = 256 * O + y[C + u], u += i, s -= 8)
            ;
          if (_ === 0)
            _ = 1 - g;
          else {
            if (_ === l2)
              return O ? NaN : 1 / 0 * (c ? -1 : 1);
            O += Math.pow(2, E), _ -= g;
          }
          return (c ? -1 : 1) * O * Math.pow(2, _ - E);
        }, d.write = function(y, C, h, E, L, p2) {
          var O, B, l2 = 8 * p2 - L - 1, g = (1 << l2) - 1, s = g >> 1, u = L === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, i = E ? 0 : p2 - 1, c = E ? 1 : -1, p2 = C < 0 || C === 0 && 1 / C < 0 ? 1 : 0;
          for (C = Math.abs(C), isNaN(C) || C === 1 / 0 ? (B = isNaN(C) ? 1 : 0, O = g) : (O = Math.floor(Math.log(C) / Math.LN2), C * (E = Math.pow(2, -O)) < 1 && (O--, E *= 2), 2 <= (C += 1 <= O + s ? u / E : u * Math.pow(2, 1 - s)) * E && (O++, E /= 2), g <= O + s ? (B = 0, O = g) : 1 <= O + s ? (B = (C * E - 1) * Math.pow(2, L), O += s) : (B = C * Math.pow(2, s - 1) * Math.pow(2, L), O = 0)); 8 <= L; y[h + i] = 255 & B, i += c, B /= 256, L -= 8)
            ;
          for (O = O << L | B, l2 += L; 0 < l2; y[h + i] = 255 & O, i += c, O /= 256, l2 -= 8)
            ;
          y[h + i - c] |= 128 * p2;
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
    }, { buffer: 3, lYpoI2: 11 }], 11: [function(n2, a, d) {
      (function(m2, b, I, M, S, A, P, T, V) {
        var y, C, h;
        function E() {
        }
        (m2 = a.exports = {}).nextTick = (C = typeof window < "u" && window.setImmediate, h = typeof window < "u" && window.postMessage && window.addEventListener, C ? function(L) {
          return window.setImmediate(L);
        } : h ? (y = [], window.addEventListener("message", function(L) {
          var _ = L.source;
          _ !== window && _ !== null || L.data !== "process-tick" || (L.stopPropagation(), 0 < y.length && y.shift()());
        }, true), function(L) {
          y.push(L), window.postMessage("process-tick", "*");
        }) : function(L) {
          setTimeout(L, 0);
        }), m2.title = "browser", m2.browser = true, m2.env = {}, m2.argv = [], m2.on = E, m2.addListener = E, m2.once = E, m2.off = E, m2.removeListener = E, m2.removeAllListeners = E, m2.emit = E, m2.binding = function(L) {
          throw new Error("process.binding is not supported");
        }, m2.cwd = function() {
          return "/";
        }, m2.chdir = function(L) {
          throw new Error("process.chdir is not supported");
        };
      }).call(this, n2("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n2("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
    }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
  });
})(Xt);
var $t = Xt.exports, it;
(function(o) {
  o.V0_3 = "0.3", o.V0_4 = "0.4", o.V0_5 = "0.5", o.V0_6 = "0.6";
})(it || (it = {}));
var st;
(function(o) {
  o.V0_2 = "0.2", o.V0_3 = "0.3";
})(st || (st = {}));
const Ft = Object.keys(it);
it.V0_6;
const zt = Object.keys(st), pt = st.V0_3;
var N;
(function(o) {
  o.Inputs = "inputs", o.Outputs = "outputs", o.State = "state", o.Definition = "definition", o.DefinitionUpdateRequest = "definitionupdaterequest", o.Error = "error", o.UrlHashUpdate = "urlhashupdate", o.Message = "Message";
})(N || (N = {}));
var X;
(function(o) {
  o.InputsUpdate = "InputsUpdate", o.OutputsUpdate = "OutputsUpdate", o.SetupIframeClientRequest = "SetupIframeClientRequest", o.SetupIframeServerResponseAck = "SetupIframeServerResponseAck", o.PluginRequest = "SetupIframeServerPluginRequestResponseAck", o.HashParamsUpdate = "HashParamsUpdate";
})(X || (X = {}));
var at;
(function(o) {
  o.InputsUpdate = "InputsUpdate", o.MessageAck = "MessageAck", o.SetupIframeServerResponse = "SetupIframeServerResponse";
})(at || (at = {}));
var kt;
(function(o) {
  o.State = "metapage/state";
})(kt || (kt = {}));
const rt = "metapage/definition", ft = "metapage/state", Qt = zt[zt.length - 1], ae = Ft[Ft.length - 1];
var lt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", dt = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var _t = 0; _t < lt.length; _t++)
  dt[lt.charCodeAt(_t)] = _t;
var wt = function(o) {
  var t = new Uint8Array(o), n2, a = t.length, d = "";
  for (n2 = 0; n2 < a; n2 += 3)
    d += lt[t[n2] >> 2], d += lt[(t[n2] & 3) << 4 | t[n2 + 1] >> 4], d += lt[(t[n2 + 1] & 15) << 2 | t[n2 + 2] >> 6], d += lt[t[n2 + 2] & 63];
  return a % 3 === 2 ? d = d.substring(0, d.length - 1) + "=" : a % 3 === 1 && (d = d.substring(0, d.length - 2) + "=="), d;
}, vt = function(o) {
  var t = o.length * 0.75, n2 = o.length, a, d = 0, m2, b, I, M;
  o[o.length - 1] === "=" && (t--, o[o.length - 2] === "=" && t--);
  var S = new ArrayBuffer(t), A = new Uint8Array(S);
  for (a = 0; a < n2; a += 4)
    m2 = dt[o.charCodeAt(a)], b = dt[o.charCodeAt(a + 1)], I = dt[o.charCodeAt(a + 2)], M = dt[o.charCodeAt(a + 3)], A[d++] = m2 << 2 | b >> 4, A[d++] = (b & 15) << 4 | I >> 2, A[d++] = (I & 3) << 6 | M & 63;
  return S;
};
const Ot = async (o) => {
  for (const t of Object.keys(o)) {
    const n2 = await ue(o[t]);
    o[t] = n2;
  }
  return o;
}, gt = async (o) => {
  for (const t of Object.keys(o)) {
    const n2 = await fe(o[t]);
    o[t] = n2;
  }
  return o;
}, ue = async (o) => {
  if (o instanceof Int8Array || o instanceof Uint8Array || o instanceof Uint8ClampedArray || o instanceof Int16Array || o instanceof Uint16Array || o instanceof Int32Array || o instanceof Uint32Array || o instanceof Float32Array || o instanceof Float64Array) {
    const t = o, n2 = {
      _s: true,
      _c: o.constructor.name,
      value: wt(t.buffer),
      byteLength: t.byteLength,
      byteOffset: t.byteOffset,
      size: t.byteLength
    };
    return Promise.resolve(n2);
  } else if (o instanceof File) {
    const t = o, n2 = await t.arrayBuffer();
    return {
      _s: true,
      _c: File.name,
      value: wt(n2),
      name: t.name,
      fileType: t.type,
      lastModified: t.lastModified,
      size: n2.byteLength
    };
  } else if (o instanceof Blob) {
    const t = o, n2 = await t.arrayBuffer();
    return {
      _s: true,
      _c: Blob.name,
      value: wt(n2),
      fileType: t.type,
      size: n2.byteLength
    };
  } else if (o instanceof ArrayBuffer) {
    const t = o, n2 = {
      _s: true,
      _c: ArrayBuffer.name,
      value: wt(t),
      size: t.byteLength
    };
    return Promise.resolve(n2);
  }
  return Promise.resolve(o);
}, fe = (o) => {
  if (!(o && typeof o == "object" && o._s === true))
    return o;
  const t = o, n2 = t._c;
  if (n2 === Blob.name) {
    const b = o;
    return new Blob([vt(t.value)], {
      type: b.fileType
    });
  } else if (n2 === File.name) {
    const b = o;
    return new File([vt(t.value)], b.name, {
      type: b.fileType,
      lastModified: b.lastModified
    });
  } else if (n2 === ArrayBuffer.name)
    return vt(t.value);
  const a = o, d = vt(a.value), m2 = a._c;
  try {
    return new globalThis[m2](d);
  } catch {
  }
  return o;
};
var Zt = { exports: {} };
(function(o) {
  var t = Object.prototype.hasOwnProperty, n2 = "~";
  function a() {
  }
  Object.create && (a.prototype = /* @__PURE__ */ Object.create(null), new a().__proto__ || (n2 = false));
  function d(M, S, A) {
    this.fn = M, this.context = S, this.once = A || false;
  }
  function m2(M, S, A, P, T) {
    if (typeof A != "function")
      throw new TypeError("The listener must be a function");
    var V = new d(A, P || M, T), y = n2 ? n2 + S : S;
    return M._events[y] ? M._events[y].fn ? M._events[y] = [M._events[y], V] : M._events[y].push(V) : (M._events[y] = V, M._eventsCount++), M;
  }
  function b(M, S) {
    --M._eventsCount === 0 ? M._events = new a() : delete M._events[S];
  }
  function I() {
    this._events = new a(), this._eventsCount = 0;
  }
  I.prototype.eventNames = function() {
    var S = [], A, P;
    if (this._eventsCount === 0)
      return S;
    for (P in A = this._events)
      t.call(A, P) && S.push(n2 ? P.slice(1) : P);
    return Object.getOwnPropertySymbols ? S.concat(Object.getOwnPropertySymbols(A)) : S;
  }, I.prototype.listeners = function(S) {
    var A = n2 ? n2 + S : S, P = this._events[A];
    if (!P)
      return [];
    if (P.fn)
      return [P.fn];
    for (var T = 0, V = P.length, y = new Array(V); T < V; T++)
      y[T] = P[T].fn;
    return y;
  }, I.prototype.listenerCount = function(S) {
    var A = n2 ? n2 + S : S, P = this._events[A];
    return P ? P.fn ? 1 : P.length : 0;
  }, I.prototype.emit = function(S, A, P, T, V, y) {
    var C = n2 ? n2 + S : S;
    if (!this._events[C])
      return false;
    var h = this._events[C], E = arguments.length, L, _;
    if (h.fn) {
      switch (h.once && this.removeListener(S, h.fn, void 0, true), E) {
        case 1:
          return h.fn.call(h.context), true;
        case 2:
          return h.fn.call(h.context, A), true;
        case 3:
          return h.fn.call(h.context, A, P), true;
        case 4:
          return h.fn.call(h.context, A, P, T), true;
        case 5:
          return h.fn.call(h.context, A, P, T, V), true;
        case 6:
          return h.fn.call(h.context, A, P, T, V, y), true;
      }
      for (_ = 1, L = new Array(E - 1); _ < E; _++)
        L[_ - 1] = arguments[_];
      h.fn.apply(h.context, L);
    } else {
      var O = h.length, B;
      for (_ = 0; _ < O; _++)
        switch (h[_].once && this.removeListener(S, h[_].fn, void 0, true), E) {
          case 1:
            h[_].fn.call(h[_].context);
            break;
          case 2:
            h[_].fn.call(h[_].context, A);
            break;
          case 3:
            h[_].fn.call(h[_].context, A, P);
            break;
          case 4:
            h[_].fn.call(h[_].context, A, P, T);
            break;
          default:
            if (!L)
              for (B = 1, L = new Array(E - 1); B < E; B++)
                L[B - 1] = arguments[B];
            h[_].fn.apply(h[_].context, L);
        }
    }
    return true;
  }, I.prototype.on = function(S, A, P) {
    return m2(this, S, A, P, false);
  }, I.prototype.once = function(S, A, P) {
    return m2(this, S, A, P, true);
  }, I.prototype.removeListener = function(S, A, P, T) {
    var V = n2 ? n2 + S : S;
    if (!this._events[V])
      return this;
    if (!A)
      return b(this, V), this;
    var y = this._events[V];
    if (y.fn)
      y.fn === A && (!T || y.once) && (!P || y.context === P) && b(this, V);
    else {
      for (var C = 0, h = [], E = y.length; C < E; C++)
        (y[C].fn !== A || T && !y[C].once || P && y[C].context !== P) && h.push(y[C]);
      h.length ? this._events[V] = h.length === 1 ? h[0] : h : b(this, V);
    }
    return this;
  }, I.prototype.removeAllListeners = function(S) {
    var A;
    return S ? (A = n2 ? n2 + S : S, this._events[A] && b(this, A)) : (this._events = new a(), this._eventsCount = 0), this;
  }, I.prototype.off = I.prototype.removeListener, I.prototype.addListener = I.prototype.on, I.prefixed = n2, I.EventEmitter = I, o.exports = I;
})(Zt);
var Dt = Zt.exports;
function Mt(o, t) {
  const n2 = Et(o), a = Et(t), d = n2.pop(), m2 = a.pop(), b = Pt(n2, a);
  return b !== 0 ? b : d && m2 ? Pt(d.split("."), m2.split(".")) : d || m2 ? d ? -1 : 1 : 0;
}
const he = (o) => typeof o == "string" && /^[v\d]/.test(o) && te.test(o), ct = (o, t, n2) => {
  de(n2);
  const a = Mt(o, t);
  return ee[n2].includes(a);
}, le = (o, t) => {
  const n2 = t.match(/^([<>=~^]+)/), a = n2 ? n2[1] : "=";
  if (a !== "^" && a !== "~")
    return ct(o, t, a);
  const [d, m2, b] = Et(o), [I, M, S] = Et(t);
  return It(d, I) !== 0 ? false : a === "^" ? Pt([m2, b], [M, S]) >= 0 : It(m2, M) !== 0 ? false : It(b, S) >= 0;
};
Mt.validate = he;
Mt.compare = ct;
Mt.satisfies = le;
const te = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i, Et = (o) => {
  if (typeof o != "string")
    throw new TypeError("Invalid argument expected string");
  const t = o.match(te);
  if (!t)
    throw new Error(`Invalid argument not valid semver ('${o}' received)`);
  return t.shift(), t;
}, qt = (o) => o === "*" || o === "x" || o === "X", Jt = (o) => {
  const t = parseInt(o, 10);
  return isNaN(t) ? o : t;
}, ce = (o, t) => typeof o != typeof t ? [String(o), String(t)] : [o, t], It = (o, t) => {
  if (qt(o) || qt(t))
    return 0;
  const [n2, a] = ce(Jt(o), Jt(t));
  return n2 > a ? 1 : n2 < a ? -1 : 0;
}, Pt = (o, t) => {
  for (let n2 = 0; n2 < Math.max(o.length, t.length); n2++) {
    const a = It(o[n2] || 0, t[n2] || 0);
    if (a !== 0)
      return a;
  }
  return 0;
}, ee = {
  ">": [1],
  ">=": [0, 1],
  "=": [0],
  "<=": [-1, 0],
  "<": [-1]
}, Wt = Object.keys(ee), de = (o) => {
  if (typeof o != "string")
    throw new TypeError(`Invalid operator type, expected string but got ${typeof o}`);
  if (Wt.indexOf(o) === -1)
    throw new Error(`Invalid operator, expected one of ${Wt.join("|")}`);
};
var mt;
(function(o) {
  o.mp_debug = "mp_debug";
})(mt || (mt = {}));
const pe = () => {
  try {
    return window !== window.top;
  } catch {
    return false;
  }
}, ne = {
  version: pt,
  metaframes: {}
};
class ge extends Dt.EventEmitter {
  constructor() {
    super(), this._definition = ne, this.getDefinition = this.getDefinition.bind(this);
  }
  error(t) {
    throw "Subclass should implement";
  }
  getDefinition() {
    return this._definition;
  }
}
const ie = (o) => {
  if (o === null)
    throw "Metapage definition cannot be null";
  if (typeof o == "string")
    try {
      o = JSON.parse(o);
    } catch {
      throw `Cannot parse into JSON:
${o}`;
    }
  if (!o.version)
    throw 'Missing "version" key in metapage definition';
  let t;
  switch (re(o.version)) {
    case st.V0_2: {
      t = ie(be(o));
      break;
    }
    case st.V0_3: {
      t = o;
      break;
    }
    default:
      console.warn(`Metapage definition version=${o.version} but we only know up to version ${pt}. Assuming the definition is compatible, but it's the future!`), t = o;
      break;
  }
  return t;
}, se = (o, t) => {
  if (o)
    switch (o.version) {
      case void 0:
      case it.V0_3:
      case it.V0_4:
        return se(me(o));
      case it.V0_5:
        return ye(o);
      case it.V0_6:
        return o;
      default:
        if (t && t.errorIfUnknownVersion)
          throw `Unsupported metaframe version. Please upgrade to a new version: npm i @metapages/metapage@latest
 ${JSON.stringify(o)}
${window.location.href}`;
        return console.error(`Unsupported metaframe version. Not throwing an error because you might not be able to upgrade. Please upgrade to a new version: npm i @metapages/metapage@latest
 ${JSON.stringify(o)}
${window.location.href}`), o;
    }
}, me = (o) => {
  const _a = o, { version: t, inputs: n2, outputs: a, allow: d, metadata: m2 } = _a, b = __objRest(_a, ["version", "inputs", "outputs", "allow", "metadata"]), I = m2, _b = I, { title: M, author: S, image: A, descriptionUrl: P, keywords: T, iconUrl: V } = _b, y = __objRest(_b, ["title", "author", "image", "descriptionUrl", "keywords", "iconUrl"]), C = __spreadValues({
    name: M,
    author: S,
    description: P,
    image: A,
    tags: T
  }, y);
  return __spreadValues({
    version: it.V0_5,
    inputs: n2,
    outputs: a,
    allow: d,
    metadata: C
  }, b);
}, ye = (o) => {
  const _a = o, { metadata: t } = _a, n2 = __objRest(_a, ["metadata"]), a = __spreadProps(__spreadValues({}, n2), {
    version: it.V0_6
  });
  if (t) {
    const _b = t, { edit: d } = _b, m2 = __objRest(_b, ["edit"]), b = __spreadValues({}, m2);
    if (a.metadata = b, d && !(b && b.operations && b.operations.edit))
      switch (b.operations || (b.operations = {}), d.type) {
        case "metapage":
          const I = d.value, M = {
            type: "metapage",
            metapage: I.definition,
            metaframe: I.key || "edit"
          };
          b.operations.edit = M;
          break;
        case "metaframe":
          const S = d.value, A = {
            type: "url",
            url: S.url,
            params: S.params ? S.params.map((P) => ({
              to: P.to,
              from: P.from,
              toType: P.toType === "path" ? void 0 : P.toType
            })) : void 0
          };
          b.operations.edit = A;
          break;
        default:
          throw `Unsupported edit type: ${d.type} in metadata for metaframe ${JSON.stringify(t)}`;
      }
  }
  return a;
}, be = (o) => (o.version = st.V0_3, o), St = (o, t) => {
  if (!t)
    return false;
  let n2 = false;
  return Object.keys(t).forEach((a) => {
    n2 = true, t[a] === void 0 ? delete o[a] : o[a] = t[a];
  }), n2;
}, re = (o) => {
  if (o === "latest")
    return pt;
  if (ct(o, "0.2", "<"))
    throw `Unknown version: ${o}`;
  return ct(o, "0.2", ">=") && ct(o, st.V0_3, "<") ? st.V0_2 : ct(o, "0.3", ">=") ? st.V0_3 : (console.log(`Could not match version=${o} to any known version, assuming ${pt}`), pt);
}, Ct = () => {
  const o = new URLSearchParams(window.location.search).get(mt.mp_debug);
  return o === "true" || o === "1";
}, _e = (o) => o.filter((n2) => new URLSearchParams(window.location.search).has(n2)).length > 0, we = (o = 8) => Bt(o), Yt = "abcdefghijklmnopqrstuvwxyz0123456789", Bt = (o = 8) => {
  for (var t = "", n2 = Yt.length, a = 0; a < o; a++)
    t += Yt.charAt(Math.floor(Math.random() * n2));
  return t;
}, Rt = (o, t, n2) => {
  t = t || "000", t && t.trim() == "" && (t = void 0);
  let a;
  if (typeof o == "string" ? a = o : typeof o == "number" ? a = o + "" : a = JSON.stringify(o, null, "  "), t && t.trim() != "") {
    var d = `color: #${t}`;
    n2 && (d = `${d}; background: #${n2}`), a = `%c${a}`, window.console.log(a, d);
  } else
    window.console.log(a);
}, oe = (o) => Ie(ve(o)), ve = (o) => {
  var t = 0;
  for (let n2 = 0; n2 < o.length; n2++)
    t = o.charCodeAt(n2) + ((t << 5) - t);
  return t;
}, Ie = (o) => {
  var t = (o & 16777215).toString(16).toUpperCase();
  return "00000".substring(0, 6 - t.length) + t;
}, Ut = () => document.readyState == "complete" || document.readyState == "interactive", jt = async () => Ut() ? Promise.resolve() : new Promise((o) => {
  if (Ut()) {
    o();
    return;
  }
  let t = false;
  window.addEventListener("load", () => {
    t || (t = true, o());
  }), setTimeout(() => {
    !t && Ut() && (t = true, o());
  }, 200);
});
class Ht extends Dt.EventEmitter {
  constructor(t, n2, a, d, m2, b = false) {
    if (super(), this.inputs = {}, this.outputs = {}, this._disposables = [], this._rpcListeners = [], this._loaded = false, this._onLoaded = [], this._sendInputsAfterRegistration = false, this._plugin = false, this._cachedEventInputsUpdate = {
      iframeId: void 0,
      inputs: void 0
    }, this._cachedEventOutputsUpdate = {
      iframeId: null,
      inputs: null
    }, !n2.startsWith("http")) {
      for (; n2.startsWith("/"); )
        n2 = n2.substring(1);
      n2 = window.location.protocol + "//" + window.location.hostname + (window.location.port && window.location.port != "" ? ":" + window.location.port : "") + "/" + n2;
    }
    this.url = n2, this._metapage = t;
    var I = new URL(this.url);
    b && I.searchParams.set(mt.mp_debug, "true"), this.url = I.href, this.id = a, this._debug = b, this._parentId = d, this._color = oe(this.id), this._consoleBackgroundColor = m2, this._iframe = document.createElement("iframe"), this._iframe.name = this.id;
    const M = this;
    this.iframe = new Promise((S) => {
      jt().then(async () => {
        if (M._iframe) {
          const A = await M.getDefinition();
          if (!M._iframe)
            return;
          A && A.allow && (M._iframe.allow = A.allow), M._iframe.src = this.url, S(M._iframe);
        }
      });
    }), this.ack = this.ack.bind(this), this.dispose = this.dispose.bind(this), this.getDefinition = this.getDefinition.bind(this), this.getDefinitionUrl = this.getDefinitionUrl.bind(this), this.setPlugin = this.setPlugin.bind(this), this.hasPermissionsDefinition = this.hasPermissionsDefinition.bind(this), this.hasPermissionsState = this.hasPermissionsState.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.onInput = this.onInput.bind(this), this.onInputs = this.onInputs.bind(this), this.onOutput = this.onOutput.bind(this), this.onOutputs = this.onOutputs.bind(this), this.register = this.register.bind(this), this.registered = this.registered.bind(this), this.sendInputs = this.sendInputs.bind(this), this.sendOrBufferPostMessage = this.sendOrBufferPostMessage.bind(this), this.sendRpc = this.sendRpc.bind(this), this.sendRpcInternal = this.sendRpcInternal.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setMetapage = this.setMetapage.bind(this), this.setOutput = this.setOutput.bind(this), this.setOutputs = this.setOutputs.bind(this), this.setPlugin = this.setPlugin.bind(this), this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this), this.isDisposed = this.isDisposed.bind(this);
  }
  addListenerReturnDisposer(t, n2) {
    return super.addListener(t, n2), () => {
      super.removeListener(t, n2);
    };
  }
  setPlugin() {
    if (this._loaded)
      throw "Cannot setPlugin after MetapageIFrameRpcClient already loaded";
    return this._plugin = true, this;
  }
  setMetapage(t) {
    return this._metapage = t, this;
  }
  hasPermissionsState() {
    return this._definition !== void 0 && this._definition.inputs !== void 0 && this._definition.inputs[ft] !== void 0;
  }
  hasPermissionsDefinition() {
    return this._definition !== void 0 && this._definition.inputs !== void 0 && this._definition.inputs[rt] !== void 0;
  }
  getDefinitionUrl() {
    var t = new URL(this.url);
    return t.pathname = t.pathname + (t.pathname.endsWith("/") ? "metaframe.json" : "/metaframe.json"), t.href;
  }
  async getDefinition() {
    if (this._definition)
      return this._definition;
    var t = this.getDefinitionUrl();
    try {
      const n2 = await window.fetch(t);
      if (n2.ok) {
        const a = await n2.json(), d = se(a);
        return this._definition = d, this._definition;
      } else
        this.emit(N.Error, `Failed to fetch: ${t}
Status: ${n2.status}
Status text: ${n2.statusText}`);
    } catch (n2) {
      this.emit(N.Error, `Failed to fetch or convert: ${t}
Error: ${n2}`);
    }
  }
  setInput(t, n2) {
    console.assert(!!t);
    var a = {};
    a[t] = n2, this.setInputs(a);
  }
  setInputs(t) {
    if (this.log({ m: "MetapageIFrameRpcClient", inputs: t }), !St(this.inputs, t))
      return this;
    if (this._loaded || (this._sendInputsAfterRegistration = true), this._iframe.parentNode && this._loaded && this.sendInputs(t), this.emit(N.Inputs, this.inputs), this._metapage.listenerCount(N.Inputs) > 0) {
      var n2 = {};
      n2[this.id] = t, this._metapage.emit(N.Inputs, n2);
    }
    return this;
  }
  setOutput(t, n2) {
    console.assert(!!t);
    var a = {};
    a[t] = n2, this.setOutputs(a);
  }
  setOutputs(t) {
    if (St(this.outputs, t) && (this.emit(N.Outputs, t), this._metapage.listenerCount(N.Outputs) > 0)) {
      var n2 = {};
      n2[this.id] = this.outputs, this._metapage.emit(N.Outputs, n2);
    }
  }
  onInputs(t) {
    return this.addListenerReturnDisposer(N.Inputs, t);
  }
  onInput(t, n2) {
    var a = function(d) {
      d.hasOwnProperty(t) && n2(d[t]);
    };
    return this.addListenerReturnDisposer(N.Inputs, a);
  }
  onOutputs(t) {
    return this.addListenerReturnDisposer(N.Outputs, t);
  }
  onOutput(t, n2) {
    var a = function(d) {
      d.hasOwnProperty(t) && n2(d[t]);
    };
    return this.addListenerReturnDisposer(N.Outputs, a);
  }
  isDisposed() {
    return this.inputs === void 0;
  }
  dispose() {
    for (super.removeAllListeners(); this._disposables && this._disposables.length > 0; ) {
      const t = this._disposables.pop();
      t && t();
    }
    this._rpcListeners = void 0, this.inputs = void 0, this.outputs = void 0, this._iframe && this._iframe.parentNode && this._iframe.parentNode.removeChild(this._iframe), this._iframe = void 0, this._bufferMessages = void 0, this._bufferTimeout && (window.clearInterval(this._bufferTimeout), this._bufferTimeout = void 0), this._metapage = void 0;
  }
  register() {
    var t = {
      iframeId: this.id,
      parentId: this._parentId,
      plugin: this._plugin,
      state: {
        inputs: this.inputs
      },
      version: Qt
    };
    this.sendRpcInternal(at.SetupIframeServerResponse, t);
  }
  registered(t) {
    if (this.log({ m: "MetapageIFrameRpcClient.registered", inputs: this.inputs }), !this._loaded) {
      if (!t)
        throw "Cannot register without a version";
      for (this.version = t, this._loaded = true; this._onLoaded && this._onLoaded.length > 0; )
        this._onLoaded.pop()();
      this._sendInputsAfterRegistration && this.sendInputs(this.inputs);
    }
  }
  async sendInputs(t) {
    t = await Ot(t), this.sendRpc(at.InputsUpdate, {
      inputs: t,
      parentId: this._parentId
    });
  }
  sendRpc(t, n2) {
    var _a, _b;
    if (((_a = this == null ? void 0 : this._iframe) == null ? void 0 : _a.parentNode) && this._loaded)
      this.sendRpcInternal(t, n2);
    else {
      (_b = this == null ? void 0 : this._metapage) == null ? void 0 : _b.error("sending rpc later");
      const a = this;
      this == null ? void 0 : this._onLoaded.push(() => {
        a.sendRpcInternal(t, n2);
      });
    }
  }
  ack(t) {
    if (this.log("\u2692 \u2692 \u2692 calling ack"), this._debug) {
      this.log("\u2692 \u2692 \u2692 sending ack from client to frame");
      var n2 = {
        message: t
      };
      this.sendRpc(at.MessageAck, n2);
    } else
      this.log("\u2692 \u2692 \u2692 NOT sending ack from client to frame since not debug mode");
  }
  log(t) {
    this._debug && this.logInternal(t);
  }
  logInternal(t) {
    let n2;
    typeof t == "string" ? n2 = t : typeof t == "string" ? n2 = t + "" : n2 = JSON.stringify(t), Rt(`Metapage[${this._parentId}] Metaframe[${this.id}] ${n2}`, this._color, this._consoleBackgroundColor);
  }
  sendRpcInternal(t, n2) {
    const a = {
      id: "_",
      iframeId: this.id,
      jsonrpc: "2.0",
      method: t,
      params: n2,
      parentId: this._parentId
    };
    this._iframe ? this.sendOrBufferPostMessage(a) : this._metapage ? this._metapage.error(`Cannot send to child iframe messageJSON=${JSON.stringify(a).substring(0, 200)}`) : console.error(`Cannot send to child iframe messageJSON=${JSON.stringify(a).substring(0, 200)}`);
  }
  sendOrBufferPostMessage(t) {
    if (this._iframe && this._iframe.contentWindow)
      this._iframe.contentWindow.postMessage(t, this.url);
    else if (this._bufferMessages)
      this._bufferMessages.push(t);
    else {
      this._bufferMessages = [t];
      const n2 = this;
      this._bufferTimeout = window.setInterval(function() {
        n2._iframe && n2._iframe.contentWindow && (n2._bufferMessages.forEach((a) => n2._iframe.contentWindow.postMessage(a, n2.url)), window.clearInterval(n2._bufferTimeout), n2._bufferTimeout = void 0, n2._bufferMessages = void 0);
      }, 0);
    }
  }
}
var Gt;
(function(o) {
  o.all = "all", o.delta = "delta";
})(Gt || (Gt = {}));
const Kt = () => ({
  metaframes: {
    inputs: {},
    outputs: {}
  },
  plugins: {
    inputs: {},
    outputs: {}
  }
}), Ee = (o, t) => !t || t === "*" || o === t ? true : t.endsWith("*") ? o.startsWith(t.slice(0, -1)) : t.startsWith("*") ? o.endsWith(t.slice(1)) : false, Se = "bcbcbc";
class tt extends ge {
  constructor(t) {
    super(), this._state = Kt(), this._metaframes = {}, this._plugins = {}, this._pluginOrder = [], this.debug = Ct(), this._internalReceivedMessageCounter = 0, this._cachedInputLookupMap = {}, this._inputMap = {}, this._id = t && t.id ? t.id : we(), this._consoleBackgroundColor = t && t.color ? t.color : Se, this.addPipe = this.addPipe.bind(this), this.dispose = this.dispose.bind(this), this.addMetaframe = this.addMetaframe.bind(this), this.addPlugin = this.addPlugin.bind(this), this.getInputsFromOutput = this.getInputsFromOutput.bind(this), this.getMetaframe = this.getMetaframe.bind(this), this.getMetaframeIds = this.getMetaframeIds.bind(this), this.getMetaframeOrPlugin = this.getMetaframeOrPlugin.bind(this), this.getMetaframes = this.getMetaframes.bind(this), this.getPlugin = this.getPlugin.bind(this), this.getPluginIds = this.getPluginIds.bind(this), this.getState = this.getState.bind(this), this.getStateMetaframes = this.getStateMetaframes.bind(this), this.isValidJSONRpcMessage = this.isValidJSONRpcMessage.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.metaframeIds = this.metaframeIds.bind(this), this.metaframes = this.metaframes.bind(this), this.onMessage = this.onMessage.bind(this), this.pluginIds = this.pluginIds.bind(this), this.plugins = this.plugins.bind(this), this.removeAll = this.removeAll.bind(this), this.removeMetaframe = this.removeMetaframe.bind(this), this.removePlugin = this.removePlugin.bind(this), this.setDebugFromUrlParams = this.setDebugFromUrlParams.bind(this), this.setDefinition = this.setDefinition.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setInputStateOnly = this.setInputStateOnly.bind(this), this.setMetaframeClientInputAndSentClientEvent = this.setMetaframeClientInputAndSentClientEvent.bind(this), this.setOutputStateOnly = this.setOutputStateOnly.bind(this), this.setState = this.setState.bind(this), this.isDisposed = this.isDisposed.bind(this), this.updatePluginsWithDefinition = this.updatePluginsWithDefinition.bind(this), this._emitDefinitionEvent = this._emitDefinitionEvent.bind(this), jt().then(() => {
      this.isDisposed() || (window.addEventListener("message", this.onMessage), this.log("Initialized"));
    });
  }
  static from(t, n2) {
    if (t == null)
      throw "Metapage definition cannot be null";
    if (typeof t == "string")
      try {
        t = JSON.parse(t);
      } catch {
        throw "Cannot parse into JSON:\n${metaPageDef}";
      }
    var a = new tt();
    return a.setDefinition(t);
  }
  isDisposed() {
    return this._metaframes === void 0;
  }
  addListenerReturnDisposer(t, n2) {
    return super.addListener(t, n2), () => {
      super.removeListener(t, n2);
    };
  }
  setDebugFromUrlParams() {
    return this.debug = _e(["MP_DEBUG", "DEBUG", "debug", "mp_debug"]), this;
  }
  getState() {
    return this._state;
  }
  setState(t) {
    this._state = t, this.getMetaframeIds().forEach((n2) => {
      this.getMetaframe(n2).setInputs(this._state.metaframes.inputs[n2]), this.getMetaframe(n2).setOutputs(this._state.metaframes.outputs[n2]);
    }), this.getPluginIds().forEach((n2) => {
      this.getPlugin(n2).setInputs(this._state.plugins.inputs[n2]), this.getPlugin(n2).setOutputs(this._state.plugins.outputs[n2]);
    }), this.emit(N.State, this._state);
  }
  getStateMetaframes() {
    return this._state.metaframes;
  }
  getDefinition() {
    return this._definition;
  }
  setDefinition(t, n2) {
    if (!t.version)
      throw "Metapage definition must have a version";
    const a = ie(t);
    a.metaframes && Object.keys(a.metaframes).forEach((m2) => {
      if (a.plugins && a.plugins.includes(m2))
        throw this.emitErrorMessage(`Plugin with url=${m2} matches metaframe. Metaframe ids and plugin urls are not allowed to collide`), `Plugin with url=${m2} matches metaframe. Metaframe ids and plugin urls are not allowed to collide`;
      var b = a.metaframes[m2];
      if (typeof b != "object")
        throw this.emitErrorMessage(`Metaframe "${m2}" is not an object`), `Metaframe "${m2}" is not an object`;
      if (!b.url)
        throw this.emitErrorMessage(`Metaframe "${m2}" missing field: url`), `Metaframe "${m2}" missing field: url`;
    });
    const d = this._definition;
    return this._definition = a, Object.keys(this._metaframes).forEach((m2) => {
      (!a.metaframes || !a.metaframes[m2]) && this.removeMetaframe(m2);
    }), Object.keys(this._plugins).forEach((m2) => {
      a.plugins && !a.plugins.includes(m2) && this.removePlugin(m2);
    }), this._pluginOrder = a.plugins ? a.plugins : [], n2 && (this._state = n2), a.metaframes && Object.keys(a.metaframes).forEach((m2) => {
      if (!this._metaframes.hasOwnProperty(m2)) {
        const b = a.metaframes[m2];
        this.addMetaframe(m2, b);
      }
    }), a.plugins && a.plugins.forEach((m2) => {
      this._plugins.hasOwnProperty(m2) || this.addPlugin(m2);
    }), d !== ne && window.setTimeout(() => {
      !this.isDisposed() && a === this._definition && (this._emitDefinitionEvent(), n2 && this.emit(N.State, this._state));
    }, 0), this;
  }
  _emitDefinitionEvent() {
    const t = {
      definition: this._definition,
      metaframes: this._metaframes,
      plugins: this._plugins
    };
    this.emit(N.Definition, t);
  }
  addPipe(t, n2) {
    this._inputMap[t] || (this._inputMap[t] = []), this._inputMap[t].push(n2);
  }
  removeMetaframe(t) {
    this._metaframes[t] && (this._metaframes[t].dispose(), delete this._metaframes[t], delete this._state.metaframes.inputs[t], delete this._state.metaframes.outputs[t], delete this._inputMap[t], Object.keys(this._inputMap).forEach((n2) => {
      const a = this._inputMap[n2];
      let d = 0;
      for (; d <= a.length; )
        a[d] && a[d].metaframe === t ? a.splice(d, 1) : d++;
    }), this._cachedInputLookupMap = {});
  }
  removePlugin(t) {
    this._plugins[t] && (this._plugins[t].dispose(), delete this._plugins[t], delete this._state.plugins.inputs[t], delete this._state.plugins.outputs[t]);
  }
  removeAll() {
    Object.keys(this._metaframes).forEach((t) => this._metaframes[t].dispose()), Object.keys(this._plugins).forEach((t) => this._plugins[t].dispose()), this._metaframes = {}, this._plugins = {}, this._state = Kt(), this._inputMap = {}, this._cachedInputLookupMap = {};
  }
  metaframes() {
    return this.getMetaframes();
  }
  metaframeIds() {
    return this.getMetaframeIds();
  }
  getMetaframeIds() {
    return Object.keys(this._metaframes);
  }
  getMetaframes() {
    return Object.assign({}, this._metaframes);
  }
  plugins() {
    return Object.assign({}, this._plugins);
  }
  pluginIds() {
    return this.getPluginIds();
  }
  getPluginIds() {
    return this._pluginOrder.slice(0);
  }
  getMetaframe(t) {
    return this == null ? void 0 : this._metaframes[t];
  }
  getPlugin(t) {
    var _a;
    return (_a = this == null ? void 0 : this._plugins) == null ? void 0 : _a[t];
  }
  addMetaframe(t, n2) {
    if (!t)
      throw "addMetaframe missing metaframeId";
    if (!n2)
      throw "addMetaframe missing definition";
    if (this._metaframes[t])
      throw this.emitErrorMessage(`Existing metaframe for id=${t}`), `Existing metaframe for id=${t}`;
    if (!n2.url)
      throw this.emitErrorMessage(`Metaframe definition missing url id=${t}`), `Metaframe definition missing url id=${t}`;
    var a = new Ht(this, n2.url, t, this._id, this._consoleBackgroundColor, this.debug).setMetapage(this);
    return this._metaframes[t] = a, a.addListener(N.Error, (d) => {
      this.emit(N.Error, {
        metaframeId: a.id,
        metaframeUrl: a.url,
        error: d
      });
    }), n2.inputs && n2.inputs.forEach((d) => this.addPipe(t, d)), a.setInputs(this._state.metaframes.inputs[t]), a;
  }
  addPlugin(t) {
    if (!t)
      throw "Plugin missing url";
    const n2 = new Ht(this, t, t, this._id, this._consoleBackgroundColor, this.debug).setInputs(this._state.plugins.inputs[t]).setMetapage(this).setPlugin();
    return Oe(this, n2), this._plugins[t] = n2, n2;
  }
  dispose() {
    this.log("disposing"), super.removeAllListeners(), window.removeEventListener("message", this.onMessage), this._metaframes && Object.keys(this._metaframes).forEach((t) => this._metaframes[t].dispose()), this._plugins && Object.keys(this._plugins).forEach((t) => this._plugins[t].dispose()), this._id = void 0, this._metaframes = void 0, this._plugins = void 0, this._state = void 0, this._cachedInputLookupMap = void 0, this._inputMap = void 0;
  }
  log(t, n2, a) {
    this.debug && this.logInternal(t, n2, a);
  }
  error(t) {
    this.logInternal(t, "f00", this._consoleBackgroundColor), this.emitErrorMessage(`${t}`);
  }
  emitErrorMessage(t) {
    this.emit(N.Error, t);
  }
  getInputsFromOutput(t, n2) {
    if (this._cachedInputLookupMap[t] || (this._cachedInputLookupMap[t] = {}), !this._cachedInputLookupMap[t][n2]) {
      var a = [];
      this._cachedInputLookupMap[t][n2] = a, Object.keys(this._inputMap).forEach((d) => {
        d !== t && this._inputMap[d].forEach((m2) => {
          if (m2.metaframe == t && Ee(n2, m2.source)) {
            var b = m2.target;
            (!m2.target || m2.target.startsWith("*") || m2.target === "") && (b = n2), a.push({ metaframe: d, pipe: b });
          }
        });
      });
    }
    return this._cachedInputLookupMap[t][n2];
  }
  isValidJSONRpcMessage(t) {
    if (t.jsonrpc !== "2.0")
      return false;
    switch (t.method) {
      case X.SetupIframeClientRequest:
        return true;
      default:
        var a = t.iframeId;
        return !(a && !(t.parentId === this._id && (this._metaframes[a] || this._plugins[a])));
    }
  }
  setInput(t, n2, a) {
    this.setInputStateOnly(t, n2, a), this.setMetaframeClientInputAndSentClientEvent(t, n2, a), this.emit(N.State, this._state), this.emit(N.Inputs, this._state);
  }
  setMetaframeClientInputAndSentClientEvent(t, n2, a) {
    if (typeof t == "object") {
      if (n2 || a)
        throw "bad arguments, see API docs";
      const d = t;
      Object.keys(d).forEach((m2) => {
        var b = m2, I = d[b];
        if (typeof I != "object")
          throw "bad arguments, see API docs";
        var M = this._metaframes[b];
        M ? M.setInputs(I) : this.error("No iframe id=$metaframeId");
      });
    } else if (typeof t == "string") {
      const d = this._metaframes[t];
      if (d == null && this.error(`No iframe id=${t}`), typeof n2 == "string")
        d.setInput(n2, a);
      else if (typeof n2 == "object")
        d.setInputs(n2);
      else
        throw "bad arguments, see API docs";
    } else
      throw "bad arguments, see API docs";
  }
  setInputs(t, n2, a) {
    this.setInput(t, n2, a);
  }
  setOutputStateOnly(t, n2, a) {
    this._setStateOnly(false, t, n2, a);
  }
  setInputStateOnly(t, n2, a) {
    this._setStateOnly(true, t, n2, a);
  }
  _setStateOnly(t, n2, a, d) {
    if (typeof n2 == "object") {
      if (a || d)
        throw "If first argument is an object, subsequent args should be undefined";
      const m2 = n2;
      Object.keys(m2).forEach((b) => {
        var I = m2[b];
        if (typeof I != "object")
          throw "Object values must be objects";
        const M = this._metaframes.hasOwnProperty(b);
        if (!M && !this._plugins.hasOwnProperty(b))
          throw "No metaframe or plugin: ${metaframeId}";
        const S = M ? t ? this._state.metaframes.inputs : this._state.metaframes.outputs : t ? this._state.plugins.inputs : this._state.plugins.outputs;
        S[b] = S[b] ? S[b] : {}, Object.keys(I).forEach((A) => {
          I[A] === void 0 ? delete S[b][A] : S[b][A] = I[A];
        });
      });
    } else if (typeof n2 == "string") {
      const m2 = n2, b = this._metaframes.hasOwnProperty(m2);
      if (!b && !this._plugins.hasOwnProperty(m2))
        throw `No metaframe or plugin: ${m2}`;
      const I = b ? t ? this._state.metaframes.inputs : this._state.metaframes.outputs : t ? this._state.plugins.inputs : this._state.plugins.outputs;
      if (typeof a == "string") {
        I[m2] = I[m2] ? I[m2] : {};
        const M = a;
        d === void 0 ? delete I[m2][M] : I[m2][M] = d;
      } else if (typeof a == "object") {
        I[m2] = I[m2] ? I[m2] : {};
        const M = a;
        Object.keys(M).forEach((S) => {
          M[S] === void 0 ? delete I[m2][S] : I[m2][S] = M[S];
        });
      } else
        throw "Second argument must be a string or an object";
    } else
      throw "First argument must be a string or an object";
  }
  getMetaframeOrPlugin(t) {
    var n2 = this._metaframes[t];
    return n2 || (n2 = this._plugins[t]), n2;
  }
  onMessage(t) {
    if (typeof t.data == "object") {
      const b = t.data;
      if (!this.isValidJSONRpcMessage(b))
        return;
      var n2 = b.method;
      const I = b.iframeId;
      if (!I)
        return;
      const M = this.getMetaframeOrPlugin(I), S = this._plugins[I];
      switch (b._messageCount = ++this._internalReceivedMessageCounter, this.debug && this.log(`processing ${JSON.stringify(b, null, "  ").substr(0, 500)}`), n2) {
        case X.SetupIframeClientRequest:
          M && M.register();
          break;
        case X.SetupIframeServerResponseAck:
          if (M) {
            const P = b.params;
            M.registered(P.version);
          }
          break;
        case X.OutputsUpdate:
          const A = b.params;
          if (this._metaframes[I]) {
            var a = this._metaframes[I];
            this.setOutputStateOnly(I, A), a.setOutputs(A), this.emit(N.State, this._state);
            var d = false;
            const P = Object.keys(A), T = {};
            P.forEach((V, y) => {
              const C = this.getInputsFromOutput(I, V);
              C.length > 0 && C.forEach((h) => {
                T[h.metaframe] || (T[h.metaframe] = {}), T[h.metaframe][h.pipe] = A[V], this.setInputStateOnly(h.metaframe, h.pipe, A[V]), d = true;
              });
            }), Object.keys(T).forEach((V) => {
              this._metaframes[V].setInputs(T[V]);
            }), d && this.emit(N.State, this._state), this.debug && a.ack({ jsonrpc: b, state: this._state });
          } else if (this._plugins[I]) {
            const P = !A[ft] && !A[rt];
            P && this.setOutputStateOnly(I, A), this._plugins[I].setOutputs(A), P && this.emit(N.State, this._state), this.debug && this._plugins[I].ack({
              jsonrpc: b,
              state: this._state
            });
          } else
            this.error("missing metaframe/plugin=$metaframeId");
          break;
        case X.InputsUpdate:
          var m2 = b.params;
          if (this.debug && this.log(`inputs ${JSON.stringify(m2)} from ${I}`), this._metaframes[I])
            this.setInputStateOnly(I, m2), this._metaframes[I].setInputs(m2), this.emit(N.State, this._state), this.debug && this._metaframes[I].ack({
              jsonrpc: b,
              state: this._state
            });
          else if (this._plugins[I]) {
            const P = !m2[ft] && !m2[rt];
            P && this.setInputStateOnly(I, m2), this._plugins[I].setInputs(m2), P && this.emit(N.State, this._state), this.debug && this._plugins[I].ack({
              jsonrpc: b,
              state: this._state
            });
          } else
            console.error(`InputsUpdate failed no metaframe or plugin id: "${I}"`), this.error(`InputsUpdate failed no metaframe or plugin id: "${I}"`);
          break;
        case X.PluginRequest:
          S && M && M.hasPermissionsState() && (M.setInput(ft, this._state), this.debug && M.ack({ jsonrpc: b, state: this._state }));
          break;
        case X.HashParamsUpdate:
          if (!S && M) {
            const P = b.params, T = new URL(M.url);
            T.hash = P.hash, M.url = T.href, this._definition.metaframes[P.metaframe].url = T.href, this._emitDefinitionEvent();
          }
          break;
        default:
          this.debug && this.log(`Unknown RPC method: "${n2}"`);
      }
      this.emit(N.Message, b);
    }
  }
  updatePluginsWithDefinition() {
    this.getDefinition(), Object.values(this._plugins).forEach((t) => {
      t.hasPermissionsDefinition() && Me(t);
    });
  }
  logInternal(t, n2, a) {
    a = a || this._consoleBackgroundColor;
    let d;
    typeof t == "string" ? d = t : typeof t == "number" ? d = t + "" : d = JSON.stringify(t), d = this._id ? `Metapage[${this._id}] ${d}` : d, Rt(d, n2, a);
  }
}
tt.version = Qt;
tt.DEFINITION = N.Definition;
tt.DEFINITION_UPDATE_REQUEST = N.DefinitionUpdateRequest;
tt.ERROR = N.Error;
tt.INPUTS = N.Inputs;
tt.MESSAGE = N.Message;
tt.OUTPUTS = N.Outputs;
tt.STATE = N.State;
tt.deserializeInputs = gt;
tt.serializeInputs = Ot;
const Oe = async (o, t) => {
  try {
    const d = await t.getDefinition();
    if (!d)
      throw `${t.url}`;
    if (t.isDisposed())
      return;
    if (t.hasPermissionsDefinition()) {
      var n2 = o.addListenerReturnDisposer(N.Definition, (m2) => {
        t.setInput(rt, m2.definition);
      });
      t._disposables.push(n2);
      var a = o.getDefinition();
      if (a && (t.setInput(rt, a), d.outputs)) {
        var n2 = t.onOutput(rt, (b) => {
          $t.sha1(b) !== $t.sha1(a) && o.emit(N.DefinitionUpdateRequest, b);
        });
        t._disposables.push(n2);
      }
    }
    if (t.hasPermissionsState() && d.outputs) {
      var n2 = t.onOutput(ft, (b) => {
        o.setState(b);
      });
      t._disposables.push(n2);
    }
  } catch (d) {
    console.error(d), o.emit(N.Error, `Failed to get plugin definition from "${t.getDefinitionUrl()}", error=${d}`);
  }
}, Me = (o) => {
  const t = o._metapage.getDefinition();
  o.setInput(rt, t);
};
var ut;
(function(o) {
  o.WaitingForPageLoad = "WaitingForPageLoad", o.SentSetupIframeClientRequest = "SentSetupIframeClientRequest", o.Ready = "Ready";
})(ut || (ut = {}));
var G;
(function(o) {
  o.Connected = "connected", o.Error = "error", o.Input = "input", o.Inputs = "inputs", o.Message = "message";
})(G || (G = {}));
class nt extends Dt.EventEmitter {
  constructor(t) {
    if (super(), this._inputPipeValues = {}, this._outputPipeValues = {}, this._state = ut.WaitingForPageLoad, this._messageSendCount = 0, this.debug = Ct(), this.isInputOutputBlobSerialization = true, this.id = window.name, this.debug = Ct(), this._isIframe = pe(), this.addListener = this.addListener.bind(this), this.dispose = this.dispose.bind(this), this.error = this.error.bind(this), this.getInput = this.getInput.bind(this), this.getInputs = this.getInputs.bind(this), this.log = this.log.bind(this), this.logInternal = this.logInternal.bind(this), this.onInput = this.onInput.bind(this), this.onInputs = this.onInputs.bind(this), this.onMessage = this.onMessage.bind(this), this.sendRpc = this.sendRpc.bind(this), this.setInput = this.setInput.bind(this), this.setInputs = this.setInputs.bind(this), this.setInternalInputsAndNotify = this.setInternalInputsAndNotify.bind(this), this.setOutput = this.setOutput.bind(this), this.setOutputs = this.setOutputs.bind(this), this.warn = this.warn.bind(this), this._resolveSetupIframeServerResponse = this._resolveSetupIframeServerResponse.bind(this), this.addListenerReturnDisposer = this.addListenerReturnDisposer.bind(this), this.connected = this.connected.bind(this), this.disableNotifyOnHashUrlChange = this.disableNotifyOnHashUrlChange.bind(this), this._onHashUrlChange = this._onHashUrlChange.bind(this), !this._isIframe) {
      this.log("Not an iframe, metaframe code disabled");
      return;
    }
    const n2 = this;
    jt().then(() => {
      this.log("pageLoaded"), window.addEventListener("message", this.onMessage), n2.sendRpc(X.SetupIframeClientRequest, {
        version: nt.version
      }), n2._state = ut.SentSetupIframeClientRequest;
    }), t && t.disableHashChangeEvent || window.addEventListener("hashchange", this._onHashUrlChange);
  }
  _resolveSetupIframeServerResponse(t) {
    if (this._state === ut.WaitingForPageLoad)
      throw "Got message but page has not finished loading, we should never get in this state";
    (async () => this._parentId ? this.log("Got JsonRpcMethods.SetupIframeServerResponse but already resolved") : (this._parentVersion = t.version, this.color = oe(this.id), this._parentId = t.parentId, this.log(`metapage[${this._parentId}](v${this._parentVersion ? this._parentVersion : "unknown"}) registered`), t.state && t.state.inputs && (this.isInputOutputBlobSerialization ? this._inputPipeValues = await gt(t.state.inputs) : this._inputPipeValues = t.state.inputs), this._state = ut.Ready, this.sendRpc(X.SetupIframeServerResponseAck, {
      version: nt.version
    }), this._inputPipeValues && Object.keys(this._inputPipeValues).length > 0 && (this.emit(G.Inputs, this._inputPipeValues), Object.keys(this._inputPipeValues).forEach((n2) => this.emit(G.Input, n2, this._inputPipeValues[n2]))), this.emit(G.Inputs, this._inputPipeValues), t.plugin && (this.plugin = new Ae(this)), this.emit(G.Connected)))();
  }
  async connected() {
    if (this._state !== ut.Ready)
      return new Promise((t, n2) => {
        let a;
        a = this.addListenerReturnDisposer(G.Connected, () => {
          t(), a();
        });
      });
  }
  addListenerReturnDisposer(t, n2) {
    return super.addListener(t, n2), () => {
      super.removeListener(t, n2);
    };
  }
  log(t, n2, a) {
    this.debug && this.logInternal(t, n2 || this.color);
  }
  warn(t) {
    this.debug && this.logInternal(t, "000", this.color);
  }
  error(t) {
    this.logInternal(t, this.color, "f00");
  }
  logInternal(t, n2, a) {
    let d;
    typeof t == "string" ? d = t : typeof t == "number" ? d = t + "" : d = JSON.stringify(t), n2 = n2 && n2 + "", d = (this.id ? `Metaframe[${this.id}] ` : "") + `${d}`, Rt(d, n2, a);
  }
  dispose() {
    super.removeAllListeners(), window.removeEventListener("message", this.onMessage), this.disableNotifyOnHashUrlChange(), this._inputPipeValues = void 0, this._outputPipeValues = void 0;
  }
  addListener(t, n2) {
    return super.addListener(t, n2), t === G.Inputs && window.setTimeout(() => {
      this._inputPipeValues && n2(this._inputPipeValues);
    }, 0), this;
  }
  onInput(t, n2) {
    return this.addListenerReturnDisposer(G.Input, (a, d) => {
      t === a && n2(d);
    });
  }
  onInputs(t) {
    return this.addListenerReturnDisposer(G.Inputs, t);
  }
  setInput(t, n2) {
    var a = {};
    a[t] = n2, this.setInputs(a);
  }
  async setInputs(t) {
    this.isInputOutputBlobSerialization && (t = await gt(t)), this.sendRpc(X.InputsUpdate, t);
  }
  async setInternalInputsAndNotify(t) {
    this.isInputOutputBlobSerialization && (t = await gt(t)), St(this._inputPipeValues, t) && (Object.keys(t).forEach((n2) => this.emit(G.Input, n2, t[n2])), this.emit(G.Inputs, t));
  }
  getInput(t) {
    return console.assert(!!t), this._inputPipeValues[t];
  }
  getInputs() {
    return this._inputPipeValues;
  }
  setOutput(t, n2) {
    console.assert(!!t);
    var a = {};
    a[t] = n2, this.setOutputs(a);
  }
  async setOutputs(t) {
    this.isInputOutputBlobSerialization && (t = await Ot(t)), St(this._outputPipeValues, t) && this.sendRpc(X.OutputsUpdate, t);
  }
  disableNotifyOnHashUrlChange() {
    window.removeEventListener("hashchange", this._onHashUrlChange);
  }
  _onHashUrlChange(t) {
    const n2 = {
      hash: window.location.hash,
      metaframe: this.id
    };
    this.sendRpc(X.HashParamsUpdate, n2);
  }
  sendRpc(t, n2) {
    if (this._isIframe) {
      const a = {
        jsonrpc: "2.0",
        id: ++this._messageSendCount,
        method: t,
        params: n2,
        iframeId: this.id,
        parentId: this._parentId
      };
      window.parent && window.parent.postMessage(a, "*");
    } else
      this.log("Cannot send JSON-RPC window message: there is no window.parent which means we are not an iframe");
  }
  onMessage(t) {
    if (typeof t.data == "object") {
      let a = t.data;
      if (a.jsonrpc === "2.0") {
        var n2 = a.method;
        if (!(n2 == at.SetupIframeServerResponse || a.parentId == this._parentId && a.iframeId == this.id)) {
          this.log(`window.message: received message but jsonrpc.parentId=${a.parentId} _parentId=${this._parentId} jsonrpc.iframeId=${a.iframeId} id=${this.id}`);
          return;
        }
        switch (n2) {
          case at.SetupIframeServerResponse:
            this._resolveSetupIframeServerResponse(a.params);
            break;
          case at.InputsUpdate:
            if (this._state !== ut.Ready)
              throw "Got InputsUpdate but metaframe is not MetaframeLoadingState.Ready";
            this.setInternalInputsAndNotify(a.params.inputs);
            break;
          case at.MessageAck:
            this.debug && this.log(`ACK: ${JSON.stringify(a)}`);
            break;
          default:
            this.debug && this.log(`window.message: unknown JSON-RPC method: ${JSON.stringify(a)}`);
            break;
        }
        this.emit(G.Message, a);
      }
    }
  }
}
nt.version = ae;
nt.ERROR = G.Error;
nt.CONNECTED = G.Connected;
nt.INPUT = G.Input;
nt.INPUTS = G.Inputs;
nt.MESSAGE = G.Message;
nt.deserializeInputs = gt;
nt.serializeInputs = Ot;
class Ae {
  constructor(t) {
    this._metaframe = t, this.requestState = this.requestState.bind(this), this.onState = this.onState.bind(this), this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.onDefinition = this.onDefinition.bind(this), this.getDefinition = this.getDefinition.bind(this), this.setDefinition = this.setDefinition.bind(this);
  }
  requestState() {
    var t = {
      method: kt.State
    };
    this._metaframe.sendRpc(X.PluginRequest, t);
  }
  onState(t) {
    const n2 = this._metaframe.onInput(ft, t);
    return this.getState() && t(this.getState()), n2;
  }
  getState() {
    return this._metaframe.getInput(ft);
  }
  setState(t) {
    this._metaframe.setOutput(ft, t);
  }
  onDefinition(t) {
    var n2 = this._metaframe.onInput(rt, t);
    return this.getDefinition() && t(this.getDefinition()), n2;
  }
  setDefinition(t) {
    this._metaframe.setOutput(rt, t);
  }
  getDefinition() {
    return this._metaframe.getInput(rt);
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d.get ? d : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a;
}
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  g !== void 0 && (e = "" + g);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const MetaframeIframe = ({
  metaframe,
  Wrapper,
  height,
  style
}) => {
  const ref = useRef(null);
  useEffect(() => {
    let cancelled = false;
    if (!metaframe) {
      return;
    }
    if (metaframe.isDisposed()) {
      return;
    }
    (async () => {
      if (metaframe.isDisposed()) {
        return;
      }
      if (cancelled) {
        return;
      }
      const iframe = await metaframe.iframe;
      if (metaframe.isDisposed()) {
        return;
      }
      if (cancelled) {
        return;
      }
      if (!(ref == null ? void 0 : ref.current)) {
        return;
      }
      if (!ref.current.firstChild || ref.current.firstChild !== iframe) {
        const child = ref.current.firstChild;
        if (child) {
          ref.current.removeChild(child);
        }
        iframe.style.cssText = `position:absolute;top:0px;width:100%;height:${height ? height : "100vh"};`;
        ref.current.appendChild(iframe);
      }
    })();
    return () => {
      var _a;
      cancelled = true;
      while ((_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.firstChild) {
        ref.current.removeChild(ref.current.firstChild);
      }
    };
  }, [metaframe, ref]);
  if (!metaframe) {
    return /* @__PURE__ */ jsx("p", {
      children: "Missing metaframe"
    });
  }
  if (Wrapper) {
    return /* @__PURE__ */ jsx(Wrapper, {
      ref,
      style: {
        position: "relative"
      }
    }, metaframe.id);
  } else {
    return /* @__PURE__ */ jsx("div", {
      ref,
      style: __spreadValues(__spreadValues({
        position: "relative"
      }, style), height ? {
        height
      } : {})
    }, metaframe.id);
  }
};
const MetaPageTemplate = {
  version: "0.3",
  metaframes: {
    embed: {
      url: ""
    }
  }
};
const MetaframeStandaloneComponent = ({
  url,
  inputs,
  onOutputs,
  onMetapageCreation,
  debug,
  height,
  style
}) => {
  const [metaframe, setMetaframe] = useState();
  const [metapage, setMetapage] = useState();
  useEffect(() => {
    const definition = Object.assign({}, __spreadValues({}, MetaPageTemplate));
    definition.metaframes.embed.url = url;
    const metapage2 = new tt();
    metapage2.debug = debug;
    metapage2.setDefinition(definition);
    setMetapage(metapage2);
    const metaframe2 = metapage2.getMetaframe("embed");
    setMetaframe(metaframe2);
    if (onOutputs) {
      metaframe2.onOutputs(onOutputs);
    }
    if (onMetapageCreation) {
      onMetapageCreation(metapage2);
    }
    return () => {
      metapage2.dispose();
    };
  }, [url, setMetaframe, onOutputs, onMetapageCreation, debug]);
  useEffect(() => {
    if (metapage && !metapage.isDisposed() && inputs) {
      metapage.setInputs({
        embed: inputs
      });
    }
  }, [metapage, inputs]);
  if (!metaframe) {
    return /* @__PURE__ */ jsx("p", {
      children: "..."
    });
  }
  return /* @__PURE__ */ jsx(MetaframeIframe, {
    metaframe,
    style,
    height
  });
};
var reactGridLayout = { exports: {} };
var ReactGridLayout$1 = {};
var lodash_isequal = { exports: {} };
(function(module, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal.process;
  var nodeUtil = function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes(n2, iteratee) {
    var index = -1, result = Array(n2);
    while (++index < n2) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }
  function cacheHas(cache, key) {
    return cache.has(key);
  }
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var nativeObjectToString = objectProto.toString;
  var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var Buffer2 = moduleExports ? root.Buffer : void 0, Symbol2 = root.Symbol, Uint8Array2 = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
  var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise2 = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap2 = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
  var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap2);
  var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }
  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map || ListCache)(),
      "string": new Hash()
    };
  }
  function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }
  function setCacheHas(value) {
    return this.__data__.has(value);
  }
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
    stack.set(array, other);
    stack.set(other, array);
    while (++index < arrLength) {
      var arrValue = array[index], othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome(other, function(othValue2, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
  }
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag:
      case dateTag:
      case numberTag:
        return eq(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag:
        return object == other + "";
      case mapTag:
        var convert = mapToArray;
      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack["delete"](object);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
  }
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }
  var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
    getTag = function(value) {
      var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKeyable(value) {
    var type3 = typeof value;
    return type3 == "string" || type3 == "number" || type3 == "symbol" || type3 == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
  }
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments = baseIsArguments(function() {
    return arguments;
  }()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArray = Array.isArray;
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction2(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }
  function isFunction2(value) {
    if (!isObject(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  function isObject(value) {
    var type3 = typeof value;
    return value != null && (type3 == "object" || type3 == "function");
  }
  function isObjectLike(value) {
    return value != null && typeof value == "object";
  }
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  function stubArray() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module.exports = isEqual;
})(lodash_isequal, lodash_isequal.exports);
function toVal(mix) {
  var k2, y, str = "";
  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (typeof mix === "object") {
    if (Array.isArray(mix)) {
      for (k2 = 0; k2 < mix.length; k2++) {
        if (mix[k2]) {
          if (y = toVal(mix[k2])) {
            str && (str += " ");
            str += y;
          }
        }
      }
    } else {
      for (k2 in mix) {
        if (mix[k2]) {
          str && (str += " ");
          str += k2;
        }
      }
    }
  }
  return str;
}
function clsx_m() {
  var i = 0, tmp, x, str = "";
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += " ");
        str += x;
      }
    }
  }
  return str;
}
var clsx_m$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": clsx_m
}, Symbol.toStringTag, { value: "Module" }));
var require$$2 = /* @__PURE__ */ getAugmentedNamespace(clsx_m$1);
var utils$1 = {};
var fastRGLPropsEqual$1 = function fastRGLPropsEqual(a, b, isEqualImpl) {
  if (a === b)
    return true;
  return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};
Object.defineProperty(utils$1, "__esModule", {
  value: true
});
utils$1.bottom = bottom;
utils$1.childrenEqual = childrenEqual;
utils$1.cloneLayout = cloneLayout;
utils$1.cloneLayoutItem = cloneLayoutItem;
utils$1.collides = collides;
utils$1.compact = compact;
utils$1.compactItem = compactItem;
utils$1.compactType = compactType;
utils$1.correctBounds = correctBounds;
utils$1.fastPositionEqual = fastPositionEqual;
utils$1.fastRGLPropsEqual = void 0;
utils$1.getAllCollisions = getAllCollisions;
utils$1.getFirstCollision = getFirstCollision;
utils$1.getLayoutItem = getLayoutItem;
utils$1.getStatics = getStatics;
utils$1.modifyLayout = modifyLayout;
utils$1.moveElement = moveElement;
utils$1.moveElementAwayFromCollision = moveElementAwayFromCollision;
utils$1.noop = void 0;
utils$1.perc = perc;
utils$1.setTopLeft = setTopLeft;
utils$1.setTransform = setTransform;
utils$1.sortLayoutItems = sortLayoutItems;
utils$1.sortLayoutItemsByColRow = sortLayoutItemsByColRow;
utils$1.sortLayoutItemsByRowCol = sortLayoutItemsByRowCol;
utils$1.synchronizeLayoutWithChildren = synchronizeLayoutWithChildren;
utils$1.validateLayout = validateLayout;
utils$1.withLayoutItem = withLayoutItem;
var _lodash$2 = _interopRequireDefault$9(lodash_isequal.exports);
var _react$3 = _interopRequireDefault$9(require$$0);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$7(Object(source), true).forEach(function(key) {
      _defineProperty$9(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function bottom(layout2) {
  var max = 0, bottomY;
  for (var i = 0, len = layout2.length; i < len; i++) {
    bottomY = layout2[i].y + layout2[i].h;
    if (bottomY > max)
      max = bottomY;
  }
  return max;
}
function cloneLayout(layout2) {
  var newLayout = Array(layout2.length);
  for (var i = 0, len = layout2.length; i < len; i++) {
    newLayout[i] = cloneLayoutItem(layout2[i]);
  }
  return newLayout;
}
function modifyLayout(layout2, layoutItem) {
  var newLayout = Array(layout2.length);
  for (var i = 0, len = layout2.length; i < len; i++) {
    if (layoutItem.i === layout2[i].i) {
      newLayout[i] = layoutItem;
    } else {
      newLayout[i] = layout2[i];
    }
  }
  return newLayout;
}
function withLayoutItem(layout2, itemKey, cb) {
  var item = getLayoutItem(layout2, itemKey);
  if (!item)
    return [layout2, null];
  item = cb(cloneLayoutItem(item));
  layout2 = modifyLayout(layout2, item);
  return [layout2, item];
}
function cloneLayoutItem(layoutItem) {
  return {
    w: layoutItem.w,
    h: layoutItem.h,
    x: layoutItem.x,
    y: layoutItem.y,
    i: layoutItem.i,
    minW: layoutItem.minW,
    maxW: layoutItem.maxW,
    minH: layoutItem.minH,
    maxH: layoutItem.maxH,
    moved: Boolean(layoutItem.moved),
    static: Boolean(layoutItem.static),
    isDraggable: layoutItem.isDraggable,
    isResizable: layoutItem.isResizable,
    resizeHandles: layoutItem.resizeHandles,
    isBounded: layoutItem.isBounded
  };
}
function childrenEqual(a, b) {
  return (0, _lodash$2.default)(_react$3.default.Children.map(a, function(c) {
    return c === null || c === void 0 ? void 0 : c.key;
  }), _react$3.default.Children.map(b, function(c) {
    return c === null || c === void 0 ? void 0 : c.key;
  }));
}
var fastRGLPropsEqual2 = fastRGLPropsEqual$1;
utils$1.fastRGLPropsEqual = fastRGLPropsEqual2;
function fastPositionEqual(a, b) {
  return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
function collides(l1, l2) {
  if (l1.i === l2.i)
    return false;
  if (l1.x + l1.w <= l2.x)
    return false;
  if (l1.x >= l2.x + l2.w)
    return false;
  if (l1.y + l1.h <= l2.y)
    return false;
  if (l1.y >= l2.y + l2.h)
    return false;
  return true;
}
function compact(layout2, compactType2, cols) {
  var compareWith = getStatics(layout2);
  var sorted = sortLayoutItems(layout2, compactType2);
  var out = Array(layout2.length);
  for (var i = 0, len = sorted.length; i < len; i++) {
    var l2 = cloneLayoutItem(sorted[i]);
    if (!l2.static) {
      l2 = compactItem(compareWith, l2, compactType2, cols, sorted);
      compareWith.push(l2);
    }
    out[layout2.indexOf(sorted[i])] = l2;
    l2.moved = false;
  }
  return out;
}
var heightWidth = {
  x: "w",
  y: "h"
};
function resolveCompactionCollision(layout2, item, moveToCoord, axis) {
  var sizeProp = heightWidth[axis];
  item[axis] += 1;
  var itemIndex = layout2.map(function(layoutItem) {
    return layoutItem.i;
  }).indexOf(item.i);
  for (var i = itemIndex + 1; i < layout2.length; i++) {
    var otherItem = layout2[i];
    if (otherItem.static)
      continue;
    if (otherItem.y > item.y + item.h)
      break;
    if (collides(item, otherItem)) {
      resolveCompactionCollision(layout2, otherItem, moveToCoord + item[sizeProp], axis);
    }
  }
  item[axis] = moveToCoord;
}
function compactItem(compareWith, l2, compactType2, cols, fullLayout) {
  var compactV = compactType2 === "vertical";
  var compactH = compactType2 === "horizontal";
  if (compactV) {
    l2.y = Math.min(bottom(compareWith), l2.y);
    while (l2.y > 0 && !getFirstCollision(compareWith, l2)) {
      l2.y--;
    }
  } else if (compactH) {
    while (l2.x > 0 && !getFirstCollision(compareWith, l2)) {
      l2.x--;
    }
  }
  var collides2;
  while (collides2 = getFirstCollision(compareWith, l2)) {
    if (compactH) {
      resolveCompactionCollision(fullLayout, l2, collides2.x + collides2.w, "x");
    } else {
      resolveCompactionCollision(fullLayout, l2, collides2.y + collides2.h, "y");
    }
    if (compactH && l2.x + l2.w > cols) {
      l2.x = cols - l2.w;
      l2.y++;
    }
  }
  l2.y = Math.max(l2.y, 0);
  l2.x = Math.max(l2.x, 0);
  return l2;
}
function correctBounds(layout2, bounds) {
  var collidesWith = getStatics(layout2);
  for (var i = 0, len = layout2.length; i < len; i++) {
    var l2 = layout2[i];
    if (l2.x + l2.w > bounds.cols)
      l2.x = bounds.cols - l2.w;
    if (l2.x < 0) {
      l2.x = 0;
      l2.w = bounds.cols;
    }
    if (!l2.static)
      collidesWith.push(l2);
    else {
      while (getFirstCollision(collidesWith, l2)) {
        l2.y++;
      }
    }
  }
  return layout2;
}
function getLayoutItem(layout2, id) {
  for (var i = 0, len = layout2.length; i < len; i++) {
    if (layout2[i].i === id)
      return layout2[i];
  }
}
function getFirstCollision(layout2, layoutItem) {
  for (var i = 0, len = layout2.length; i < len; i++) {
    if (collides(layout2[i], layoutItem))
      return layout2[i];
  }
}
function getAllCollisions(layout2, layoutItem) {
  return layout2.filter(function(l2) {
    return collides(l2, layoutItem);
  });
}
function getStatics(layout2) {
  return layout2.filter(function(l2) {
    return l2.static;
  });
}
function moveElement(layout2, l2, x, y, isUserAction, preventCollision, compactType2, cols, allowOverlap) {
  if (l2.static && l2.isDraggable !== true)
    return layout2;
  if (l2.y === y && l2.x === x)
    return layout2;
  log$2("Moving element ".concat(l2.i, " to [").concat(String(x), ",").concat(String(y), "] from [").concat(l2.x, ",").concat(l2.y, "]"));
  var oldX = l2.x;
  var oldY = l2.y;
  if (typeof x === "number")
    l2.x = x;
  if (typeof y === "number")
    l2.y = y;
  l2.moved = true;
  var sorted = sortLayoutItems(layout2, compactType2);
  var movingUp = compactType2 === "vertical" && typeof y === "number" ? oldY >= y : compactType2 === "horizontal" && typeof x === "number" ? oldX >= x : false;
  if (movingUp)
    sorted = sorted.reverse();
  var collisions = getAllCollisions(sorted, l2);
  var hasCollisions = collisions.length > 0;
  if (hasCollisions && allowOverlap) {
    return cloneLayout(layout2);
  } else if (hasCollisions && preventCollision) {
    log$2("Collision prevented on ".concat(l2.i, ", reverting."));
    l2.x = oldX;
    l2.y = oldY;
    l2.moved = false;
    return layout2;
  }
  for (var i = 0, len = collisions.length; i < len; i++) {
    var collision = collisions[i];
    log$2("Resolving collision between ".concat(l2.i, " at [").concat(l2.x, ",").concat(l2.y, "] and ").concat(collision.i, " at [").concat(collision.x, ",").concat(collision.y, "]"));
    if (collision.moved)
      continue;
    if (collision.static) {
      layout2 = moveElementAwayFromCollision(layout2, collision, l2, isUserAction, compactType2, cols);
    } else {
      layout2 = moveElementAwayFromCollision(layout2, l2, collision, isUserAction, compactType2, cols);
    }
  }
  return layout2;
}
function moveElementAwayFromCollision(layout2, collidesWith, itemToMove, isUserAction, compactType2, cols) {
  var compactH = compactType2 === "horizontal";
  var compactV = compactType2 !== "horizontal";
  var preventCollision = collidesWith.static;
  if (isUserAction) {
    isUserAction = false;
    var fakeItem = {
      x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
      y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
      w: itemToMove.w,
      h: itemToMove.h,
      i: "-1"
    };
    if (!getFirstCollision(layout2, fakeItem)) {
      log$2("Doing reverse collision on ".concat(itemToMove.i, " up to [").concat(fakeItem.x, ",").concat(fakeItem.y, "]."));
      return moveElement(layout2, itemToMove, compactH ? fakeItem.x : void 0, compactV ? fakeItem.y : void 0, isUserAction, preventCollision, compactType2, cols);
    }
  }
  return moveElement(layout2, itemToMove, compactH ? itemToMove.x + 1 : void 0, compactV ? itemToMove.y + 1 : void 0, isUserAction, preventCollision, compactType2, cols);
}
function perc(num) {
  return num * 100 + "%";
}
function setTransform(_ref) {
  var top = _ref.top, left = _ref.left, width = _ref.width, height = _ref.height;
  var translate = "translate(".concat(left, "px,").concat(top, "px)");
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    position: "absolute"
  };
}
function setTopLeft(_ref2) {
  var top = _ref2.top, left = _ref2.left, width = _ref2.width, height = _ref2.height;
  return {
    top: "".concat(top, "px"),
    left: "".concat(left, "px"),
    width: "".concat(width, "px"),
    height: "".concat(height, "px"),
    position: "absolute"
  };
}
function sortLayoutItems(layout2, compactType2) {
  if (compactType2 === "horizontal")
    return sortLayoutItemsByColRow(layout2);
  if (compactType2 === "vertical")
    return sortLayoutItemsByRowCol(layout2);
  else
    return layout2;
}
function sortLayoutItemsByRowCol(layout2) {
  return layout2.slice(0).sort(function(a, b) {
    if (a.y > b.y || a.y === b.y && a.x > b.x) {
      return 1;
    } else if (a.y === b.y && a.x === b.x) {
      return 0;
    }
    return -1;
  });
}
function sortLayoutItemsByColRow(layout2) {
  return layout2.slice(0).sort(function(a, b) {
    if (a.x > b.x || a.x === b.x && a.y > b.y) {
      return 1;
    }
    return -1;
  });
}
function synchronizeLayoutWithChildren(initialLayout, children2, cols, compactType2, allowOverlap) {
  initialLayout = initialLayout || [];
  var layout2 = [];
  _react$3.default.Children.forEach(children2, function(child) {
    if ((child === null || child === void 0 ? void 0 : child.key) == null)
      return;
    var exists = getLayoutItem(initialLayout, String(child.key));
    if (exists) {
      layout2.push(cloneLayoutItem(exists));
    } else {
      var g = child.props["data-grid"] || child.props._grid;
      if (g) {
        layout2.push(cloneLayoutItem(_objectSpread$7(_objectSpread$7({}, g), {}, {
          i: child.key
        })));
      } else {
        layout2.push(cloneLayoutItem({
          w: 1,
          h: 1,
          x: 0,
          y: bottom(layout2),
          i: String(child.key)
        }));
      }
    }
  });
  var correctedLayout = correctBounds(layout2, {
    cols
  });
  return allowOverlap ? correctedLayout : compact(correctedLayout, compactType2, cols);
}
function validateLayout(layout2) {
  var contextName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Layout";
  var subProps = ["x", "y", "w", "h"];
  if (!Array.isArray(layout2))
    throw new Error(contextName + " must be an array!");
  for (var i = 0, len = layout2.length; i < len; i++) {
    var item = layout2[i];
    for (var j = 0; j < subProps.length; j++) {
      if (typeof item[subProps[j]] !== "number") {
        throw new Error("ReactGridLayout: " + contextName + "[" + i + "]." + subProps[j] + " must be a number!");
      }
    }
  }
}
function compactType(props) {
  var _ref3 = props || {}, verticalCompact2 = _ref3.verticalCompact, compactType2 = _ref3.compactType;
  return verticalCompact2 === false ? null : compactType2;
}
function log$2() {
  return;
}
var noop = function noop2() {
};
utils$1.noop = noop;
var calculateUtils = {};
Object.defineProperty(calculateUtils, "__esModule", {
  value: true
});
calculateUtils.calcGridColWidth = calcGridColWidth;
calculateUtils.calcGridItemPosition = calcGridItemPosition;
calculateUtils.calcGridItemWHPx = calcGridItemWHPx;
calculateUtils.calcWH = calcWH;
calculateUtils.calcXY = calcXY;
calculateUtils.clamp = clamp;
function calcGridColWidth(positionParams) {
  var margin = positionParams.margin, containerPadding = positionParams.containerPadding, containerWidth = positionParams.containerWidth, cols = positionParams.cols;
  return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
function calcGridItemWHPx(gridUnits, colOrRowSize, marginPx) {
  if (!Number.isFinite(gridUnits))
    return gridUnits;
  return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
function calcGridItemPosition(positionParams, x, y, w, h, state) {
  var margin = positionParams.margin, containerPadding = positionParams.containerPadding, rowHeight = positionParams.rowHeight;
  var colWidth = calcGridColWidth(positionParams);
  var out = {};
  if (state && state.resizing) {
    out.width = Math.round(state.resizing.width);
    out.height = Math.round(state.resizing.height);
  } else {
    out.width = calcGridItemWHPx(w, colWidth, margin[0]);
    out.height = calcGridItemWHPx(h, rowHeight, margin[1]);
  }
  if (state && state.dragging) {
    out.top = Math.round(state.dragging.top);
    out.left = Math.round(state.dragging.left);
  } else {
    out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
    out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
  }
  return out;
}
function calcXY(positionParams, top, left, w, h) {
  var margin = positionParams.margin, cols = positionParams.cols, rowHeight = positionParams.rowHeight, maxRows = positionParams.maxRows;
  var colWidth = calcGridColWidth(positionParams);
  var x = Math.round((left - margin[0]) / (colWidth + margin[0]));
  var y = Math.round((top - margin[1]) / (rowHeight + margin[1]));
  x = clamp(x, 0, cols - w);
  y = clamp(y, 0, maxRows - h);
  return {
    x,
    y
  };
}
function calcWH(positionParams, width, height, x, y) {
  var margin = positionParams.margin, maxRows = positionParams.maxRows, cols = positionParams.cols, rowHeight = positionParams.rowHeight;
  var colWidth = calcGridColWidth(positionParams);
  var w = Math.round((width + margin[0]) / (colWidth + margin[0]));
  var h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
  w = clamp(w, 0, cols - x);
  h = clamp(h, 0, maxRows - y);
  return {
    w,
    h
  };
}
function clamp(num, lowerBound, upperBound) {
  return Math.max(Math.min(num, upperBound), lowerBound);
}
var GridItem$1 = {};
var propTypes$1 = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$1.exports = factoryWithThrowingShims();
}
var cjs = { exports: {} };
var Draggable$1 = {};
var domFns = {};
var shims = {};
Object.defineProperty(shims, "__esModule", {
  value: true
});
shims.dontSetMe = dontSetMe;
shims.findInArray = findInArray;
shims.int = int;
shims.isFunction = isFunction;
shims.isNum = isNum;
function findInArray(array, callback) {
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array]))
      return array[i];
  }
}
function isFunction(func) {
  return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function isNum(num) {
  return typeof num === "number" && !isNaN(num);
}
function int(a) {
  return parseInt(a, 10);
}
function dontSetMe(props, propName, componentName) {
  if (props[propName]) {
    return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
  }
}
var getPrefix$1 = {};
Object.defineProperty(getPrefix$1, "__esModule", {
  value: true
});
getPrefix$1.browserPrefixToKey = browserPrefixToKey;
getPrefix$1.browserPrefixToStyle = browserPrefixToStyle;
getPrefix$1.default = void 0;
getPrefix$1.getPrefix = getPrefix;
var prefixes = ["Moz", "Webkit", "O", "ms"];
function getPrefix() {
  var _window$document, _window$document$docu;
  var prop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window === "undefined")
    return "";
  var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
  if (!style)
    return "";
  if (prop in style)
    return "";
  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style)
      return prefixes[i];
  }
  return "";
}
function browserPrefixToKey(prop, prefix) {
  return prefix ? "".concat(prefix).concat(kebabToTitleCase(prop)) : prop;
}
function browserPrefixToStyle(prop, prefix) {
  return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function kebabToTitleCase(str) {
  var out = "";
  var shouldCapitalize = true;
  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === "-") {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}
var _default$1 = getPrefix();
getPrefix$1.default = _default$1;
function _typeof$5(obj) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$5(obj);
}
Object.defineProperty(domFns, "__esModule", {
  value: true
});
domFns.addClassName = addClassName;
domFns.addEvent = addEvent;
domFns.addUserSelectStyles = addUserSelectStyles;
domFns.createCSSTransform = createCSSTransform;
domFns.createSVGTransform = createSVGTransform;
domFns.getTouch = getTouch;
domFns.getTouchIdentifier = getTouchIdentifier;
domFns.getTranslation = getTranslation;
domFns.innerHeight = innerHeight;
domFns.innerWidth = innerWidth;
domFns.matchesSelector = matchesSelector;
domFns.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
domFns.offsetXYFromParent = offsetXYFromParent;
domFns.outerHeight = outerHeight;
domFns.outerWidth = outerWidth;
domFns.removeClassName = removeClassName;
domFns.removeEvent = removeEvent;
domFns.removeUserSelectStyles = removeUserSelectStyles;
var _shims$2 = shims;
var _getPrefix = _interopRequireWildcard$6(getPrefix$1);
function _getRequireWildcardCache$6(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$6 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$6(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$5(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$6(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$6(Object(source), true).forEach(function(key) {
      _defineProperty$8(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var matchesSelectorFunc = "";
function matchesSelector(el, selector) {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims$2.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(method) {
      return (0, _shims$2.isFunction)(el[method]);
    });
  }
  if (!(0, _shims$2.isFunction)(el[matchesSelectorFunc]))
    return false;
  return el[matchesSelectorFunc](selector);
}
function matchesSelectorAndParentsTo(el, selector, baseNode) {
  var node = el;
  do {
    if (matchesSelector(node, selector))
      return true;
    if (node === baseNode)
      return false;
    node = node.parentNode;
  } while (node);
  return false;
}
function addEvent(el, event, handler, inputOptions) {
  if (!el)
    return;
  var options = _objectSpread$6({
    capture: true
  }, inputOptions);
  if (el.addEventListener) {
    el.addEventListener(event, handler, options);
  } else if (el.attachEvent) {
    el.attachEvent("on" + event, handler);
  } else {
    el["on" + event] = handler;
  }
}
function removeEvent(el, event, handler, inputOptions) {
  if (!el)
    return;
  var options = _objectSpread$6({
    capture: true
  }, inputOptions);
  if (el.removeEventListener) {
    el.removeEventListener(event, handler, options);
  } else if (el.detachEvent) {
    el.detachEvent("on" + event, handler);
  } else {
    el["on" + event] = null;
  }
}
function outerHeight(node) {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims$2.int)(computedStyle.borderTopWidth);
  height += (0, _shims$2.int)(computedStyle.borderBottomWidth);
  return height;
}
function outerWidth(node) {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims$2.int)(computedStyle.borderLeftWidth);
  width += (0, _shims$2.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node) {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims$2.int)(computedStyle.paddingTop);
  height -= (0, _shims$2.int)(computedStyle.paddingBottom);
  return height;
}
function innerWidth(node) {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims$2.int)(computedStyle.paddingLeft);
  width -= (0, _shims$2.int)(computedStyle.paddingRight);
  return width;
}
function offsetXYFromParent(evt, offsetParent2, scale) {
  var isBody = offsetParent2 === offsetParent2.ownerDocument.body;
  var offsetParentRect = isBody ? {
    left: 0,
    top: 0
  } : offsetParent2.getBoundingClientRect();
  var x = (evt.clientX + offsetParent2.scrollLeft - offsetParentRect.left) / scale;
  var y = (evt.clientY + offsetParent2.scrollTop - offsetParentRect.top) / scale;
  return {
    x,
    y
  };
}
function createCSSTransform(controlPos, positionOffset) {
  var translation = getTranslation(controlPos, positionOffset, "px");
  return _defineProperty$8({}, (0, _getPrefix.browserPrefixToKey)("transform", _getPrefix.default), translation);
}
function createSVGTransform(controlPos, positionOffset) {
  var translation = getTranslation(controlPos, positionOffset, "");
  return translation;
}
function getTranslation(_ref2, positionOffset, unitSuffix) {
  var x = _ref2.x, y = _ref2.y;
  var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
  if (positionOffset) {
    var defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
    var defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
    translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
  }
  return translation;
}
function getTouch(e, identifier) {
  return e.targetTouches && (0, _shims$2.findInArray)(e.targetTouches, function(t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims$2.findInArray)(e.changedTouches, function(t) {
    return identifier === t.identifier;
  });
}
function getTouchIdentifier(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function addUserSelectStyles(doc) {
  if (!doc)
    return;
  var styleEl = doc.getElementById("react-draggable-style-el");
  if (!styleEl) {
    styleEl = doc.createElement("style");
    styleEl.type = "text/css";
    styleEl.id = "react-draggable-style-el";
    styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
    styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
    doc.getElementsByTagName("head")[0].appendChild(styleEl);
  }
  if (doc.body)
    addClassName(doc.body, "react-draggable-transparent-selection");
}
function removeUserSelectStyles(doc) {
  if (!doc)
    return;
  try {
    if (doc.body)
      removeClassName(doc.body, "react-draggable-transparent-selection");
    if (doc.selection) {
      doc.selection.empty();
    } else {
      var selection = (doc.defaultView || window).getSelection();
      if (selection && selection.type !== "Caret") {
        selection.removeAllRanges();
      }
    }
  } catch (e) {
  }
}
function addClassName(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) {
      el.className += " ".concat(className);
    }
  }
}
function removeClassName(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
  }
}
var positionFns = {};
Object.defineProperty(positionFns, "__esModule", {
  value: true
});
positionFns.canDragX = canDragX;
positionFns.canDragY = canDragY;
positionFns.createCoreData = createCoreData;
positionFns.createDraggableData = createDraggableData;
positionFns.getBoundPosition = getBoundPosition;
positionFns.getControlPosition = getControlPosition;
positionFns.snapToGrid = snapToGrid;
var _shims$1 = shims;
var _domFns$1 = domFns;
function getBoundPosition(draggable, x, y) {
  if (!draggable.props.bounds)
    return [x, y];
  var bounds = draggable.props.bounds;
  bounds = typeof bounds === "string" ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);
  if (typeof bounds === "string") {
    var ownerDocument = node.ownerDocument;
    var ownerWindow = ownerDocument.defaultView;
    var boundNode;
    if (bounds === "parent") {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    var boundNodeEl = boundNode;
    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
    bounds = {
      left: -node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingLeft) + (0, _shims$1.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingTop) + (0, _shims$1.int)(nodeStyle.marginTop),
      right: (0, _domFns$1.innerWidth)(boundNodeEl) - (0, _domFns$1.outerWidth)(node) - node.offsetLeft + (0, _shims$1.int)(boundNodeStyle.paddingRight) - (0, _shims$1.int)(nodeStyle.marginRight),
      bottom: (0, _domFns$1.innerHeight)(boundNodeEl) - (0, _domFns$1.outerHeight)(node) - node.offsetTop + (0, _shims$1.int)(boundNodeStyle.paddingBottom) - (0, _shims$1.int)(nodeStyle.marginBottom)
    };
  }
  if ((0, _shims$1.isNum)(bounds.right))
    x = Math.min(x, bounds.right);
  if ((0, _shims$1.isNum)(bounds.bottom))
    y = Math.min(y, bounds.bottom);
  if ((0, _shims$1.isNum)(bounds.left))
    x = Math.max(x, bounds.left);
  if ((0, _shims$1.isNum)(bounds.top))
    y = Math.max(y, bounds.top);
  return [x, y];
}
function snapToGrid(grid, pendingX, pendingY) {
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}
function canDragX(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function canDragY(draggable) {
  return draggable.props.axis === "both" || draggable.props.axis === "y";
}
function getControlPosition(e, touchIdentifier, draggableCore) {
  var touchObj = typeof touchIdentifier === "number" ? (0, _domFns$1.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === "number" && !touchObj)
    return null;
  var node = findDOMNode(draggableCore);
  var offsetParent2 = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns$1.offsetXYFromParent)(touchObj || e, offsetParent2, draggableCore.props.scale);
}
function createCoreData(draggable, x, y) {
  var state = draggable.state;
  var isStart = !(0, _shims$1.isNum)(state.lastX);
  var node = findDOMNode(draggable);
  if (isStart) {
    return {
      node,
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x,
      y
    };
  } else {
    return {
      node,
      deltaX: x - state.lastX,
      deltaY: y - state.lastY,
      lastX: state.lastX,
      lastY: state.lastY,
      x,
      y
    };
  }
}
function createDraggableData(draggable, coreData) {
  var scale = draggable.props.scale;
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX / scale,
    y: draggable.state.y + coreData.deltaY / scale,
    deltaX: coreData.deltaX / scale,
    deltaY: coreData.deltaY / scale,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}
function cloneBounds(bounds) {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}
function findDOMNode(draggable) {
  var node = draggable.findDOMNode();
  if (!node) {
    throw new Error("<DraggableCore>: Unmounted during event!");
  }
  return node;
}
var DraggableCore$2 = {};
var log$1 = {};
Object.defineProperty(log$1, "__esModule", {
  value: true
});
log$1.default = log;
function log() {
}
function _typeof$4(obj) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$4(obj);
}
Object.defineProperty(DraggableCore$2, "__esModule", {
  value: true
});
DraggableCore$2.default = void 0;
var React$5 = _interopRequireWildcard$5(require$$0);
var _propTypes$7 = _interopRequireDefault$8(propTypes$1.exports);
var _reactDom = _interopRequireDefault$8(require$$2$1);
var _domFns = domFns;
var _positionFns = positionFns;
var _shims = shims;
var _log = _interopRequireDefault$8(log$1);
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$5(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$5 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$5(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$4(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$5(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$6(subClass, superClass);
}
function _setPrototypeOf$6(o, p2) {
  _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$6(o, p2);
}
function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$4(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$4(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$4(this, result);
  };
}
function _possibleConstructorReturn$4(self2, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$4(self2);
}
function _assertThisInitialized$4(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$4(o);
}
function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var eventsFor = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
var dragEventFor = eventsFor.mouse;
var DraggableCore$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits$4(DraggableCore2, _React$Component);
  var _super = _createSuper$4(DraggableCore2);
  function DraggableCore2() {
    var _this;
    _classCallCheck$4(this, DraggableCore2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$7(_assertThisInitialized$4(_this), "state", {
      dragging: false,
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: null
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "mounted", false);
    _defineProperty$7(_assertThisInitialized$4(_this), "handleDragStart", function(e) {
      _this.props.onMouseDown(e);
      if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0)
        return false;
      var thisNode = _this.findDOMNode();
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error("<DraggableCore> not mounted on DragStart!");
      }
      var ownerDocument = thisNode.ownerDocument;
      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }
      if (e.type === "touchstart")
        e.preventDefault();
      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.setState({
        touchIdentifier
      });
      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _assertThisInitialized$4(_this));
      if (position == null)
        return;
      var x = position.x, y = position.y;
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized$4(_this), x, y);
      (0, _log.default)("DraggableCore: handleDragStart: %j", coreEvent);
      (0, _log.default)("calling", _this.props.onStart);
      var shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false || _this.mounted === false)
        return;
      if (_this.props.enableUserSelectHack)
        (0, _domFns.addUserSelectStyles)(ownerDocument);
      _this.setState({
        dragging: true,
        lastX: x,
        lastY: y
      });
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "handleDrag", function(e) {
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized$4(_this));
      if (position == null)
        return;
      var x = position.x, y = position.y;
      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX, deltaY = y - _this.state.lastY;
        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
        var _snapToGrid2 = _slicedToArray$1(_snapToGrid, 2);
        deltaX = _snapToGrid2[0];
        deltaY = _snapToGrid2[1];
        if (!deltaX && !deltaY)
          return;
        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized$4(_this), x, y);
      (0, _log.default)("DraggableCore: handleDrag: %j", coreEvent);
      var shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false || _this.mounted === false) {
        try {
          _this.handleDragStop(new MouseEvent("mouseup"));
        } catch (err) {
          var event = document.createEvent("MouseEvents");
          event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }
      _this.setState({
        lastX: x,
        lastY: y
      });
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "handleDragStop", function(e) {
      if (!_this.state.dragging)
        return;
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _assertThisInitialized$4(_this));
      if (position == null)
        return;
      var x = position.x, y = position.y;
      if (Array.isArray(_this.props.grid)) {
        var deltaX = x - _this.state.lastX || 0;
        var deltaY = y - _this.state.lastY || 0;
        var _snapToGrid3 = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
        var _snapToGrid4 = _slicedToArray$1(_snapToGrid3, 2);
        deltaX = _snapToGrid4[0];
        deltaY = _snapToGrid4[1];
        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
      }
      var coreEvent = (0, _positionFns.createCoreData)(_assertThisInitialized$4(_this), x, y);
      var shouldContinue = _this.props.onStop(e, coreEvent);
      if (shouldContinue === false || _this.mounted === false)
        return false;
      var thisNode = _this.findDOMNode();
      if (thisNode) {
        if (_this.props.enableUserSelectHack)
          (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }
      (0, _log.default)("DraggableCore: handleDragStop: %j", coreEvent);
      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });
      if (thisNode) {
        (0, _log.default)("DraggableCore: Removing handlers");
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "onMouseDown", function(e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStart(e);
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "onMouseUp", function(e) {
      dragEventFor = eventsFor.mouse;
      return _this.handleDragStop(e);
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "onTouchStart", function(e) {
      dragEventFor = eventsFor.touch;
      return _this.handleDragStart(e);
    });
    _defineProperty$7(_assertThisInitialized$4(_this), "onTouchEnd", function(e) {
      dragEventFor = eventsFor.touch;
      return _this.handleDragStop(e);
    });
    return _this;
  }
  _createClass$4(DraggableCore2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      var thisNode = this.findDOMNode();
      if (thisNode) {
        (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      var thisNode = this.findDOMNode();
      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
          passive: false
        });
        if (this.props.enableUserSelectHack)
          (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }
  }, {
    key: "findDOMNode",
    value: function findDOMNode2() {
      var _this$props, _this$props2, _this$props2$nodeRef;
      return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : _reactDom.default.findDOMNode(this);
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */ React$5.cloneElement(React$5.Children.only(this.props.children), {
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);
  return DraggableCore2;
}(React$5.Component);
DraggableCore$2.default = DraggableCore$1;
_defineProperty$7(DraggableCore$1, "displayName", "DraggableCore");
_defineProperty$7(DraggableCore$1, "propTypes", {
  allowAnyClick: _propTypes$7.default.bool,
  disabled: _propTypes$7.default.bool,
  enableUserSelectHack: _propTypes$7.default.bool,
  offsetParent: function offsetParent(props, propName) {
    if (props[propName] && props[propName].nodeType !== 1) {
      throw new Error("Draggable's offsetParent must be a DOM Node.");
    }
  },
  grid: _propTypes$7.default.arrayOf(_propTypes$7.default.number),
  handle: _propTypes$7.default.string,
  cancel: _propTypes$7.default.string,
  nodeRef: _propTypes$7.default.object,
  onStart: _propTypes$7.default.func,
  onDrag: _propTypes$7.default.func,
  onStop: _propTypes$7.default.func,
  onMouseDown: _propTypes$7.default.func,
  scale: _propTypes$7.default.number,
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
_defineProperty$7(DraggableCore$1, "defaultProps", {
  allowAnyClick: false,
  disabled: false,
  enableUserSelectHack: true,
  onStart: function onStart() {
  },
  onDrag: function onDrag() {
  },
  onStop: function onStop() {
  },
  onMouseDown: function onMouseDown() {
  },
  scale: 1
});
(function(exports) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return _typeof2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, _typeof2(obj);
  }
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "DraggableCore", {
    enumerable: true,
    get: function get() {
      return _DraggableCore.default;
    }
  });
  exports.default = void 0;
  var React2 = _interopRequireWildcard2(require$$0);
  var _propTypes3 = _interopRequireDefault2(propTypes$1.exports);
  var _reactDom2 = _interopRequireDefault2(require$$2$1);
  var _clsx2 = _interopRequireDefault2(require$$2);
  var _domFns2 = domFns;
  var _positionFns2 = positionFns;
  var _shims2 = shims;
  var _DraggableCore = _interopRequireDefault2(DraggableCore$2);
  var _log2 = _interopRequireDefault2(log$1);
  var _excluded2 = ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"];
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _getRequireWildcardCache2(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
    var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
    return (_getRequireWildcardCache2 = function _getRequireWildcardCache3(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard2(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof2(obj) !== "object" && typeof obj !== "function") {
      return { default: obj };
    }
    var cache = _getRequireWildcardCache2(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  function _extends2() {
    _extends2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends2.apply(this, arguments);
  }
  function _objectWithoutProperties2(source, excluded) {
    if (source == null)
      return {};
    var target = _objectWithoutPropertiesLoose2(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
          continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
          continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose2(source, excluded) {
    if (source == null)
      return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty2(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _slicedToArray2(arr, i) {
    return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
  }
  function _nonIterableRest2() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _unsupportedIterableToArray2(o, minLen) {
    if (!o)
      return;
    if (typeof o === "string")
      return _arrayLikeToArray2(o, minLen);
    var n2 = Object.prototype.toString.call(o).slice(8, -1);
    if (n2 === "Object" && o.constructor)
      n2 = o.constructor.name;
    if (n2 === "Map" || n2 === "Set")
      return Array.from(o);
    if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
      return _arrayLikeToArray2(o, minLen);
  }
  function _arrayLikeToArray2(arr, len) {
    if (len == null || len > arr.length)
      len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
  function _iterableToArrayLimit2(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null)
      return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e2;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i)
          break;
      }
    } catch (err) {
      _d = true;
      _e2 = err;
    } finally {
      try {
        if (!_n && _i["return"] != null)
          _i["return"]();
      } finally {
        if (_d)
          throw _e2;
      }
    }
    return _arr;
  }
  function _arrayWithHoles2(arr) {
    if (Array.isArray(arr))
      return arr;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass2(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
    Object.defineProperty(subClass, "prototype", { writable: false });
    if (superClass)
      _setPrototypeOf2(subClass, superClass);
  }
  function _setPrototypeOf2(o, p2) {
    _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
      o2.__proto__ = p3;
      return o2;
    };
    return _setPrototypeOf2(o, p2);
  }
  function _createSuper2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf2(Derived), result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf2(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn2(this, result);
    };
  }
  function _possibleConstructorReturn2(self2, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized2(self2);
  }
  function _assertThisInitialized2(self2) {
    if (self2 === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self2;
  }
  function _isNativeReflectConstruct2() {
    if (typeof Reflect === "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy === "function")
      return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf2(o) {
    _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf3(o2) {
      return o2.__proto__ || Object.getPrototypeOf(o2);
    };
    return _getPrototypeOf2(o);
  }
  function _defineProperty2(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var Draggable2 = /* @__PURE__ */ function(_React$Component) {
    _inherits2(Draggable3, _React$Component);
    var _super = _createSuper2(Draggable3);
    function Draggable3(props) {
      var _this;
      _classCallCheck2(this, Draggable3);
      _this = _super.call(this, props);
      _defineProperty2(_assertThisInitialized2(_this), "onDragStart", function(e, coreData) {
        (0, _log2.default)("Draggable: onDragStart: %j", coreData);
        var shouldStart = _this.props.onStart(e, (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData));
        if (shouldStart === false)
          return false;
        _this.setState({
          dragging: true,
          dragged: true
        });
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDrag", function(e, coreData) {
        if (!_this.state.dragging)
          return false;
        (0, _log2.default)("Draggable: onDrag: %j", coreData);
        var uiData = (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData);
        var newState = {
          x: uiData.x,
          y: uiData.y
        };
        if (_this.props.bounds) {
          var x = newState.x, y = newState.y;
          newState.x += _this.state.slackX;
          newState.y += _this.state.slackY;
          var _getBoundPosition = (0, _positionFns2.getBoundPosition)(_assertThisInitialized2(_this), newState.x, newState.y), _getBoundPosition2 = _slicedToArray2(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
          newState.x = newStateX;
          newState.y = newStateY;
          newState.slackX = _this.state.slackX + (x - newState.x);
          newState.slackY = _this.state.slackY + (y - newState.y);
          uiData.x = newState.x;
          uiData.y = newState.y;
          uiData.deltaX = newState.x - _this.state.x;
          uiData.deltaY = newState.y - _this.state.y;
        }
        var shouldUpdate = _this.props.onDrag(e, uiData);
        if (shouldUpdate === false)
          return false;
        _this.setState(newState);
      });
      _defineProperty2(_assertThisInitialized2(_this), "onDragStop", function(e, coreData) {
        if (!_this.state.dragging)
          return false;
        var shouldContinue = _this.props.onStop(e, (0, _positionFns2.createDraggableData)(_assertThisInitialized2(_this), coreData));
        if (shouldContinue === false)
          return false;
        (0, _log2.default)("Draggable: onDragStop: %j", coreData);
        var newState = {
          dragging: false,
          slackX: 0,
          slackY: 0
        };
        var controlled = Boolean(_this.props.position);
        if (controlled) {
          var _this$props$position = _this.props.position, x = _this$props$position.x, y = _this$props$position.y;
          newState.x = x;
          newState.y = y;
        }
        _this.setState(newState);
      });
      _this.state = {
        dragging: false,
        dragged: false,
        x: props.position ? props.position.x : props.defaultPosition.x,
        y: props.position ? props.position.y : props.defaultPosition.y,
        prevPropsPosition: _objectSpread2({}, props.position),
        slackX: 0,
        slackY: 0,
        isElementSVG: false
      };
      if (props.position && !(props.onDrag || props.onStop)) {
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
      return _this;
    }
    _createClass2(Draggable3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) {
          this.setState({
            isElementSVG: true
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.setState({
          dragging: false
        });
      }
    }, {
      key: "findDOMNode",
      value: function findDOMNode2() {
        var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : _reactDom2.default.findDOMNode(this);
      }
    }, {
      key: "render",
      value: function render() {
        var _clsx3;
        var _this$props2 = this.props;
        _this$props2.axis;
        _this$props2.bounds;
        var children2 = _this$props2.children, defaultPosition = _this$props2.defaultPosition, defaultClassName = _this$props2.defaultClassName, defaultClassNameDragging = _this$props2.defaultClassNameDragging, defaultClassNameDragged = _this$props2.defaultClassNameDragged, position = _this$props2.position, positionOffset = _this$props2.positionOffset;
        _this$props2.scale;
        var draggableCoreProps = _objectWithoutProperties2(_this$props2, _excluded2);
        var style = {};
        var svgTransform = null;
        var controlled = Boolean(position);
        var draggable = !controlled || this.state.dragging;
        var validPosition = position || defaultPosition;
        var transformOpts = {
          x: (0, _positionFns2.canDragX)(this) && draggable ? this.state.x : validPosition.x,
          y: (0, _positionFns2.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        if (this.state.isElementSVG) {
          svgTransform = (0, _domFns2.createSVGTransform)(transformOpts, positionOffset);
        } else {
          style = (0, _domFns2.createCSSTransform)(transformOpts, positionOffset);
        }
        var className = (0, _clsx2.default)(children2.props.className || "", defaultClassName, (_clsx3 = {}, _defineProperty2(_clsx3, defaultClassNameDragging, this.state.dragging), _defineProperty2(_clsx3, defaultClassNameDragged, this.state.dragged), _clsx3));
        return /* @__PURE__ */ React2.createElement(_DraggableCore.default, _extends2({}, draggableCoreProps, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ React2.cloneElement(React2.Children.only(children2), {
          className,
          style: _objectSpread2(_objectSpread2({}, children2.props.style), style),
          transform: svgTransform
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, _ref2) {
        var position = _ref.position;
        var prevPropsPosition = _ref2.prevPropsPosition;
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
          (0, _log2.default)("Draggable: getDerivedStateFromProps %j", {
            position,
            prevPropsPosition
          });
          return {
            x: position.x,
            y: position.y,
            prevPropsPosition: _objectSpread2({}, position)
          };
        }
        return null;
      }
    }]);
    return Draggable3;
  }(React2.Component);
  exports.default = Draggable2;
  _defineProperty2(Draggable2, "displayName", "Draggable");
  _defineProperty2(Draggable2, "propTypes", _objectSpread2(_objectSpread2({}, _DraggableCore.default.propTypes), {}, {
    axis: _propTypes3.default.oneOf(["both", "x", "y", "none"]),
    bounds: _propTypes3.default.oneOfType([_propTypes3.default.shape({
      left: _propTypes3.default.number,
      right: _propTypes3.default.number,
      top: _propTypes3.default.number,
      bottom: _propTypes3.default.number
    }), _propTypes3.default.string, _propTypes3.default.oneOf([false])]),
    defaultClassName: _propTypes3.default.string,
    defaultClassNameDragging: _propTypes3.default.string,
    defaultClassNameDragged: _propTypes3.default.string,
    defaultPosition: _propTypes3.default.shape({
      x: _propTypes3.default.number,
      y: _propTypes3.default.number
    }),
    positionOffset: _propTypes3.default.shape({
      x: _propTypes3.default.oneOfType([_propTypes3.default.number, _propTypes3.default.string]),
      y: _propTypes3.default.oneOfType([_propTypes3.default.number, _propTypes3.default.string])
    }),
    position: _propTypes3.default.shape({
      x: _propTypes3.default.number,
      y: _propTypes3.default.number
    }),
    className: _shims2.dontSetMe,
    style: _shims2.dontSetMe,
    transform: _shims2.dontSetMe
  }));
  _defineProperty2(Draggable2, "defaultProps", _objectSpread2(_objectSpread2({}, _DraggableCore.default.defaultProps), {}, {
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  }));
})(Draggable$1);
var _require = Draggable$1, Draggable = _require.default, DraggableCore = _require.DraggableCore;
cjs.exports = Draggable;
cjs.exports.default = Draggable;
cjs.exports.DraggableCore = DraggableCore;
var reactResizable = { exports: {} };
var Resizable$1 = {};
var utils = {};
utils.__esModule = true;
utils.cloneElement = cloneElement;
var _react$2 = _interopRequireDefault$7(require$$0);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function(key) {
        _defineProperty$6(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function cloneElement(element, props) {
  if (props.style && element.props.style) {
    props.style = _objectSpread$5(_objectSpread$5({}, element.props.style), props.style);
  }
  if (props.className && element.props.className) {
    props.className = element.props.className + " " + props.className;
  }
  return /* @__PURE__ */ _react$2.default.cloneElement(element, props);
}
var propTypes = {};
propTypes.__esModule = true;
propTypes.resizableProps = void 0;
var _propTypes$6 = _interopRequireDefault$6(propTypes$1.exports);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var resizableProps = {
  axis: _propTypes$6.default.oneOf(["both", "x", "y", "none"]),
  className: _propTypes$6.default.string,
  children: _propTypes$6.default.element.isRequired,
  draggableOpts: _propTypes$6.default.shape({
    allowAnyClick: _propTypes$6.default.bool,
    cancel: _propTypes$6.default.string,
    children: _propTypes$6.default.node,
    disabled: _propTypes$6.default.bool,
    enableUserSelectHack: _propTypes$6.default.bool,
    offsetParent: _propTypes$6.default.node,
    grid: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
    handle: _propTypes$6.default.string,
    nodeRef: _propTypes$6.default.object,
    onStart: _propTypes$6.default.func,
    onDrag: _propTypes$6.default.func,
    onStop: _propTypes$6.default.func,
    onMouseDown: _propTypes$6.default.func,
    scale: _propTypes$6.default.number
  }),
  height: _propTypes$6.default.number.isRequired,
  handle: _propTypes$6.default.oneOfType([_propTypes$6.default.node, _propTypes$6.default.func]),
  handleSize: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  lockAspectRatio: _propTypes$6.default.bool,
  maxConstraints: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  minConstraints: _propTypes$6.default.arrayOf(_propTypes$6.default.number),
  onResizeStop: _propTypes$6.default.func,
  onResizeStart: _propTypes$6.default.func,
  onResize: _propTypes$6.default.func,
  resizeHandles: _propTypes$6.default.arrayOf(_propTypes$6.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
  transformScale: _propTypes$6.default.number,
  width: _propTypes$6.default.number.isRequired
};
propTypes.resizableProps = resizableProps;
Resizable$1.__esModule = true;
Resizable$1.default = void 0;
var React$4 = _interopRequireWildcard$4(require$$0);
var _reactDraggable$1 = cjs.exports;
var _utils$4 = utils;
var _propTypes$5 = propTypes;
var _excluded$3 = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
function _getRequireWildcardCache$4(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$4 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$4(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$4(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends$3() {
  _extends$3 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function(key) {
        _defineProperty$5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$5(subClass, superClass);
}
function _setPrototypeOf$5(o, p2) {
  _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$5(o, p2);
}
var Resizable = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose$1(Resizable2, _React$Component);
  function Resizable2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleRefs = {};
    _this.lastHandleRect = null;
    _this.slack = null;
    return _this;
  }
  var _proto = Resizable2.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.resetData();
  };
  _proto.resetData = function resetData() {
    this.lastHandleRect = this.slack = null;
  };
  _proto.runConstraints = function runConstraints(width, height) {
    var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
    if (!minConstraints && !maxConstraints && !lockAspectRatio)
      return [width, height];
    if (lockAspectRatio) {
      var ratio = this.props.width / this.props.height;
      var deltaW = width - this.props.width;
      var deltaH = height - this.props.height;
      if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) {
        height = width / ratio;
      } else {
        width = height * ratio;
      }
    }
    var oldW = width, oldH = height;
    var _ref = this.slack || [0, 0], slackW = _ref[0], slackH = _ref[1];
    width += slackW;
    height += slackH;
    if (minConstraints) {
      width = Math.max(minConstraints[0], width);
      height = Math.max(minConstraints[1], height);
    }
    if (maxConstraints) {
      width = Math.min(maxConstraints[0], width);
      height = Math.min(maxConstraints[1], height);
    }
    this.slack = [slackW + (oldW - width), slackH + (oldH - height)];
    return [width, height];
  };
  _proto.resizeHandler = function resizeHandler(handlerName, axis) {
    var _this2 = this;
    return function(e, _ref2) {
      var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
      if (handlerName === "onResizeStart")
        _this2.resetData();
      var canDragX2 = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis !== "n" && axis !== "s";
      var canDragY2 = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis !== "e" && axis !== "w";
      if (!canDragX2 && !canDragY2)
        return;
      var axisV = axis[0];
      var axisH = axis[axis.length - 1];
      var handleRect = node.getBoundingClientRect();
      if (_this2.lastHandleRect != null) {
        if (axisH === "w") {
          var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
          deltaX += deltaLeftSinceLast;
        }
        if (axisV === "n") {
          var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
          deltaY += deltaTopSinceLast;
        }
      }
      _this2.lastHandleRect = handleRect;
      if (axisH === "w")
        deltaX = -deltaX;
      if (axisV === "n")
        deltaY = -deltaY;
      var width = _this2.props.width + (canDragX2 ? deltaX / _this2.props.transformScale : 0);
      var height = _this2.props.height + (canDragY2 ? deltaY / _this2.props.transformScale : 0);
      var _this2$runConstraints = _this2.runConstraints(width, height);
      width = _this2$runConstraints[0];
      height = _this2$runConstraints[1];
      var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
      var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
      var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
      if (cb && !shouldSkipCb) {
        e.persist == null ? void 0 : e.persist();
        cb(e, {
          node,
          size: {
            width,
            height
          },
          handle: axis
        });
      }
      if (handlerName === "onResizeStop")
        _this2.resetData();
    };
  };
  _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
    var handle = this.props.handle;
    if (!handle) {
      return /* @__PURE__ */ React$4.createElement("span", {
        className: "react-resizable-handle react-resizable-handle-" + handleAxis,
        ref
      });
    }
    if (typeof handle === "function") {
      return handle(handleAxis, ref);
    }
    var isDOMElement = typeof handle.type === "string";
    var props = _objectSpread$4({
      ref
    }, isDOMElement ? {} : {
      handleAxis
    });
    return /* @__PURE__ */ React$4.cloneElement(handle, props);
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props, children2 = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts;
    _this$props2.width;
    _this$props2.height;
    _this$props2.handle;
    _this$props2.handleSize;
    _this$props2.lockAspectRatio;
    _this$props2.axis;
    _this$props2.minConstraints;
    _this$props2.maxConstraints;
    _this$props2.onResize;
    _this$props2.onResizeStop;
    _this$props2.onResizeStart;
    var resizeHandles = _this$props2.resizeHandles;
    _this$props2.transformScale;
    var p2 = _objectWithoutPropertiesLoose$3(_this$props2, _excluded$3);
    return (0, _utils$4.cloneElement)(children2, _objectSpread$4(_objectSpread$4({}, p2), {}, {
      className: (className ? className + " " : "") + "react-resizable",
      children: [].concat(children2.props.children, resizeHandles.map(function(handleAxis) {
        var _this3$handleRefs$han;
        var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /* @__PURE__ */ React$4.createRef();
        return /* @__PURE__ */ React$4.createElement(_reactDraggable$1.DraggableCore, _extends$3({}, draggableOpts, {
          nodeRef: ref,
          key: "resizableHandle-" + handleAxis,
          onStop: _this3.resizeHandler("onResizeStop", handleAxis),
          onStart: _this3.resizeHandler("onResizeStart", handleAxis),
          onDrag: _this3.resizeHandler("onResize", handleAxis)
        }), _this3.renderResizeHandle(handleAxis, ref));
      }))
    }));
  };
  return Resizable2;
}(React$4.Component);
Resizable$1.default = Resizable;
Resizable.propTypes = _propTypes$5.resizableProps;
Resizable.defaultProps = {
  axis: "both",
  handleSize: [20, 20],
  lockAspectRatio: false,
  minConstraints: [20, 20],
  maxConstraints: [Infinity, Infinity],
  resizeHandles: ["se"],
  transformScale: 1
};
var ResizableBox$1 = {};
ResizableBox$1.__esModule = true;
ResizableBox$1.default = void 0;
var React$3 = _interopRequireWildcard$3(require$$0);
var _propTypes$4 = _interopRequireDefault$5(propTypes$1.exports);
var _Resizable = _interopRequireDefault$5(Resizable$1);
var _propTypes2 = propTypes;
var _excluded$2 = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$3(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$3 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$3(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$3(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function(key) {
        _defineProperty$4(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$4(subClass, superClass);
}
function _setPrototypeOf$4(o, p2) {
  _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$4(o, p2);
}
var ResizableBox = /* @__PURE__ */ function(_React$Component) {
  _inheritsLoose(ResizableBox2, _React$Component);
  function ResizableBox2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      width: _this.props.width,
      height: _this.props.height,
      propsWidth: _this.props.width,
      propsHeight: _this.props.height
    };
    _this.onResize = function(e, data) {
      var size = data.size;
      if (_this.props.onResize) {
        e.persist == null ? void 0 : e.persist();
        _this.setState(size, function() {
          return _this.props.onResize && _this.props.onResize(e, data);
        });
      } else {
        _this.setState(size);
      }
    };
    return _this;
  }
  ResizableBox2.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (state.propsWidth !== props.width || state.propsHeight !== props.height) {
      return {
        width: props.width,
        height: props.height,
        propsWidth: props.width,
        propsHeight: props.height
      };
    }
    return null;
  };
  var _proto = ResizableBox2.prototype;
  _proto.render = function render() {
    var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize;
    _this$props.onResize;
    var onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis;
    _this$props.width;
    _this$props.height;
    var resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = _objectWithoutPropertiesLoose$2(_this$props, _excluded$2);
    return /* @__PURE__ */ React$3.createElement(_Resizable.default, {
      axis,
      draggableOpts,
      handle,
      handleSize,
      height: this.state.height,
      lockAspectRatio,
      maxConstraints,
      minConstraints,
      onResizeStart,
      onResize: this.onResize,
      onResizeStop,
      resizeHandles,
      transformScale,
      width: this.state.width
    }, /* @__PURE__ */ React$3.createElement("div", _extends$2({}, props, {
      style: _objectSpread$3(_objectSpread$3({}, style), {}, {
        width: this.state.width + "px",
        height: this.state.height + "px"
      })
    })));
  };
  return ResizableBox2;
}(React$3.Component);
ResizableBox$1.default = ResizableBox;
ResizableBox.propTypes = _objectSpread$3(_objectSpread$3({}, _propTypes2.resizableProps), {}, {
  children: _propTypes$4.default.element
});
reactResizable.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
reactResizable.exports.Resizable = Resizable$1.default;
reactResizable.exports.ResizableBox = ResizableBox$1.default;
var ReactGridLayoutPropTypes = {};
Object.defineProperty(ReactGridLayoutPropTypes, "__esModule", {
  value: true
});
ReactGridLayoutPropTypes.resizeHandleType = ReactGridLayoutPropTypes.resizeHandleAxesType = ReactGridLayoutPropTypes.default = void 0;
var _propTypes$3 = _interopRequireDefault$4(propTypes$1.exports);
var _react$1 = _interopRequireDefault$4(require$$0);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var resizeHandleAxesType = _propTypes$3.default.arrayOf(_propTypes$3.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"]));
ReactGridLayoutPropTypes.resizeHandleAxesType = resizeHandleAxesType;
var resizeHandleType = _propTypes$3.default.oneOfType([_propTypes$3.default.node, _propTypes$3.default.func]);
ReactGridLayoutPropTypes.resizeHandleType = resizeHandleType;
var _default = {
  className: _propTypes$3.default.string,
  style: _propTypes$3.default.object,
  width: _propTypes$3.default.number,
  autoSize: _propTypes$3.default.bool,
  cols: _propTypes$3.default.number,
  draggableCancel: _propTypes$3.default.string,
  draggableHandle: _propTypes$3.default.string,
  verticalCompact: function verticalCompact(props) {
    if (props.verticalCompact === false && false) {
      console.warn('`verticalCompact` on <ReactGridLayout> is deprecated and will be removed soon. Use `compactType`: "horizontal" | "vertical" | null.');
    }
  },
  compactType: _propTypes$3.default.oneOf(["vertical", "horizontal"]),
  layout: function layout(props) {
    var layout2 = props.layout;
    if (layout2 === void 0)
      return;
    utils$1.validateLayout(layout2, "layout");
  },
  margin: _propTypes$3.default.arrayOf(_propTypes$3.default.number),
  containerPadding: _propTypes$3.default.arrayOf(_propTypes$3.default.number),
  rowHeight: _propTypes$3.default.number,
  maxRows: _propTypes$3.default.number,
  isBounded: _propTypes$3.default.bool,
  isDraggable: _propTypes$3.default.bool,
  isResizable: _propTypes$3.default.bool,
  allowOverlap: _propTypes$3.default.bool,
  preventCollision: _propTypes$3.default.bool,
  useCSSTransforms: _propTypes$3.default.bool,
  transformScale: _propTypes$3.default.number,
  isDroppable: _propTypes$3.default.bool,
  resizeHandles: resizeHandleAxesType,
  resizeHandle: resizeHandleType,
  onLayoutChange: _propTypes$3.default.func,
  onDragStart: _propTypes$3.default.func,
  onDrag: _propTypes$3.default.func,
  onDragStop: _propTypes$3.default.func,
  onResizeStart: _propTypes$3.default.func,
  onResize: _propTypes$3.default.func,
  onResizeStop: _propTypes$3.default.func,
  onDrop: _propTypes$3.default.func,
  droppingItem: _propTypes$3.default.shape({
    i: _propTypes$3.default.string.isRequired,
    w: _propTypes$3.default.number.isRequired,
    h: _propTypes$3.default.number.isRequired
  }),
  children: function children(props, propName) {
    var children2 = props[propName];
    var keys = {};
    _react$1.default.Children.forEach(children2, function(child) {
      if ((child === null || child === void 0 ? void 0 : child.key) == null)
        return;
      if (keys[child.key]) {
        throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
      }
      keys[child.key] = true;
    });
  },
  innerRef: _propTypes$3.default.any
};
ReactGridLayoutPropTypes.default = _default;
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
Object.defineProperty(GridItem$1, "__esModule", {
  value: true
});
GridItem$1.default = void 0;
var _react = _interopRequireDefault$3(require$$0);
var _propTypes$2 = _interopRequireDefault$3(propTypes$1.exports);
var _reactDraggable = cjs.exports;
var _reactResizable = reactResizable.exports;
var _utils$3 = utils$1;
var _calculateUtils$1 = calculateUtils;
var _ReactGridLayoutPropTypes$1 = ReactGridLayoutPropTypes;
var _clsx$2 = _interopRequireDefault$3(require$$2);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$3(subClass, superClass);
}
function _setPrototypeOf$3(o, p2) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$3(o, p2);
}
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$3(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$3(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$3(this, result);
  };
}
function _possibleConstructorReturn$3(self2, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$3(self2);
}
function _assertThisInitialized$3(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$3(o);
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var GridItem = /* @__PURE__ */ function(_React$Component) {
  _inherits$3(GridItem2, _React$Component);
  var _super = _createSuper$3(GridItem2);
  function GridItem2() {
    var _this;
    _classCallCheck$3(this, GridItem2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$3(_assertThisInitialized$3(_this), "state", {
      resizing: null,
      dragging: null,
      className: ""
    });
    _defineProperty$3(_assertThisInitialized$3(_this), "elementRef", /* @__PURE__ */ _react.default.createRef());
    _defineProperty$3(_assertThisInitialized$3(_this), "onDragStart", function(e, _ref) {
      var node = _ref.node;
      var _this$props = _this.props, onDragStart = _this$props.onDragStart, transformScale = _this$props.transformScale;
      if (!onDragStart)
        return;
      var newPosition = {
        top: 0,
        left: 0
      };
      var offsetParent2 = node.offsetParent;
      if (!offsetParent2)
        return;
      var parentRect = offsetParent2.getBoundingClientRect();
      var clientRect = node.getBoundingClientRect();
      var cLeft = clientRect.left / transformScale;
      var pLeft = parentRect.left / transformScale;
      var cTop = clientRect.top / transformScale;
      var pTop = parentRect.top / transformScale;
      newPosition.left = cLeft - pLeft + offsetParent2.scrollLeft;
      newPosition.top = cTop - pTop + offsetParent2.scrollTop;
      _this.setState({
        dragging: newPosition
      });
      var _calcXY = (0, _calculateUtils$1.calcXY)(_this.getPositionParams(), newPosition.top, newPosition.left, _this.props.w, _this.props.h), x = _calcXY.x, y = _calcXY.y;
      return onDragStart.call(_assertThisInitialized$3(_this), _this.props.i, x, y, {
        e,
        node,
        newPosition
      });
    });
    _defineProperty$3(_assertThisInitialized$3(_this), "onDrag", function(e, _ref2) {
      var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
      var onDrag2 = _this.props.onDrag;
      if (!onDrag2)
        return;
      if (!_this.state.dragging) {
        throw new Error("onDrag called before onDragStart.");
      }
      var top = _this.state.dragging.top + deltaY;
      var left = _this.state.dragging.left + deltaX;
      var _this$props2 = _this.props, isBounded = _this$props2.isBounded, i = _this$props2.i, w = _this$props2.w, h = _this$props2.h, containerWidth = _this$props2.containerWidth;
      var positionParams = _this.getPositionParams();
      if (isBounded) {
        var offsetParent2 = node.offsetParent;
        if (offsetParent2) {
          var _this$props3 = _this.props, margin = _this$props3.margin, rowHeight = _this$props3.rowHeight;
          var bottomBoundary = offsetParent2.clientHeight - (0, _calculateUtils$1.calcGridItemWHPx)(h, rowHeight, margin[1]);
          top = (0, _calculateUtils$1.clamp)(top, 0, bottomBoundary);
          var colWidth = (0, _calculateUtils$1.calcGridColWidth)(positionParams);
          var rightBoundary = containerWidth - (0, _calculateUtils$1.calcGridItemWHPx)(w, colWidth, margin[0]);
          left = (0, _calculateUtils$1.clamp)(left, 0, rightBoundary);
        }
      }
      var newPosition = {
        top,
        left
      };
      _this.setState({
        dragging: newPosition
      });
      var _calcXY2 = (0, _calculateUtils$1.calcXY)(positionParams, top, left, w, h), x = _calcXY2.x, y = _calcXY2.y;
      return onDrag2.call(_assertThisInitialized$3(_this), i, x, y, {
        e,
        node,
        newPosition
      });
    });
    _defineProperty$3(_assertThisInitialized$3(_this), "onDragStop", function(e, _ref3) {
      var node = _ref3.node;
      var onDragStop = _this.props.onDragStop;
      if (!onDragStop)
        return;
      if (!_this.state.dragging) {
        throw new Error("onDragEnd called before onDragStart.");
      }
      var _this$props4 = _this.props, w = _this$props4.w, h = _this$props4.h, i = _this$props4.i;
      var _this$state$dragging = _this.state.dragging, left = _this$state$dragging.left, top = _this$state$dragging.top;
      var newPosition = {
        top,
        left
      };
      _this.setState({
        dragging: null
      });
      var _calcXY3 = (0, _calculateUtils$1.calcXY)(_this.getPositionParams(), top, left, w, h), x = _calcXY3.x, y = _calcXY3.y;
      return onDragStop.call(_assertThisInitialized$3(_this), i, x, y, {
        e,
        node,
        newPosition
      });
    });
    _defineProperty$3(_assertThisInitialized$3(_this), "onResizeStop", function(e, callbackData) {
      _this.onResizeHandler(e, callbackData, "onResizeStop");
    });
    _defineProperty$3(_assertThisInitialized$3(_this), "onResizeStart", function(e, callbackData) {
      _this.onResizeHandler(e, callbackData, "onResizeStart");
    });
    _defineProperty$3(_assertThisInitialized$3(_this), "onResize", function(e, callbackData) {
      _this.onResizeHandler(e, callbackData, "onResize");
    });
    return _this;
  }
  _createClass$3(GridItem2, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.children !== nextProps.children)
        return true;
      if (this.props.droppingPosition !== nextProps.droppingPosition)
        return true;
      var oldPosition = (0, _calculateUtils$1.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
      var newPosition = (0, _calculateUtils$1.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
      return !(0, _utils$3.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.moveDroppingItem({});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.moveDroppingItem(prevProps);
    }
  }, {
    key: "moveDroppingItem",
    value: function moveDroppingItem(prevProps) {
      var droppingPosition = this.props.droppingPosition;
      if (!droppingPosition)
        return;
      var node = this.elementRef.current;
      if (!node)
        return;
      var prevDroppingPosition = prevProps.droppingPosition || {
        left: 0,
        top: 0
      };
      var dragging = this.state.dragging;
      var shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
      if (!dragging) {
        this.onDragStart(droppingPosition.e, {
          node,
          deltaX: droppingPosition.left,
          deltaY: droppingPosition.top
        });
      } else if (shouldDrag) {
        var deltaX = droppingPosition.left - dragging.left;
        var deltaY = droppingPosition.top - dragging.top;
        this.onDrag(droppingPosition.e, {
          node,
          deltaX,
          deltaY
        });
      }
    }
  }, {
    key: "getPositionParams",
    value: function getPositionParams() {
      var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      return {
        cols: props.cols,
        containerPadding: props.containerPadding,
        containerWidth: props.containerWidth,
        margin: props.margin,
        maxRows: props.maxRows,
        rowHeight: props.rowHeight
      };
    }
  }, {
    key: "createStyle",
    value: function createStyle(pos) {
      var _this$props5 = this.props, usePercentages = _this$props5.usePercentages, containerWidth = _this$props5.containerWidth, useCSSTransforms = _this$props5.useCSSTransforms;
      var style;
      if (useCSSTransforms) {
        style = (0, _utils$3.setTransform)(pos);
      } else {
        style = (0, _utils$3.setTopLeft)(pos);
        if (usePercentages) {
          style.left = (0, _utils$3.perc)(pos.left / containerWidth);
          style.width = (0, _utils$3.perc)(pos.width / containerWidth);
        }
      }
      return style;
    }
  }, {
    key: "mixinDraggable",
    value: function mixinDraggable(child, isDraggable) {
      return /* @__PURE__ */ _react.default.createElement(_reactDraggable.DraggableCore, {
        disabled: !isDraggable,
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop,
        handle: this.props.handle,
        cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
        scale: this.props.transformScale,
        nodeRef: this.elementRef
      }, child);
    }
  }, {
    key: "mixinResizable",
    value: function mixinResizable(child, position, isResizable) {
      var _this$props6 = this.props, cols = _this$props6.cols, x = _this$props6.x, minW2 = _this$props6.minW, minH2 = _this$props6.minH, maxW2 = _this$props6.maxW, maxH2 = _this$props6.maxH, transformScale = _this$props6.transformScale, resizeHandles = _this$props6.resizeHandles, resizeHandle = _this$props6.resizeHandle;
      var positionParams = this.getPositionParams();
      var maxWidth = (0, _calculateUtils$1.calcGridItemPosition)(positionParams, 0, 0, cols - x, 0).width;
      var mins = (0, _calculateUtils$1.calcGridItemPosition)(positionParams, 0, 0, minW2, minH2);
      var maxes = (0, _calculateUtils$1.calcGridItemPosition)(positionParams, 0, 0, maxW2, maxH2);
      var minConstraints = [mins.width, mins.height];
      var maxConstraints = [Math.min(maxes.width, maxWidth), Math.min(maxes.height, Infinity)];
      return /* @__PURE__ */ _react.default.createElement(_reactResizable.Resizable, {
        draggableOpts: {
          disabled: !isResizable
        },
        className: isResizable ? void 0 : "react-resizable-hide",
        width: position.width,
        height: position.height,
        minConstraints,
        maxConstraints,
        onResizeStop: this.onResizeStop,
        onResizeStart: this.onResizeStart,
        onResize: this.onResize,
        transformScale,
        resizeHandles,
        handle: resizeHandle
      }, child);
    }
  }, {
    key: "onResizeHandler",
    value: function onResizeHandler(e, _ref4, handlerName) {
      var node = _ref4.node, size = _ref4.size;
      var handler = this.props[handlerName];
      if (!handler)
        return;
      var _this$props7 = this.props, cols = _this$props7.cols, x = _this$props7.x, y = _this$props7.y, i = _this$props7.i, maxH2 = _this$props7.maxH, minH2 = _this$props7.minH;
      var _this$props8 = this.props, minW2 = _this$props8.minW, maxW2 = _this$props8.maxW;
      var _calcWH = (0, _calculateUtils$1.calcWH)(this.getPositionParams(), size.width, size.height, x, y), w = _calcWH.w, h = _calcWH.h;
      minW2 = Math.max(minW2, 1);
      maxW2 = Math.min(maxW2, cols - x);
      w = (0, _calculateUtils$1.clamp)(w, minW2, maxW2);
      h = (0, _calculateUtils$1.clamp)(h, minH2, maxH2);
      this.setState({
        resizing: handlerName === "onResizeStop" ? null : size
      });
      handler.call(this, i, w, h, {
        e,
        node,
        size
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props, x = _this$props9.x, y = _this$props9.y, w = _this$props9.w, h = _this$props9.h, isDraggable = _this$props9.isDraggable, isResizable = _this$props9.isResizable, droppingPosition = _this$props9.droppingPosition, useCSSTransforms = _this$props9.useCSSTransforms;
      var pos = (0, _calculateUtils$1.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
      var child = _react.default.Children.only(this.props.children);
      var newChild = /* @__PURE__ */ _react.default.cloneElement(child, {
        ref: this.elementRef,
        className: (0, _clsx$2.default)("react-grid-item", child.props.className, this.props.className, {
          static: this.props.static,
          resizing: Boolean(this.state.resizing),
          "react-draggable": isDraggable,
          "react-draggable-dragging": Boolean(this.state.dragging),
          dropping: Boolean(droppingPosition),
          cssTransforms: useCSSTransforms
        }),
        style: _objectSpread$2(_objectSpread$2(_objectSpread$2({}, this.props.style), child.props.style), this.createStyle(pos))
      });
      newChild = this.mixinResizable(newChild, pos, isResizable);
      newChild = this.mixinDraggable(newChild, isDraggable);
      return newChild;
    }
  }]);
  return GridItem2;
}(_react.default.Component);
GridItem$1.default = GridItem;
_defineProperty$3(GridItem, "propTypes", {
  children: _propTypes$2.default.element,
  cols: _propTypes$2.default.number.isRequired,
  containerWidth: _propTypes$2.default.number.isRequired,
  rowHeight: _propTypes$2.default.number.isRequired,
  margin: _propTypes$2.default.array.isRequired,
  maxRows: _propTypes$2.default.number.isRequired,
  containerPadding: _propTypes$2.default.array.isRequired,
  x: _propTypes$2.default.number.isRequired,
  y: _propTypes$2.default.number.isRequired,
  w: _propTypes$2.default.number.isRequired,
  h: _propTypes$2.default.number.isRequired,
  minW: function minW(props, propName) {
    var value = props[propName];
    if (typeof value !== "number")
      return new Error("minWidth not Number");
    if (value > props.w || value > props.maxW)
      return new Error("minWidth larger than item width/maxWidth");
  },
  maxW: function maxW(props, propName) {
    var value = props[propName];
    if (typeof value !== "number")
      return new Error("maxWidth not Number");
    if (value < props.w || value < props.minW)
      return new Error("maxWidth smaller than item width/minWidth");
  },
  minH: function minH(props, propName) {
    var value = props[propName];
    if (typeof value !== "number")
      return new Error("minHeight not Number");
    if (value > props.h || value > props.maxH)
      return new Error("minHeight larger than item height/maxHeight");
  },
  maxH: function maxH(props, propName) {
    var value = props[propName];
    if (typeof value !== "number")
      return new Error("maxHeight not Number");
    if (value < props.h || value < props.minH)
      return new Error("maxHeight smaller than item height/minHeight");
  },
  i: _propTypes$2.default.string.isRequired,
  resizeHandles: _ReactGridLayoutPropTypes$1.resizeHandleAxesType,
  resizeHandle: _ReactGridLayoutPropTypes$1.resizeHandleType,
  onDragStop: _propTypes$2.default.func,
  onDragStart: _propTypes$2.default.func,
  onDrag: _propTypes$2.default.func,
  onResizeStop: _propTypes$2.default.func,
  onResizeStart: _propTypes$2.default.func,
  onResize: _propTypes$2.default.func,
  isDraggable: _propTypes$2.default.bool.isRequired,
  isResizable: _propTypes$2.default.bool.isRequired,
  isBounded: _propTypes$2.default.bool.isRequired,
  static: _propTypes$2.default.bool,
  useCSSTransforms: _propTypes$2.default.bool.isRequired,
  transformScale: _propTypes$2.default.number,
  className: _propTypes$2.default.string,
  handle: _propTypes$2.default.string,
  cancel: _propTypes$2.default.string,
  droppingPosition: _propTypes$2.default.shape({
    e: _propTypes$2.default.object.isRequired,
    left: _propTypes$2.default.number.isRequired,
    top: _propTypes$2.default.number.isRequired
  })
});
_defineProperty$3(GridItem, "defaultProps", {
  className: "",
  cancel: "",
  handle: "",
  minH: 1,
  minW: 1,
  maxH: Infinity,
  maxW: Infinity,
  transformScale: 1
});
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
Object.defineProperty(ReactGridLayout$1, "__esModule", {
  value: true
});
ReactGridLayout$1.default = void 0;
var React$2 = _interopRequireWildcard$2(require$$0);
var _lodash$1 = _interopRequireDefault$2(lodash_isequal.exports);
var _clsx$1 = _interopRequireDefault$2(require$$2);
var _utils$2 = utils$1;
var _calculateUtils = calculateUtils;
var _GridItem = _interopRequireDefault$2(GridItem$1);
var _ReactGridLayoutPropTypes = _interopRequireDefault$2(ReactGridLayoutPropTypes);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$2(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$2 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$2(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$2(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$2(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$2(o, p2);
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$2(this, result);
  };
}
function _possibleConstructorReturn$2(self2, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self2);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$2(o);
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var layoutClassName$1 = "react-grid-layout";
var isFirefox = false;
try {
  isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
}
var ReactGridLayout = /* @__PURE__ */ function(_React$Component) {
  _inherits$2(ReactGridLayout2, _React$Component);
  var _super = _createSuper$2(ReactGridLayout2);
  function ReactGridLayout2() {
    var _this;
    _classCallCheck$2(this, ReactGridLayout2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "state", {
      activeDrag: null,
      layout: (0, _utils$2.synchronizeLayoutWithChildren)(_this.props.layout, _this.props.children, _this.props.cols, (0, _utils$2.compactType)(_this.props), _this.props.allowOverlap),
      mounted: false,
      oldDragItem: null,
      oldLayout: null,
      oldResizeItem: null,
      droppingDOMNode: null,
      children: []
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "dragEnterCounter", 0);
    _defineProperty$2(_assertThisInitialized$2(_this), "onDragStart", function(i, x, y, _ref) {
      var e = _ref.e, node = _ref.node;
      var layout2 = _this.state.layout;
      var l2 = (0, _utils$2.getLayoutItem)(layout2, i);
      if (!l2)
        return;
      _this.setState({
        oldDragItem: (0, _utils$2.cloneLayoutItem)(l2),
        oldLayout: layout2
      });
      return _this.props.onDragStart(layout2, l2, l2, null, e, node);
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onDrag", function(i, x, y, _ref2) {
      var e = _ref2.e, node = _ref2.node;
      var oldDragItem = _this.state.oldDragItem;
      var layout2 = _this.state.layout;
      var _this$props = _this.props, cols = _this$props.cols, allowOverlap = _this$props.allowOverlap, preventCollision = _this$props.preventCollision;
      var l2 = (0, _utils$2.getLayoutItem)(layout2, i);
      if (!l2)
        return;
      var placeholder = {
        w: l2.w,
        h: l2.h,
        x: l2.x,
        y: l2.y,
        placeholder: true,
        i
      };
      var isUserAction = true;
      layout2 = (0, _utils$2.moveElement)(layout2, l2, x, y, isUserAction, preventCollision, (0, _utils$2.compactType)(_this.props), cols, allowOverlap);
      _this.props.onDrag(layout2, oldDragItem, l2, placeholder, e, node);
      _this.setState({
        layout: allowOverlap ? layout2 : (0, _utils$2.compact)(layout2, (0, _utils$2.compactType)(_this.props), cols),
        activeDrag: placeholder
      });
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onDragStop", function(i, x, y, _ref3) {
      var e = _ref3.e, node = _ref3.node;
      if (!_this.state.activeDrag)
        return;
      var oldDragItem = _this.state.oldDragItem;
      var layout2 = _this.state.layout;
      var _this$props2 = _this.props, cols = _this$props2.cols, preventCollision = _this$props2.preventCollision, allowOverlap = _this$props2.allowOverlap;
      var l2 = (0, _utils$2.getLayoutItem)(layout2, i);
      if (!l2)
        return;
      var isUserAction = true;
      layout2 = (0, _utils$2.moveElement)(layout2, l2, x, y, isUserAction, preventCollision, (0, _utils$2.compactType)(_this.props), cols, allowOverlap);
      _this.props.onDragStop(layout2, oldDragItem, l2, null, e, node);
      var newLayout = allowOverlap ? layout2 : (0, _utils$2.compact)(layout2, (0, _utils$2.compactType)(_this.props), cols);
      var oldLayout = _this.state.oldLayout;
      _this.setState({
        activeDrag: null,
        layout: newLayout,
        oldDragItem: null,
        oldLayout: null
      });
      _this.onLayoutMaybeChanged(newLayout, oldLayout);
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onResizeStart", function(i, w, h, _ref4) {
      var e = _ref4.e, node = _ref4.node;
      var layout2 = _this.state.layout;
      var l2 = (0, _utils$2.getLayoutItem)(layout2, i);
      if (!l2)
        return;
      _this.setState({
        oldResizeItem: (0, _utils$2.cloneLayoutItem)(l2),
        oldLayout: _this.state.layout
      });
      _this.props.onResizeStart(layout2, l2, l2, null, e, node);
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onResize", function(i, w, h, _ref5) {
      var e = _ref5.e, node = _ref5.node;
      var _this$state = _this.state, layout2 = _this$state.layout, oldResizeItem = _this$state.oldResizeItem;
      var _this$props3 = _this.props, cols = _this$props3.cols, preventCollision = _this$props3.preventCollision, allowOverlap = _this$props3.allowOverlap;
      var _withLayoutItem = (0, _utils$2.withLayoutItem)(layout2, i, function(l3) {
        var hasCollisions;
        if (preventCollision && !allowOverlap) {
          var collisions = (0, _utils$2.getAllCollisions)(layout2, _objectSpread$1(_objectSpread$1({}, l3), {}, {
            w,
            h
          })).filter(function(layoutItem) {
            return layoutItem.i !== l3.i;
          });
          hasCollisions = collisions.length > 0;
          if (hasCollisions) {
            var leastX = Infinity, leastY = Infinity;
            collisions.forEach(function(layoutItem) {
              if (layoutItem.x > l3.x)
                leastX = Math.min(leastX, layoutItem.x);
              if (layoutItem.y > l3.y)
                leastY = Math.min(leastY, layoutItem.y);
            });
            if (Number.isFinite(leastX))
              l3.w = leastX - l3.x;
            if (Number.isFinite(leastY))
              l3.h = leastY - l3.y;
          }
        }
        if (!hasCollisions) {
          l3.w = w;
          l3.h = h;
        }
        return l3;
      }), _withLayoutItem2 = _slicedToArray(_withLayoutItem, 2), newLayout = _withLayoutItem2[0], l2 = _withLayoutItem2[1];
      if (!l2)
        return;
      var placeholder = {
        w: l2.w,
        h: l2.h,
        x: l2.x,
        y: l2.y,
        static: true,
        i
      };
      _this.props.onResize(newLayout, oldResizeItem, l2, placeholder, e, node);
      _this.setState({
        layout: allowOverlap ? newLayout : (0, _utils$2.compact)(newLayout, (0, _utils$2.compactType)(_this.props), cols),
        activeDrag: placeholder
      });
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onResizeStop", function(i, w, h, _ref6) {
      var e = _ref6.e, node = _ref6.node;
      var _this$state2 = _this.state, layout2 = _this$state2.layout, oldResizeItem = _this$state2.oldResizeItem;
      var _this$props4 = _this.props, cols = _this$props4.cols, allowOverlap = _this$props4.allowOverlap;
      var l2 = (0, _utils$2.getLayoutItem)(layout2, i);
      _this.props.onResizeStop(layout2, oldResizeItem, l2, null, e, node);
      var newLayout = allowOverlap ? layout2 : (0, _utils$2.compact)(layout2, (0, _utils$2.compactType)(_this.props), cols);
      var oldLayout = _this.state.oldLayout;
      _this.setState({
        activeDrag: null,
        layout: newLayout,
        oldResizeItem: null,
        oldLayout: null
      });
      _this.onLayoutMaybeChanged(newLayout, oldLayout);
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onDragOver", function(e) {
      var _e$nativeEvent$target;
      e.preventDefault();
      e.stopPropagation();
      if (isFirefox && !((_e$nativeEvent$target = e.nativeEvent.target) !== null && _e$nativeEvent$target !== void 0 && _e$nativeEvent$target.classList.contains(layoutClassName$1))) {
        return false;
      }
      var _this$props5 = _this.props, droppingItem = _this$props5.droppingItem, onDropDragOver = _this$props5.onDropDragOver, margin = _this$props5.margin, cols = _this$props5.cols, rowHeight = _this$props5.rowHeight, maxRows = _this$props5.maxRows, width = _this$props5.width, containerPadding = _this$props5.containerPadding, transformScale = _this$props5.transformScale;
      var onDragOverResult = onDropDragOver === null || onDropDragOver === void 0 ? void 0 : onDropDragOver(e);
      if (onDragOverResult === false) {
        if (_this.state.droppingDOMNode) {
          _this.removeDroppingPlaceholder();
        }
        return false;
      }
      var finalDroppingItem = _objectSpread$1(_objectSpread$1({}, droppingItem), onDragOverResult);
      var layout2 = _this.state.layout;
      var _e$nativeEvent = e.nativeEvent, layerX = _e$nativeEvent.layerX, layerY = _e$nativeEvent.layerY;
      var droppingPosition = {
        left: layerX / transformScale,
        top: layerY / transformScale,
        e
      };
      if (!_this.state.droppingDOMNode) {
        var positionParams = {
          cols,
          margin,
          maxRows,
          rowHeight,
          containerWidth: width,
          containerPadding: containerPadding || margin
        };
        var calculatedPosition = (0, _calculateUtils.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
        _this.setState({
          droppingDOMNode: /* @__PURE__ */ React$2.createElement("div", {
            key: finalDroppingItem.i
          }),
          droppingPosition,
          layout: [].concat(_toConsumableArray(layout2), [_objectSpread$1(_objectSpread$1({}, finalDroppingItem), {}, {
            x: calculatedPosition.x,
            y: calculatedPosition.y,
            static: false,
            isDraggable: true
          })])
        });
      } else if (_this.state.droppingPosition) {
        var _this$state$droppingP = _this.state.droppingPosition, left = _this$state$droppingP.left, top = _this$state$droppingP.top;
        var shouldUpdatePosition = left != layerX || top != layerY;
        if (shouldUpdatePosition) {
          _this.setState({
            droppingPosition
          });
        }
      }
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "removeDroppingPlaceholder", function() {
      var _this$props6 = _this.props, droppingItem = _this$props6.droppingItem, cols = _this$props6.cols;
      var layout2 = _this.state.layout;
      var newLayout = (0, _utils$2.compact)(layout2.filter(function(l2) {
        return l2.i !== droppingItem.i;
      }), (0, _utils$2.compactType)(_this.props), cols);
      _this.setState({
        layout: newLayout,
        droppingDOMNode: null,
        activeDrag: null,
        droppingPosition: void 0
      });
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onDragLeave", function(e) {
      e.preventDefault();
      e.stopPropagation();
      _this.dragEnterCounter--;
      if (_this.dragEnterCounter === 0) {
        _this.removeDroppingPlaceholder();
      }
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onDragEnter", function(e) {
      e.preventDefault();
      e.stopPropagation();
      _this.dragEnterCounter++;
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onDrop", function(e) {
      e.preventDefault();
      e.stopPropagation();
      var droppingItem = _this.props.droppingItem;
      var layout2 = _this.state.layout;
      var item = layout2.find(function(l2) {
        return l2.i === droppingItem.i;
      });
      _this.dragEnterCounter = 0;
      _this.removeDroppingPlaceholder();
      _this.props.onDrop(layout2, item, e);
    });
    return _this;
  }
  _createClass$2(ReactGridLayout2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
      this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.children !== nextProps.children || !(0, _utils$2.fastRGLPropsEqual)(this.props, nextProps, _lodash$1.default) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.state.activeDrag) {
        var newLayout = this.state.layout;
        var oldLayout = prevState.layout;
        this.onLayoutMaybeChanged(newLayout, oldLayout);
      }
    }
  }, {
    key: "containerHeight",
    value: function containerHeight() {
      if (!this.props.autoSize)
        return;
      var nbRow = (0, _utils$2.bottom)(this.state.layout);
      var containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
      return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
  }, {
    key: "onLayoutMaybeChanged",
    value: function onLayoutMaybeChanged(newLayout, oldLayout) {
      if (!oldLayout)
        oldLayout = this.state.layout;
      if (!(0, _lodash$1.default)(oldLayout, newLayout)) {
        this.props.onLayoutChange(newLayout);
      }
    }
  }, {
    key: "placeholder",
    value: function placeholder() {
      var activeDrag = this.state.activeDrag;
      if (!activeDrag)
        return null;
      var _this$props7 = this.props, width = _this$props7.width, cols = _this$props7.cols, margin = _this$props7.margin, containerPadding = _this$props7.containerPadding, rowHeight = _this$props7.rowHeight, maxRows = _this$props7.maxRows, useCSSTransforms = _this$props7.useCSSTransforms, transformScale = _this$props7.transformScale;
      return /* @__PURE__ */ React$2.createElement(_GridItem.default, {
        w: activeDrag.w,
        h: activeDrag.h,
        x: activeDrag.x,
        y: activeDrag.y,
        i: activeDrag.i,
        className: "react-grid-placeholder",
        containerWidth: width,
        cols,
        margin,
        containerPadding: containerPadding || margin,
        maxRows,
        rowHeight,
        isDraggable: false,
        isResizable: false,
        isBounded: false,
        useCSSTransforms,
        transformScale
      }, /* @__PURE__ */ React$2.createElement("div", null));
    }
  }, {
    key: "processGridItem",
    value: function processGridItem(child, isDroppingItem) {
      if (!child || !child.key)
        return;
      var l2 = (0, _utils$2.getLayoutItem)(this.state.layout, String(child.key));
      if (!l2)
        return null;
      var _this$props8 = this.props, width = _this$props8.width, cols = _this$props8.cols, margin = _this$props8.margin, containerPadding = _this$props8.containerPadding, rowHeight = _this$props8.rowHeight, maxRows = _this$props8.maxRows, isDraggable = _this$props8.isDraggable, isResizable = _this$props8.isResizable, isBounded = _this$props8.isBounded, useCSSTransforms = _this$props8.useCSSTransforms, transformScale = _this$props8.transformScale, draggableCancel = _this$props8.draggableCancel, draggableHandle = _this$props8.draggableHandle, resizeHandles = _this$props8.resizeHandles, resizeHandle = _this$props8.resizeHandle;
      var _this$state3 = this.state, mounted = _this$state3.mounted, droppingPosition = _this$state3.droppingPosition;
      var draggable = typeof l2.isDraggable === "boolean" ? l2.isDraggable : !l2.static && isDraggable;
      var resizable = typeof l2.isResizable === "boolean" ? l2.isResizable : !l2.static && isResizable;
      var resizeHandlesOptions = l2.resizeHandles || resizeHandles;
      var bounded = draggable && isBounded && l2.isBounded !== false;
      return /* @__PURE__ */ React$2.createElement(_GridItem.default, {
        containerWidth: width,
        cols,
        margin,
        containerPadding: containerPadding || margin,
        maxRows,
        rowHeight,
        cancel: draggableCancel,
        handle: draggableHandle,
        onDragStop: this.onDragStop,
        onDragStart: this.onDragStart,
        onDrag: this.onDrag,
        onResizeStart: this.onResizeStart,
        onResize: this.onResize,
        onResizeStop: this.onResizeStop,
        isDraggable: draggable,
        isResizable: resizable,
        isBounded: bounded,
        useCSSTransforms: useCSSTransforms && mounted,
        usePercentages: !mounted,
        transformScale,
        w: l2.w,
        h: l2.h,
        x: l2.x,
        y: l2.y,
        i: l2.i,
        minH: l2.minH,
        minW: l2.minW,
        maxH: l2.maxH,
        maxW: l2.maxW,
        static: l2.static,
        droppingPosition: isDroppingItem ? droppingPosition : void 0,
        resizeHandles: resizeHandlesOptions,
        resizeHandle
      }, child);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props9 = this.props, className = _this$props9.className, style = _this$props9.style, isDroppable = _this$props9.isDroppable, innerRef = _this$props9.innerRef;
      var mergedClassName = (0, _clsx$1.default)(layoutClassName$1, className);
      var mergedStyle = _objectSpread$1({
        height: this.containerHeight()
      }, style);
      return /* @__PURE__ */ React$2.createElement("div", {
        ref: innerRef,
        className: mergedClassName,
        style: mergedStyle,
        onDrop: isDroppable ? this.onDrop : _utils$2.noop,
        onDragLeave: isDroppable ? this.onDragLeave : _utils$2.noop,
        onDragEnter: isDroppable ? this.onDragEnter : _utils$2.noop,
        onDragOver: isDroppable ? this.onDragOver : _utils$2.noop
      }, React$2.Children.map(this.props.children, function(child) {
        return _this2.processGridItem(child);
      }), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newLayoutBase;
      if (prevState.activeDrag) {
        return null;
      }
      if (!(0, _lodash$1.default)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) {
        newLayoutBase = nextProps.layout;
      } else if (!(0, _utils$2.childrenEqual)(nextProps.children, prevState.children)) {
        newLayoutBase = prevState.layout;
      }
      if (newLayoutBase) {
        var newLayout = (0, _utils$2.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, _utils$2.compactType)(nextProps), nextProps.allowOverlap);
        return {
          layout: newLayout,
          compactType: nextProps.compactType,
          children: nextProps.children,
          propsLayout: nextProps.layout
        };
      }
      return null;
    }
  }]);
  return ReactGridLayout2;
}(React$2.Component);
ReactGridLayout$1.default = ReactGridLayout;
_defineProperty$2(ReactGridLayout, "displayName", "ReactGridLayout");
_defineProperty$2(ReactGridLayout, "propTypes", _ReactGridLayoutPropTypes.default);
_defineProperty$2(ReactGridLayout, "defaultProps", {
  autoSize: true,
  cols: 12,
  className: "",
  style: {},
  draggableHandle: "",
  draggableCancel: "",
  containerPadding: null,
  rowHeight: 150,
  maxRows: Infinity,
  layout: [],
  margin: [10, 10],
  isBounded: false,
  isDraggable: true,
  isResizable: true,
  allowOverlap: false,
  isDroppable: false,
  useCSSTransforms: true,
  transformScale: 1,
  verticalCompact: true,
  compactType: "vertical",
  preventCollision: false,
  droppingItem: {
    i: "__dropping-elem__",
    h: 1,
    w: 1
  },
  resizeHandles: ["se"],
  onLayoutChange: _utils$2.noop,
  onDragStart: _utils$2.noop,
  onDrag: _utils$2.noop,
  onDragStop: _utils$2.noop,
  onResizeStart: _utils$2.noop,
  onResize: _utils$2.noop,
  onResizeStop: _utils$2.noop,
  onDrop: _utils$2.noop,
  onDropDragOver: _utils$2.noop
});
var ResponsiveReactGridLayout$1 = {};
var responsiveUtils = {};
Object.defineProperty(responsiveUtils, "__esModule", {
  value: true
});
responsiveUtils.findOrGenerateResponsiveLayout = findOrGenerateResponsiveLayout;
responsiveUtils.getBreakpointFromWidth = getBreakpointFromWidth;
responsiveUtils.getColsFromBreakpoint = getColsFromBreakpoint;
responsiveUtils.sortBreakpoints = sortBreakpoints;
var _utils$1 = utils$1;
function getBreakpointFromWidth(breakpoints, width) {
  var sorted = sortBreakpoints(breakpoints);
  var matching = sorted[0];
  for (var i = 1, len = sorted.length; i < len; i++) {
    var breakpointName = sorted[i];
    if (width > breakpoints[breakpointName])
      matching = breakpointName;
  }
  return matching;
}
function getColsFromBreakpoint(breakpoint, cols) {
  if (!cols[breakpoint]) {
    throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
  }
  return cols[breakpoint];
}
function findOrGenerateResponsiveLayout(layouts2, breakpoints, breakpoint, lastBreakpoint, cols, compactType2) {
  if (layouts2[breakpoint])
    return (0, _utils$1.cloneLayout)(layouts2[breakpoint]);
  var layout2 = layouts2[lastBreakpoint];
  var breakpointsSorted = sortBreakpoints(breakpoints);
  var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
  for (var i = 0, len = breakpointsAbove.length; i < len; i++) {
    var b = breakpointsAbove[i];
    if (layouts2[b]) {
      layout2 = layouts2[b];
      break;
    }
  }
  layout2 = (0, _utils$1.cloneLayout)(layout2 || []);
  return (0, _utils$1.compact)((0, _utils$1.correctBounds)(layout2, {
    cols
  }), compactType2, cols);
}
function sortBreakpoints(breakpoints) {
  var keys = Object.keys(breakpoints);
  return keys.sort(function(a, b) {
    return breakpoints[a] - breakpoints[b];
  });
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
Object.defineProperty(ResponsiveReactGridLayout$1, "__esModule", {
  value: true
});
ResponsiveReactGridLayout$1.default = void 0;
var React$1 = _interopRequireWildcard$1(require$$0);
var _propTypes$1 = _interopRequireDefault$1(propTypes$1.exports);
var _lodash = _interopRequireDefault$1(lodash_isequal.exports);
var _utils = utils$1;
var _responsiveUtils = responsiveUtils;
var _ReactGridLayout = _interopRequireDefault$1(ReactGridLayout$1);
var _excluded$1 = ["breakpoint", "breakpoints", "cols", "layouts", "margin", "containerPadding", "onBreakpointChange", "onLayoutChange", "onWidthChange"];
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache$1(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard$1(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache$1(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends$1() {
  _extends$1 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$1(o, p2);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var type = function type2(obj) {
  return Object.prototype.toString.call(obj);
};
function getIndentationValue(param, breakpoint) {
  if (param == null)
    return null;
  return Array.isArray(param) ? param : param[breakpoint];
}
var ResponsiveReactGridLayout = /* @__PURE__ */ function(_React$Component) {
  _inherits$1(ResponsiveReactGridLayout2, _React$Component);
  var _super = _createSuper$1(ResponsiveReactGridLayout2);
  function ResponsiveReactGridLayout2() {
    var _this;
    _classCallCheck$1(this, ResponsiveReactGridLayout2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$1(_assertThisInitialized$1(_this), "state", _this.generateInitialState());
    _defineProperty$1(_assertThisInitialized$1(_this), "onLayoutChange", function(layout2) {
      _this.props.onLayoutChange(layout2, _objectSpread(_objectSpread({}, _this.props.layouts), {}, _defineProperty$1({}, _this.state.breakpoint, layout2)));
    });
    return _this;
  }
  _createClass$1(ResponsiveReactGridLayout2, [{
    key: "generateInitialState",
    value: function generateInitialState() {
      var _this$props = this.props, width = _this$props.width, breakpoints = _this$props.breakpoints, layouts2 = _this$props.layouts, cols = _this$props.cols;
      var breakpoint = (0, _responsiveUtils.getBreakpointFromWidth)(breakpoints, width);
      var colNo = (0, _responsiveUtils.getColsFromBreakpoint)(breakpoint, cols);
      var compactType2 = this.props.verticalCompact === false ? null : this.props.compactType;
      var initialLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts2, breakpoints, breakpoint, breakpoint, colNo, compactType2);
      return {
        layout: initialLayout,
        breakpoint,
        cols: colNo
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, _lodash.default)(this.props.breakpoints, prevProps.breakpoints) || !(0, _lodash.default)(this.props.cols, prevProps.cols)) {
        this.onWidthChange(prevProps);
      }
    }
  }, {
    key: "onWidthChange",
    value: function onWidthChange(prevProps) {
      var _this$props2 = this.props, breakpoints = _this$props2.breakpoints, cols = _this$props2.cols, layouts2 = _this$props2.layouts, compactType2 = _this$props2.compactType;
      var newBreakpoint = this.props.breakpoint || (0, _responsiveUtils.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
      var lastBreakpoint = this.state.breakpoint;
      var newCols = (0, _responsiveUtils.getColsFromBreakpoint)(newBreakpoint, cols);
      var newLayouts = _objectSpread({}, layouts2);
      if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
        if (!(lastBreakpoint in newLayouts))
          newLayouts[lastBreakpoint] = (0, _utils.cloneLayout)(this.state.layout);
        var layout2 = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType2);
        layout2 = (0, _utils.synchronizeLayoutWithChildren)(layout2, this.props.children, newCols, compactType2, this.props.allowOverlap);
        newLayouts[newBreakpoint] = layout2;
        this.props.onLayoutChange(layout2, newLayouts);
        this.props.onBreakpointChange(newBreakpoint, newCols);
        this.setState({
          breakpoint: newBreakpoint,
          layout: layout2,
          cols: newCols
        });
      }
      var margin = getIndentationValue(this.props.margin, newBreakpoint);
      var containerPadding = getIndentationValue(this.props.containerPadding, newBreakpoint);
      this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props;
      _this$props3.breakpoint;
      _this$props3.breakpoints;
      _this$props3.cols;
      _this$props3.layouts;
      var margin = _this$props3.margin, containerPadding = _this$props3.containerPadding;
      _this$props3.onBreakpointChange;
      _this$props3.onLayoutChange;
      _this$props3.onWidthChange;
      var other = _objectWithoutProperties$1(_this$props3, _excluded$1);
      return /* @__PURE__ */ React$1.createElement(_ReactGridLayout.default, _extends$1({}, other, {
        margin: getIndentationValue(margin, this.state.breakpoint),
        containerPadding: getIndentationValue(containerPadding, this.state.breakpoint),
        onLayoutChange: this.onLayoutChange,
        layout: this.state.layout,
        cols: this.state.cols
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!(0, _lodash.default)(nextProps.layouts, prevState.layouts)) {
        var breakpoint = prevState.breakpoint, _cols = prevState.cols;
        var newLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, _cols, nextProps.compactType);
        return {
          layout: newLayout,
          layouts: nextProps.layouts
        };
      }
      return null;
    }
  }]);
  return ResponsiveReactGridLayout2;
}(React$1.Component);
ResponsiveReactGridLayout$1.default = ResponsiveReactGridLayout;
_defineProperty$1(ResponsiveReactGridLayout, "propTypes", {
  breakpoint: _propTypes$1.default.string,
  breakpoints: _propTypes$1.default.object,
  allowOverlap: _propTypes$1.default.bool,
  cols: _propTypes$1.default.object,
  margin: _propTypes$1.default.oneOfType([_propTypes$1.default.array, _propTypes$1.default.object]),
  containerPadding: _propTypes$1.default.oneOfType([_propTypes$1.default.array, _propTypes$1.default.object]),
  layouts: function layouts(props, propName) {
    if (type(props[propName]) !== "[object Object]") {
      throw new Error("Layout property must be an object. Received: " + type(props[propName]));
    }
    Object.keys(props[propName]).forEach(function(key) {
      if (!(key in props.breakpoints)) {
        throw new Error("Each key in layouts must align with a key in breakpoints.");
      }
      (0, _utils.validateLayout)(props.layouts[key], "layouts." + key);
    });
  },
  width: _propTypes$1.default.number.isRequired,
  onBreakpointChange: _propTypes$1.default.func,
  onLayoutChange: _propTypes$1.default.func,
  onWidthChange: _propTypes$1.default.func
});
_defineProperty$1(ResponsiveReactGridLayout, "defaultProps", {
  breakpoints: {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0
  },
  cols: {
    lg: 12,
    md: 10,
    sm: 6,
    xs: 4,
    xxs: 2
  },
  containerPadding: {
    lg: null,
    md: null,
    sm: null,
    xs: null,
    xxs: null
  },
  layouts: {},
  margin: [10, 10],
  allowOverlap: false,
  onBreakpointChange: _utils.noop,
  onLayoutChange: _utils.noop,
  onWidthChange: _utils.noop
});
var WidthProvider = {};
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
Object.defineProperty(WidthProvider, "__esModule", {
  value: true
});
WidthProvider.default = WidthProvideRGL;
var React = _interopRequireWildcard(require$$0);
var _propTypes = _interopRequireDefault(propTypes$1.exports);
var _clsx = _interopRequireDefault(require$$2);
var _excluded = ["measureBeforeMount"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var layoutClassName = "react-grid-layout";
function WidthProvideRGL(ComposedComponent) {
  var _class;
  return _class = /* @__PURE__ */ function(_React$Component) {
    _inherits(WidthProvider2, _React$Component);
    var _super = _createSuper(WidthProvider2);
    function WidthProvider2() {
      var _this;
      _classCallCheck(this, WidthProvider2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        width: 1280
      });
      _defineProperty(_assertThisInitialized(_this), "elementRef", /* @__PURE__ */ React.createRef());
      _defineProperty(_assertThisInitialized(_this), "mounted", false);
      _defineProperty(_assertThisInitialized(_this), "onWindowResize", function() {
        if (!_this.mounted)
          return;
        var node = _this.elementRef.current;
        if (node instanceof HTMLElement && node.offsetWidth) {
          _this.setState({
            width: node.offsetWidth
          });
        }
      });
      return _this;
    }
    _createClass(WidthProvider2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mounted = true;
        window.addEventListener("resize", this.onWindowResize);
        this.onWindowResize();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener("resize", this.onWindowResize);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props, measureBeforeMount = _this$props.measureBeforeMount, rest = _objectWithoutProperties(_this$props, _excluded);
        if (measureBeforeMount && !this.mounted) {
          return /* @__PURE__ */ React.createElement("div", {
            className: (0, _clsx.default)(this.props.className, layoutClassName),
            style: this.props.style,
            ref: this.elementRef
          });
        }
        return /* @__PURE__ */ React.createElement(ComposedComponent, _extends({
          innerRef: this.elementRef
        }, rest, this.state));
      }
    }]);
    return WidthProvider2;
  }(React.Component), _defineProperty(_class, "defaultProps", {
    measureBeforeMount: false
  }), _defineProperty(_class, "propTypes", {
    measureBeforeMount: _propTypes.default.bool
  }), _class;
}
(function(module) {
  module.exports = ReactGridLayout$1.default;
  module.exports.utils = utils$1;
  module.exports.Responsive = ResponsiveReactGridLayout$1.default;
  module.exports.Responsive.utils = responsiveUtils;
  module.exports.WidthProvider = WidthProvider.default;
})(reactGridLayout);
var GridLayout = reactGridLayout.exports;
var object_hash = { exports: {} };
(function(module, exports) {
  !function(e) {
    module.exports = e();
  }(function() {
    return function r(o, i, u) {
      function s(n2, e2) {
        if (!i[n2]) {
          if (!o[n2]) {
            var t = typeof commonjsRequire == "function" && commonjsRequire;
            if (!e2 && t)
              return t(n2, true);
            if (a)
              return a(n2, true);
            throw new Error("Cannot find module '" + n2 + "'");
          }
          e2 = i[n2] = { exports: {} };
          o[n2][0].call(e2.exports, function(e3) {
            var t2 = o[n2][1][e3];
            return s(t2 || e3);
          }, e2, e2.exports, r, o, i, u);
        }
        return i[n2].exports;
      }
      for (var a = typeof commonjsRequire == "function" && commonjsRequire, e = 0; e < u.length; e++)
        s(u[e]);
      return s;
    }({ 1: [function(w, b, m2) {
      !function(e, n2, s, c, d, h, p2, g, y) {
        var r = w("crypto");
        function t(e2, t2) {
          t2 = u(e2, t2);
          var n3;
          return (n3 = t2.algorithm !== "passthrough" ? r.createHash(t2.algorithm) : new l2()).write === void 0 && (n3.write = n3.update, n3.end = n3.update), f2(t2, n3).dispatch(e2), n3.update || n3.end(""), n3.digest ? n3.digest(t2.encoding === "buffer" ? void 0 : t2.encoding) : (e2 = n3.read(), t2.encoding !== "buffer" ? e2.toString(t2.encoding) : e2);
        }
        (m2 = b.exports = t).sha1 = function(e2) {
          return t(e2);
        }, m2.keys = function(e2) {
          return t(e2, { excludeValues: true, algorithm: "sha1", encoding: "hex" });
        }, m2.MD5 = function(e2) {
          return t(e2, { algorithm: "md5", encoding: "hex" });
        }, m2.keysMD5 = function(e2) {
          return t(e2, { algorithm: "md5", encoding: "hex", excludeValues: true });
        };
        var o = r.getHashes ? r.getHashes().slice() : ["sha1", "md5"], i = (o.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
        function u(e2, t2) {
          var n3 = {};
          if (n3.algorithm = (t2 = t2 || {}).algorithm || "sha1", n3.encoding = t2.encoding || "hex", n3.excludeValues = !!t2.excludeValues, n3.algorithm = n3.algorithm.toLowerCase(), n3.encoding = n3.encoding.toLowerCase(), n3.ignoreUnknown = t2.ignoreUnknown === true, n3.respectType = t2.respectType !== false, n3.respectFunctionNames = t2.respectFunctionNames !== false, n3.respectFunctionProperties = t2.respectFunctionProperties !== false, n3.unorderedArrays = t2.unorderedArrays === true, n3.unorderedSets = t2.unorderedSets !== false, n3.unorderedObjects = t2.unorderedObjects !== false, n3.replacer = t2.replacer || void 0, n3.excludeKeys = t2.excludeKeys || void 0, e2 === void 0)
            throw new Error("Object argument required.");
          for (var r2 = 0; r2 < o.length; ++r2)
            o[r2].toLowerCase() === n3.algorithm.toLowerCase() && (n3.algorithm = o[r2]);
          if (o.indexOf(n3.algorithm) === -1)
            throw new Error('Algorithm "' + n3.algorithm + '"  not supported. supported values: ' + o.join(", "));
          if (i.indexOf(n3.encoding) === -1 && n3.algorithm !== "passthrough")
            throw new Error('Encoding "' + n3.encoding + '"  not supported. supported values: ' + i.join(", "));
          return n3;
        }
        function a(e2) {
          if (typeof e2 == "function")
            return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(e2)) != null;
        }
        function f2(o2, t2, i2) {
          i2 = i2 || [];
          function u2(e2) {
            return t2.update ? t2.update(e2, "utf8") : t2.write(e2, "utf8");
          }
          return { dispatch: function(e2) {
            return this["_" + ((e2 = o2.replacer ? o2.replacer(e2) : e2) === null ? "null" : typeof e2)](e2);
          }, _object: function(t3) {
            var n3, e2 = Object.prototype.toString.call(t3), r2 = /\[object (.*)\]/i.exec(e2);
            r2 = (r2 = r2 ? r2[1] : "unknown:[" + e2 + "]").toLowerCase();
            if (0 <= (e2 = i2.indexOf(t3)))
              return this.dispatch("[CIRCULAR:" + e2 + "]");
            if (i2.push(t3), s !== void 0 && s.isBuffer && s.isBuffer(t3))
              return u2("buffer:"), u2(t3);
            if (r2 === "object" || r2 === "function" || r2 === "asyncfunction")
              return e2 = Object.keys(t3), o2.unorderedObjects && (e2 = e2.sort()), o2.respectType === false || a(t3) || e2.splice(0, 0, "prototype", "__proto__", "constructor"), o2.excludeKeys && (e2 = e2.filter(function(e3) {
                return !o2.excludeKeys(e3);
              })), u2("object:" + e2.length + ":"), n3 = this, e2.forEach(function(e3) {
                n3.dispatch(e3), u2(":"), o2.excludeValues || n3.dispatch(t3[e3]), u2(",");
              });
            if (!this["_" + r2]) {
              if (o2.ignoreUnknown)
                return u2("[" + r2 + "]");
              throw new Error('Unknown object type "' + r2 + '"');
            }
            this["_" + r2](t3);
          }, _array: function(e2, t3) {
            t3 = t3 !== void 0 ? t3 : o2.unorderedArrays !== false;
            var n3 = this;
            if (u2("array:" + e2.length + ":"), !t3 || e2.length <= 1)
              return e2.forEach(function(e3) {
                return n3.dispatch(e3);
              });
            var r2 = [], t3 = e2.map(function(e3) {
              var t4 = new l2(), n4 = i2.slice();
              return f2(o2, t4, n4).dispatch(e3), r2 = r2.concat(n4.slice(i2.length)), t4.read().toString();
            });
            return i2 = i2.concat(r2), t3.sort(), this._array(t3, false);
          }, _date: function(e2) {
            return u2("date:" + e2.toJSON());
          }, _symbol: function(e2) {
            return u2("symbol:" + e2.toString());
          }, _error: function(e2) {
            return u2("error:" + e2.toString());
          }, _boolean: function(e2) {
            return u2("bool:" + e2.toString());
          }, _string: function(e2) {
            u2("string:" + e2.length + ":"), u2(e2.toString());
          }, _function: function(e2) {
            u2("fn:"), a(e2) ? this.dispatch("[native]") : this.dispatch(e2.toString()), o2.respectFunctionNames !== false && this.dispatch("function-name:" + String(e2.name)), o2.respectFunctionProperties && this._object(e2);
          }, _number: function(e2) {
            return u2("number:" + e2.toString());
          }, _xml: function(e2) {
            return u2("xml:" + e2.toString());
          }, _null: function() {
            return u2("Null");
          }, _undefined: function() {
            return u2("Undefined");
          }, _regexp: function(e2) {
            return u2("regex:" + e2.toString());
          }, _uint8array: function(e2) {
            return u2("uint8array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _uint8clampedarray: function(e2) {
            return u2("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _int8array: function(e2) {
            return u2("int8array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _uint16array: function(e2) {
            return u2("uint16array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _int16array: function(e2) {
            return u2("int16array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _uint32array: function(e2) {
            return u2("uint32array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _int32array: function(e2) {
            return u2("int32array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _float32array: function(e2) {
            return u2("float32array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _float64array: function(e2) {
            return u2("float64array:"), this.dispatch(Array.prototype.slice.call(e2));
          }, _arraybuffer: function(e2) {
            return u2("arraybuffer:"), this.dispatch(new Uint8Array(e2));
          }, _url: function(e2) {
            return u2("url:" + e2.toString());
          }, _map: function(e2) {
            u2("map:");
            e2 = Array.from(e2);
            return this._array(e2, o2.unorderedSets !== false);
          }, _set: function(e2) {
            u2("set:");
            e2 = Array.from(e2);
            return this._array(e2, o2.unorderedSets !== false);
          }, _file: function(e2) {
            return u2("file:"), this.dispatch([e2.name, e2.size, e2.type, e2.lastModfied]);
          }, _blob: function() {
            if (o2.ignoreUnknown)
              return u2("[blob]");
            throw Error('Hashing Blob objects is currently not supported\n(see https://github.com/puleos/object-hash/issues/26)\nUse "options.replacer" or "options.ignoreUnknown"\n');
          }, _domwindow: function() {
            return u2("domwindow");
          }, _bigint: function(e2) {
            return u2("bigint:" + e2.toString());
          }, _process: function() {
            return u2("process");
          }, _timer: function() {
            return u2("timer");
          }, _pipe: function() {
            return u2("pipe");
          }, _tcp: function() {
            return u2("tcp");
          }, _udp: function() {
            return u2("udp");
          }, _tty: function() {
            return u2("tty");
          }, _statwatcher: function() {
            return u2("statwatcher");
          }, _securecontext: function() {
            return u2("securecontext");
          }, _connection: function() {
            return u2("connection");
          }, _zlib: function() {
            return u2("zlib");
          }, _context: function() {
            return u2("context");
          }, _nodescript: function() {
            return u2("nodescript");
          }, _httpparser: function() {
            return u2("httpparser");
          }, _dataview: function() {
            return u2("dataview");
          }, _signal: function() {
            return u2("signal");
          }, _fsevent: function() {
            return u2("fsevent");
          }, _tlswrap: function() {
            return u2("tlswrap");
          } };
        }
        function l2() {
          return { buf: "", write: function(e2) {
            this.buf += e2;
          }, end: function(e2) {
            this.buf += e2;
          }, read: function() {
            return this.buf;
          } };
        }
        m2.writeToStream = function(e2, t2, n3) {
          return n3 === void 0 && (n3 = t2, t2 = {}), f2(t2 = u(e2, t2), n3).dispatch(e2);
        };
      }.call(this, w("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
    }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(e, t, f2) {
      !function(e2, t2, n2, r, o, i, u, s, a) {
        !function(e3) {
          var a2 = typeof Uint8Array != "undefined" ? Uint8Array : Array, t3 = "+".charCodeAt(0), n3 = "/".charCodeAt(0), r2 = "0".charCodeAt(0), o2 = "a".charCodeAt(0), i2 = "A".charCodeAt(0), u2 = "-".charCodeAt(0), s2 = "_".charCodeAt(0);
          function f3(e4) {
            e4 = e4.charCodeAt(0);
            return e4 === t3 || e4 === u2 ? 62 : e4 === n3 || e4 === s2 ? 63 : e4 < r2 ? -1 : e4 < r2 + 10 ? e4 - r2 + 26 + 26 : e4 < i2 + 26 ? e4 - i2 : e4 < o2 + 26 ? e4 - o2 + 26 : void 0;
          }
          e3.toByteArray = function(e4) {
            var t4, n4;
            if (0 < e4.length % 4)
              throw new Error("Invalid string. Length must be a multiple of 4");
            var r3 = e4.length, r3 = e4.charAt(r3 - 2) === "=" ? 2 : e4.charAt(r3 - 1) === "=" ? 1 : 0, o3 = new a2(3 * e4.length / 4 - r3), i3 = 0 < r3 ? e4.length - 4 : e4.length, u3 = 0;
            function s3(e5) {
              o3[u3++] = e5;
            }
            for (t4 = 0; t4 < i3; t4 += 4, 0)
              s3((16711680 & (n4 = f3(e4.charAt(t4)) << 18 | f3(e4.charAt(t4 + 1)) << 12 | f3(e4.charAt(t4 + 2)) << 6 | f3(e4.charAt(t4 + 3)))) >> 16), s3((65280 & n4) >> 8), s3(255 & n4);
            return r3 == 2 ? s3(255 & (n4 = f3(e4.charAt(t4)) << 2 | f3(e4.charAt(t4 + 1)) >> 4)) : r3 == 1 && (s3((n4 = f3(e4.charAt(t4)) << 10 | f3(e4.charAt(t4 + 1)) << 4 | f3(e4.charAt(t4 + 2)) >> 2) >> 8 & 255), s3(255 & n4)), o3;
          }, e3.fromByteArray = function(e4) {
            var t4, n4, r3, o3, i3 = e4.length % 3, u3 = "";
            function s3(e5) {
              return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(e5);
            }
            for (t4 = 0, r3 = e4.length - i3; t4 < r3; t4 += 3)
              n4 = (e4[t4] << 16) + (e4[t4 + 1] << 8) + e4[t4 + 2], u3 += s3((o3 = n4) >> 18 & 63) + s3(o3 >> 12 & 63) + s3(o3 >> 6 & 63) + s3(63 & o3);
            switch (i3) {
              case 1:
                u3 = (u3 += s3((n4 = e4[e4.length - 1]) >> 2)) + s3(n4 << 4 & 63) + "==";
                break;
              case 2:
                u3 = (u3 = (u3 += s3((n4 = (e4[e4.length - 2] << 8) + e4[e4.length - 1]) >> 10)) + s3(n4 >> 4 & 63)) + s3(n4 << 2 & 63) + "=";
            }
            return u3;
          };
        }(f2 === void 0 ? this.base64js = {} : f2);
      }.call(this, e("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
    }, { buffer: 3, lYpoI2: 11 }], 3: [function(O, e, H) {
      !function(e2, n2, f2, r, h, p2, g, y, w) {
        var a = O("base64-js"), i = O("ieee754");
        function f2(e3, t2, n3) {
          if (!(this instanceof f2))
            return new f2(e3, t2, n3);
          var r2, o2, i2, u2, s2 = typeof e3;
          if (t2 === "base64" && s2 == "string")
            for (e3 = (u2 = e3).trim ? u2.trim() : u2.replace(/^\s+|\s+$/g, ""); e3.length % 4 != 0; )
              e3 += "=";
          if (s2 == "number")
            r2 = j(e3);
          else if (s2 == "string")
            r2 = f2.byteLength(e3, t2);
          else {
            if (s2 != "object")
              throw new Error("First argument needs to be a number, array or string.");
            r2 = j(e3.length);
          }
          if (f2._useTypedArrays ? o2 = f2._augment(new Uint8Array(r2)) : ((o2 = this).length = r2, o2._isBuffer = true), f2._useTypedArrays && typeof e3.byteLength == "number")
            o2._set(e3);
          else if (C(u2 = e3) || f2.isBuffer(u2) || u2 && typeof u2 == "object" && typeof u2.length == "number")
            for (i2 = 0; i2 < r2; i2++)
              f2.isBuffer(e3) ? o2[i2] = e3.readUInt8(i2) : o2[i2] = e3[i2];
          else if (s2 == "string")
            o2.write(e3, 0, t2);
          else if (s2 == "number" && !f2._useTypedArrays && !n3)
            for (i2 = 0; i2 < r2; i2++)
              o2[i2] = 0;
          return o2;
        }
        function b(e3, t2, n3, r2) {
          return f2._charsWritten = c(function(e4) {
            for (var t3 = [], n4 = 0; n4 < e4.length; n4++)
              t3.push(255 & e4.charCodeAt(n4));
            return t3;
          }(t2), e3, n3, r2);
        }
        function m2(e3, t2, n3, r2) {
          return f2._charsWritten = c(function(e4) {
            for (var t3, n4, r3 = [], o2 = 0; o2 < e4.length; o2++)
              n4 = e4.charCodeAt(o2), t3 = n4 >> 8, n4 = n4 % 256, r3.push(n4), r3.push(t3);
            return r3;
          }(t2), e3, n3, r2);
        }
        function v(e3, t2, n3) {
          var r2 = "";
          n3 = Math.min(e3.length, n3);
          for (var o2 = t2; o2 < n3; o2++)
            r2 += String.fromCharCode(e3[o2]);
          return r2;
        }
        function o(e3, t2, n3, r2) {
          r2 || (d(typeof n3 == "boolean", "missing or invalid endian"), d(t2 != null, "missing offset"), d(t2 + 1 < e3.length, "Trying to read beyond buffer length"));
          var o2, r2 = e3.length;
          if (!(r2 <= t2))
            return n3 ? (o2 = e3[t2], t2 + 1 < r2 && (o2 |= e3[t2 + 1] << 8)) : (o2 = e3[t2] << 8, t2 + 1 < r2 && (o2 |= e3[t2 + 1])), o2;
        }
        function u(e3, t2, n3, r2) {
          r2 || (d(typeof n3 == "boolean", "missing or invalid endian"), d(t2 != null, "missing offset"), d(t2 + 3 < e3.length, "Trying to read beyond buffer length"));
          var o2, r2 = e3.length;
          if (!(r2 <= t2))
            return n3 ? (t2 + 2 < r2 && (o2 = e3[t2 + 2] << 16), t2 + 1 < r2 && (o2 |= e3[t2 + 1] << 8), o2 |= e3[t2], t2 + 3 < r2 && (o2 += e3[t2 + 3] << 24 >>> 0)) : (t2 + 1 < r2 && (o2 = e3[t2 + 1] << 16), t2 + 2 < r2 && (o2 |= e3[t2 + 2] << 8), t2 + 3 < r2 && (o2 |= e3[t2 + 3]), o2 += e3[t2] << 24 >>> 0), o2;
        }
        function _(e3, t2, n3, r2) {
          if (r2 || (d(typeof n3 == "boolean", "missing or invalid endian"), d(t2 != null, "missing offset"), d(t2 + 1 < e3.length, "Trying to read beyond buffer length")), !(e3.length <= t2))
            return r2 = o(e3, t2, n3, true), 32768 & r2 ? -1 * (65535 - r2 + 1) : r2;
        }
        function E(e3, t2, n3, r2) {
          if (r2 || (d(typeof n3 == "boolean", "missing or invalid endian"), d(t2 != null, "missing offset"), d(t2 + 3 < e3.length, "Trying to read beyond buffer length")), !(e3.length <= t2))
            return r2 = u(e3, t2, n3, true), 2147483648 & r2 ? -1 * (4294967295 - r2 + 1) : r2;
        }
        function I(e3, t2, n3, r2) {
          return r2 || (d(typeof n3 == "boolean", "missing or invalid endian"), d(t2 + 3 < e3.length, "Trying to read beyond buffer length")), i.read(e3, t2, n3, 23, 4);
        }
        function A(e3, t2, n3, r2) {
          return r2 || (d(typeof n3 == "boolean", "missing or invalid endian"), d(t2 + 7 < e3.length, "Trying to read beyond buffer length")), i.read(e3, t2, n3, 52, 8);
        }
        function s(e3, t2, n3, r2, o2) {
          o2 || (d(t2 != null, "missing value"), d(typeof r2 == "boolean", "missing or invalid endian"), d(n3 != null, "missing offset"), d(n3 + 1 < e3.length, "trying to write beyond buffer length"), Y(t2, 65535));
          o2 = e3.length;
          if (!(o2 <= n3))
            for (var i2 = 0, u2 = Math.min(o2 - n3, 2); i2 < u2; i2++)
              e3[n3 + i2] = (t2 & 255 << 8 * (r2 ? i2 : 1 - i2)) >>> 8 * (r2 ? i2 : 1 - i2);
        }
        function l2(e3, t2, n3, r2, o2) {
          o2 || (d(t2 != null, "missing value"), d(typeof r2 == "boolean", "missing or invalid endian"), d(n3 != null, "missing offset"), d(n3 + 3 < e3.length, "trying to write beyond buffer length"), Y(t2, 4294967295));
          o2 = e3.length;
          if (!(o2 <= n3))
            for (var i2 = 0, u2 = Math.min(o2 - n3, 4); i2 < u2; i2++)
              e3[n3 + i2] = t2 >>> 8 * (r2 ? i2 : 3 - i2) & 255;
        }
        function B(e3, t2, n3, r2, o2) {
          o2 || (d(t2 != null, "missing value"), d(typeof r2 == "boolean", "missing or invalid endian"), d(n3 != null, "missing offset"), d(n3 + 1 < e3.length, "Trying to write beyond buffer length"), F(t2, 32767, -32768)), e3.length <= n3 || s(e3, 0 <= t2 ? t2 : 65535 + t2 + 1, n3, r2, o2);
        }
        function L(e3, t2, n3, r2, o2) {
          o2 || (d(t2 != null, "missing value"), d(typeof r2 == "boolean", "missing or invalid endian"), d(n3 != null, "missing offset"), d(n3 + 3 < e3.length, "Trying to write beyond buffer length"), F(t2, 2147483647, -2147483648)), e3.length <= n3 || l2(e3, 0 <= t2 ? t2 : 4294967295 + t2 + 1, n3, r2, o2);
        }
        function U(e3, t2, n3, r2, o2) {
          o2 || (d(t2 != null, "missing value"), d(typeof r2 == "boolean", "missing or invalid endian"), d(n3 != null, "missing offset"), d(n3 + 3 < e3.length, "Trying to write beyond buffer length"), D(t2, 34028234663852886e22, -34028234663852886e22)), e3.length <= n3 || i.write(e3, t2, n3, r2, 23, 4);
        }
        function x(e3, t2, n3, r2, o2) {
          o2 || (d(t2 != null, "missing value"), d(typeof r2 == "boolean", "missing or invalid endian"), d(n3 != null, "missing offset"), d(n3 + 7 < e3.length, "Trying to write beyond buffer length"), D(t2, 17976931348623157e292, -17976931348623157e292)), e3.length <= n3 || i.write(e3, t2, n3, r2, 52, 8);
        }
        H.Buffer = f2, H.SlowBuffer = f2, H.INSPECT_MAX_BYTES = 50, f2.poolSize = 8192, f2._useTypedArrays = function() {
          try {
            var e3 = new ArrayBuffer(0), t2 = new Uint8Array(e3);
            return t2.foo = function() {
              return 42;
            }, t2.foo() === 42 && typeof t2.subarray == "function";
          } catch (e4) {
            return false;
          }
        }(), f2.isEncoding = function(e3) {
          switch (String(e3).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "raw":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return true;
            default:
              return false;
          }
        }, f2.isBuffer = function(e3) {
          return !(e3 == null || !e3._isBuffer);
        }, f2.byteLength = function(e3, t2) {
          var n3;
          switch (e3 += "", t2 || "utf8") {
            case "hex":
              n3 = e3.length / 2;
              break;
            case "utf8":
            case "utf-8":
              n3 = T(e3).length;
              break;
            case "ascii":
            case "binary":
            case "raw":
              n3 = e3.length;
              break;
            case "base64":
              n3 = M(e3).length;
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              n3 = 2 * e3.length;
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return n3;
        }, f2.concat = function(e3, t2) {
          if (d(C(e3), "Usage: Buffer.concat(list, [totalLength])\nlist should be an Array."), e3.length === 0)
            return new f2(0);
          if (e3.length === 1)
            return e3[0];
          if (typeof t2 != "number")
            for (o2 = t2 = 0; o2 < e3.length; o2++)
              t2 += e3[o2].length;
          for (var n3 = new f2(t2), r2 = 0, o2 = 0; o2 < e3.length; o2++) {
            var i2 = e3[o2];
            i2.copy(n3, r2), r2 += i2.length;
          }
          return n3;
        }, f2.prototype.write = function(e3, t2, n3, r2) {
          isFinite(t2) ? isFinite(n3) || (r2 = n3, n3 = void 0) : (a2 = r2, r2 = t2, t2 = n3, n3 = a2), t2 = Number(t2) || 0;
          var o2, i2, u2, s2, a2 = this.length - t2;
          switch ((!n3 || a2 < (n3 = Number(n3))) && (n3 = a2), r2 = String(r2 || "utf8").toLowerCase()) {
            case "hex":
              o2 = function(e4, t3, n4, r3) {
                n4 = Number(n4) || 0;
                var o3 = e4.length - n4;
                (!r3 || o3 < (r3 = Number(r3))) && (r3 = o3), d((o3 = t3.length) % 2 == 0, "Invalid hex string"), o3 / 2 < r3 && (r3 = o3 / 2);
                for (var i3 = 0; i3 < r3; i3++) {
                  var u3 = parseInt(t3.substr(2 * i3, 2), 16);
                  d(!isNaN(u3), "Invalid hex string"), e4[n4 + i3] = u3;
                }
                return f2._charsWritten = 2 * i3, i3;
              }(this, e3, t2, n3);
              break;
            case "utf8":
            case "utf-8":
              i2 = this, u2 = t2, s2 = n3, o2 = f2._charsWritten = c(T(e3), i2, u2, s2);
              break;
            case "ascii":
            case "binary":
              o2 = b(this, e3, t2, n3);
              break;
            case "base64":
              i2 = this, u2 = t2, s2 = n3, o2 = f2._charsWritten = c(M(e3), i2, u2, s2);
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              o2 = m2(this, e3, t2, n3);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return o2;
        }, f2.prototype.toString = function(e3, t2, n3) {
          var r2, o2, i2, u2, s2 = this;
          if (e3 = String(e3 || "utf8").toLowerCase(), t2 = Number(t2) || 0, (n3 = n3 !== void 0 ? Number(n3) : s2.length) === t2)
            return "";
          switch (e3) {
            case "hex":
              r2 = function(e4, t3, n4) {
                var r3 = e4.length;
                (!t3 || t3 < 0) && (t3 = 0);
                (!n4 || n4 < 0 || r3 < n4) && (n4 = r3);
                for (var o3 = "", i3 = t3; i3 < n4; i3++)
                  o3 += k2(e4[i3]);
                return o3;
              }(s2, t2, n3);
              break;
            case "utf8":
            case "utf-8":
              r2 = function(e4, t3, n4) {
                var r3 = "", o3 = "";
                n4 = Math.min(e4.length, n4);
                for (var i3 = t3; i3 < n4; i3++)
                  e4[i3] <= 127 ? (r3 += N2(o3) + String.fromCharCode(e4[i3]), o3 = "") : o3 += "%" + e4[i3].toString(16);
                return r3 + N2(o3);
              }(s2, t2, n3);
              break;
            case "ascii":
            case "binary":
              r2 = v(s2, t2, n3);
              break;
            case "base64":
              o2 = s2, u2 = n3, r2 = (i2 = t2) === 0 && u2 === o2.length ? a.fromByteArray(o2) : a.fromByteArray(o2.slice(i2, u2));
              break;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              r2 = function(e4, t3, n4) {
                for (var r3 = e4.slice(t3, n4), o3 = "", i3 = 0; i3 < r3.length; i3 += 2)
                  o3 += String.fromCharCode(r3[i3] + 256 * r3[i3 + 1]);
                return o3;
              }(s2, t2, n3);
              break;
            default:
              throw new Error("Unknown encoding");
          }
          return r2;
        }, f2.prototype.toJSON = function() {
          return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
        }, f2.prototype.copy = function(e3, t2, n3, r2) {
          if (t2 = t2 || 0, (r2 = r2 || r2 === 0 ? r2 : this.length) !== (n3 = n3 || 0) && e3.length !== 0 && this.length !== 0) {
            d(n3 <= r2, "sourceEnd < sourceStart"), d(0 <= t2 && t2 < e3.length, "targetStart out of bounds"), d(0 <= n3 && n3 < this.length, "sourceStart out of bounds"), d(0 <= r2 && r2 <= this.length, "sourceEnd out of bounds"), r2 > this.length && (r2 = this.length);
            var o2 = (r2 = e3.length - t2 < r2 - n3 ? e3.length - t2 + n3 : r2) - n3;
            if (o2 < 100 || !f2._useTypedArrays)
              for (var i2 = 0; i2 < o2; i2++)
                e3[i2 + t2] = this[i2 + n3];
            else
              e3._set(this.subarray(n3, n3 + o2), t2);
          }
        }, f2.prototype.slice = function(e3, t2) {
          var n3 = this.length;
          if (e3 = S(e3, n3, 0), t2 = S(t2, n3, n3), f2._useTypedArrays)
            return f2._augment(this.subarray(e3, t2));
          for (var r2 = t2 - e3, o2 = new f2(r2, void 0, true), i2 = 0; i2 < r2; i2++)
            o2[i2] = this[i2 + e3];
          return o2;
        }, f2.prototype.get = function(e3) {
          return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(e3);
        }, f2.prototype.set = function(e3, t2) {
          return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(e3, t2);
        }, f2.prototype.readUInt8 = function(e3, t2) {
          if (t2 || (d(e3 != null, "missing offset"), d(e3 < this.length, "Trying to read beyond buffer length")), !(e3 >= this.length))
            return this[e3];
        }, f2.prototype.readUInt16LE = function(e3, t2) {
          return o(this, e3, true, t2);
        }, f2.prototype.readUInt16BE = function(e3, t2) {
          return o(this, e3, false, t2);
        }, f2.prototype.readUInt32LE = function(e3, t2) {
          return u(this, e3, true, t2);
        }, f2.prototype.readUInt32BE = function(e3, t2) {
          return u(this, e3, false, t2);
        }, f2.prototype.readInt8 = function(e3, t2) {
          if (t2 || (d(e3 != null, "missing offset"), d(e3 < this.length, "Trying to read beyond buffer length")), !(e3 >= this.length))
            return 128 & this[e3] ? -1 * (255 - this[e3] + 1) : this[e3];
        }, f2.prototype.readInt16LE = function(e3, t2) {
          return _(this, e3, true, t2);
        }, f2.prototype.readInt16BE = function(e3, t2) {
          return _(this, e3, false, t2);
        }, f2.prototype.readInt32LE = function(e3, t2) {
          return E(this, e3, true, t2);
        }, f2.prototype.readInt32BE = function(e3, t2) {
          return E(this, e3, false, t2);
        }, f2.prototype.readFloatLE = function(e3, t2) {
          return I(this, e3, true, t2);
        }, f2.prototype.readFloatBE = function(e3, t2) {
          return I(this, e3, false, t2);
        }, f2.prototype.readDoubleLE = function(e3, t2) {
          return A(this, e3, true, t2);
        }, f2.prototype.readDoubleBE = function(e3, t2) {
          return A(this, e3, false, t2);
        }, f2.prototype.writeUInt8 = function(e3, t2, n3) {
          n3 || (d(e3 != null, "missing value"), d(t2 != null, "missing offset"), d(t2 < this.length, "trying to write beyond buffer length"), Y(e3, 255)), t2 >= this.length || (this[t2] = e3);
        }, f2.prototype.writeUInt16LE = function(e3, t2, n3) {
          s(this, e3, t2, true, n3);
        }, f2.prototype.writeUInt16BE = function(e3, t2, n3) {
          s(this, e3, t2, false, n3);
        }, f2.prototype.writeUInt32LE = function(e3, t2, n3) {
          l2(this, e3, t2, true, n3);
        }, f2.prototype.writeUInt32BE = function(e3, t2, n3) {
          l2(this, e3, t2, false, n3);
        }, f2.prototype.writeInt8 = function(e3, t2, n3) {
          n3 || (d(e3 != null, "missing value"), d(t2 != null, "missing offset"), d(t2 < this.length, "Trying to write beyond buffer length"), F(e3, 127, -128)), t2 >= this.length || (0 <= e3 ? this.writeUInt8(e3, t2, n3) : this.writeUInt8(255 + e3 + 1, t2, n3));
        }, f2.prototype.writeInt16LE = function(e3, t2, n3) {
          B(this, e3, t2, true, n3);
        }, f2.prototype.writeInt16BE = function(e3, t2, n3) {
          B(this, e3, t2, false, n3);
        }, f2.prototype.writeInt32LE = function(e3, t2, n3) {
          L(this, e3, t2, true, n3);
        }, f2.prototype.writeInt32BE = function(e3, t2, n3) {
          L(this, e3, t2, false, n3);
        }, f2.prototype.writeFloatLE = function(e3, t2, n3) {
          U(this, e3, t2, true, n3);
        }, f2.prototype.writeFloatBE = function(e3, t2, n3) {
          U(this, e3, t2, false, n3);
        }, f2.prototype.writeDoubleLE = function(e3, t2, n3) {
          x(this, e3, t2, true, n3);
        }, f2.prototype.writeDoubleBE = function(e3, t2, n3) {
          x(this, e3, t2, false, n3);
        }, f2.prototype.fill = function(e3, t2, n3) {
          if (t2 = t2 || 0, n3 = n3 || this.length, d(typeof (e3 = typeof (e3 = e3 || 0) == "string" ? e3.charCodeAt(0) : e3) == "number" && !isNaN(e3), "value is not a number"), d(t2 <= n3, "end < start"), n3 !== t2 && this.length !== 0) {
            d(0 <= t2 && t2 < this.length, "start out of bounds"), d(0 <= n3 && n3 <= this.length, "end out of bounds");
            for (var r2 = t2; r2 < n3; r2++)
              this[r2] = e3;
          }
        }, f2.prototype.inspect = function() {
          for (var e3 = [], t2 = this.length, n3 = 0; n3 < t2; n3++)
            if (e3[n3] = k2(this[n3]), n3 === H.INSPECT_MAX_BYTES) {
              e3[n3 + 1] = "...";
              break;
            }
          return "<Buffer " + e3.join(" ") + ">";
        }, f2.prototype.toArrayBuffer = function() {
          if (typeof Uint8Array == "undefined")
            throw new Error("Buffer.toArrayBuffer not supported in this browser");
          if (f2._useTypedArrays)
            return new f2(this).buffer;
          for (var e3 = new Uint8Array(this.length), t2 = 0, n3 = e3.length; t2 < n3; t2 += 1)
            e3[t2] = this[t2];
          return e3.buffer;
        };
        var t = f2.prototype;
        function S(e3, t2, n3) {
          return typeof e3 != "number" ? n3 : t2 <= (e3 = ~~e3) ? t2 : 0 <= e3 || 0 <= (e3 += t2) ? e3 : 0;
        }
        function j(e3) {
          return (e3 = ~~Math.ceil(+e3)) < 0 ? 0 : e3;
        }
        function C(e3) {
          return (Array.isArray || function(e4) {
            return Object.prototype.toString.call(e4) === "[object Array]";
          })(e3);
        }
        function k2(e3) {
          return e3 < 16 ? "0" + e3.toString(16) : e3.toString(16);
        }
        function T(e3) {
          for (var t2 = [], n3 = 0; n3 < e3.length; n3++) {
            var r2 = e3.charCodeAt(n3);
            if (r2 <= 127)
              t2.push(e3.charCodeAt(n3));
            else
              for (var o2 = n3, i2 = (55296 <= r2 && r2 <= 57343 && n3++, encodeURIComponent(e3.slice(o2, n3 + 1)).substr(1).split("%")), u2 = 0; u2 < i2.length; u2++)
                t2.push(parseInt(i2[u2], 16));
          }
          return t2;
        }
        function M(e3) {
          return a.toByteArray(e3);
        }
        function c(e3, t2, n3, r2) {
          for (var o2 = 0; o2 < r2 && !(o2 + n3 >= t2.length || o2 >= e3.length); o2++)
            t2[o2 + n3] = e3[o2];
          return o2;
        }
        function N2(e3) {
          try {
            return decodeURIComponent(e3);
          } catch (e4) {
            return String.fromCharCode(65533);
          }
        }
        function Y(e3, t2) {
          d(typeof e3 == "number", "cannot write a non-number as a number"), d(0 <= e3, "specified a negative value for writing an unsigned value"), d(e3 <= t2, "value is larger than maximum value for type"), d(Math.floor(e3) === e3, "value has a fractional component");
        }
        function F(e3, t2, n3) {
          d(typeof e3 == "number", "cannot write a non-number as a number"), d(e3 <= t2, "value larger than maximum allowed value"), d(n3 <= e3, "value smaller than minimum allowed value"), d(Math.floor(e3) === e3, "value has a fractional component");
        }
        function D(e3, t2, n3) {
          d(typeof e3 == "number", "cannot write a non-number as a number"), d(e3 <= t2, "value larger than maximum allowed value"), d(n3 <= e3, "value smaller than minimum allowed value");
        }
        function d(e3, t2) {
          if (!e3)
            throw new Error(t2 || "Failed assertion");
        }
        f2._augment = function(e3) {
          return e3._isBuffer = true, e3._get = e3.get, e3._set = e3.set, e3.get = t.get, e3.set = t.set, e3.write = t.write, e3.toString = t.toString, e3.toLocaleString = t.toString, e3.toJSON = t.toJSON, e3.copy = t.copy, e3.slice = t.slice, e3.readUInt8 = t.readUInt8, e3.readUInt16LE = t.readUInt16LE, e3.readUInt16BE = t.readUInt16BE, e3.readUInt32LE = t.readUInt32LE, e3.readUInt32BE = t.readUInt32BE, e3.readInt8 = t.readInt8, e3.readInt16LE = t.readInt16LE, e3.readInt16BE = t.readInt16BE, e3.readInt32LE = t.readInt32LE, e3.readInt32BE = t.readInt32BE, e3.readFloatLE = t.readFloatLE, e3.readFloatBE = t.readFloatBE, e3.readDoubleLE = t.readDoubleLE, e3.readDoubleBE = t.readDoubleBE, e3.writeUInt8 = t.writeUInt8, e3.writeUInt16LE = t.writeUInt16LE, e3.writeUInt16BE = t.writeUInt16BE, e3.writeUInt32LE = t.writeUInt32LE, e3.writeUInt32BE = t.writeUInt32BE, e3.writeInt8 = t.writeInt8, e3.writeInt16LE = t.writeInt16LE, e3.writeInt16BE = t.writeInt16BE, e3.writeInt32LE = t.writeInt32LE, e3.writeInt32BE = t.writeInt32BE, e3.writeFloatLE = t.writeFloatLE, e3.writeFloatBE = t.writeFloatBE, e3.writeDoubleLE = t.writeDoubleLE, e3.writeDoubleBE = t.writeDoubleBE, e3.fill = t.fill, e3.inspect = t.inspect, e3.toArrayBuffer = t.toArrayBuffer, e3;
        };
      }.call(this, O("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, O("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
    }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(c, d, e) {
      !function(e2, t, a, n2, r, o, i, u, s) {
        var a = c("buffer").Buffer, f2 = 4, l2 = new a(f2);
        l2.fill(0);
        d.exports = { hash: function(e3, t2, n3, r2) {
          for (var o2 = t2(function(e4, t3) {
            e4.length % f2 != 0 && (n4 = e4.length + (f2 - e4.length % f2), e4 = a.concat([e4, l2], n4));
            for (var n4, r3 = [], o3 = t3 ? e4.readInt32BE : e4.readInt32LE, i3 = 0; i3 < e4.length; i3 += f2)
              r3.push(o3.call(e4, i3));
            return r3;
          }(e3 = a.isBuffer(e3) ? e3 : new a(e3), r2), 8 * e3.length), t2 = r2, i2 = new a(n3), u2 = t2 ? i2.writeInt32BE : i2.writeInt32LE, s2 = 0; s2 < o2.length; s2++)
            u2.call(i2, o2[s2], 4 * s2, true);
          return i2;
        } };
      }.call(this, c("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 5: [function(v, e, _) {
      !function(l2, c, u, d, h, p2, g, y, w) {
        var u = v("buffer").Buffer, e2 = v("./sha"), t = v("./sha256"), n2 = v("./rng"), b = { sha1: e2, sha256: t, md5: v("./md5") }, s = 64, a = new u(s);
        function r(e3, n3) {
          var r2 = b[e3 = e3 || "sha1"], o2 = [];
          return r2 || i("algorithm:", e3, "is not yet supported"), { update: function(e4) {
            return u.isBuffer(e4) || (e4 = new u(e4)), o2.push(e4), e4.length, this;
          }, digest: function(e4) {
            var t2 = u.concat(o2), t2 = n3 ? function(e5, t3, n4) {
              u.isBuffer(t3) || (t3 = new u(t3)), u.isBuffer(n4) || (n4 = new u(n4)), t3.length > s ? t3 = e5(t3) : t3.length < s && (t3 = u.concat([t3, a], s));
              for (var r3 = new u(s), o3 = new u(s), i2 = 0; i2 < s; i2++)
                r3[i2] = 54 ^ t3[i2], o3[i2] = 92 ^ t3[i2];
              return n4 = e5(u.concat([r3, n4])), e5(u.concat([o3, n4]));
            }(r2, n3, t2) : r2(t2);
            return o2 = null, e4 ? t2.toString(e4) : t2;
          } };
        }
        function i() {
          var e3 = [].slice.call(arguments).join(" ");
          throw new Error([e3, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join("\n"));
        }
        a.fill(0), _.createHash = function(e3) {
          return r(e3);
        }, _.createHmac = r, _.randomBytes = function(e3, t2) {
          if (!t2 || !t2.call)
            return new u(n2(e3));
          try {
            t2.call(this, void 0, new u(n2(e3)));
          } catch (e4) {
            t2(e4);
          }
        };
        var o, f2 = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], m2 = function(e3) {
          _[e3] = function() {
            i("sorry,", e3, "is not implemented yet");
          };
        };
        for (o in f2)
          m2(f2[o]);
      }.call(this, v("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, v("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(w, b, e) {
      !function(e2, r, o, i, u, a, f2, l2, y) {
        var t = w("./helpers");
        function n2(e3, t2) {
          e3[t2 >> 5] |= 128 << t2 % 32, e3[14 + (t2 + 64 >>> 9 << 4)] = t2;
          for (var n3 = 1732584193, r2 = -271733879, o2 = -1732584194, i2 = 271733878, u2 = 0; u2 < e3.length; u2 += 16) {
            var s2 = n3, a2 = r2, f3 = o2, l3 = i2, n3 = c(n3, r2, o2, i2, e3[u2 + 0], 7, -680876936), i2 = c(i2, n3, r2, o2, e3[u2 + 1], 12, -389564586), o2 = c(o2, i2, n3, r2, e3[u2 + 2], 17, 606105819), r2 = c(r2, o2, i2, n3, e3[u2 + 3], 22, -1044525330);
            n3 = c(n3, r2, o2, i2, e3[u2 + 4], 7, -176418897), i2 = c(i2, n3, r2, o2, e3[u2 + 5], 12, 1200080426), o2 = c(o2, i2, n3, r2, e3[u2 + 6], 17, -1473231341), r2 = c(r2, o2, i2, n3, e3[u2 + 7], 22, -45705983), n3 = c(n3, r2, o2, i2, e3[u2 + 8], 7, 1770035416), i2 = c(i2, n3, r2, o2, e3[u2 + 9], 12, -1958414417), o2 = c(o2, i2, n3, r2, e3[u2 + 10], 17, -42063), r2 = c(r2, o2, i2, n3, e3[u2 + 11], 22, -1990404162), n3 = c(n3, r2, o2, i2, e3[u2 + 12], 7, 1804603682), i2 = c(i2, n3, r2, o2, e3[u2 + 13], 12, -40341101), o2 = c(o2, i2, n3, r2, e3[u2 + 14], 17, -1502002290), n3 = d(n3, r2 = c(r2, o2, i2, n3, e3[u2 + 15], 22, 1236535329), o2, i2, e3[u2 + 1], 5, -165796510), i2 = d(i2, n3, r2, o2, e3[u2 + 6], 9, -1069501632), o2 = d(o2, i2, n3, r2, e3[u2 + 11], 14, 643717713), r2 = d(r2, o2, i2, n3, e3[u2 + 0], 20, -373897302), n3 = d(n3, r2, o2, i2, e3[u2 + 5], 5, -701558691), i2 = d(i2, n3, r2, o2, e3[u2 + 10], 9, 38016083), o2 = d(o2, i2, n3, r2, e3[u2 + 15], 14, -660478335), r2 = d(r2, o2, i2, n3, e3[u2 + 4], 20, -405537848), n3 = d(n3, r2, o2, i2, e3[u2 + 9], 5, 568446438), i2 = d(i2, n3, r2, o2, e3[u2 + 14], 9, -1019803690), o2 = d(o2, i2, n3, r2, e3[u2 + 3], 14, -187363961), r2 = d(r2, o2, i2, n3, e3[u2 + 8], 20, 1163531501), n3 = d(n3, r2, o2, i2, e3[u2 + 13], 5, -1444681467), i2 = d(i2, n3, r2, o2, e3[u2 + 2], 9, -51403784), o2 = d(o2, i2, n3, r2, e3[u2 + 7], 14, 1735328473), n3 = h(n3, r2 = d(r2, o2, i2, n3, e3[u2 + 12], 20, -1926607734), o2, i2, e3[u2 + 5], 4, -378558), i2 = h(i2, n3, r2, o2, e3[u2 + 8], 11, -2022574463), o2 = h(o2, i2, n3, r2, e3[u2 + 11], 16, 1839030562), r2 = h(r2, o2, i2, n3, e3[u2 + 14], 23, -35309556), n3 = h(n3, r2, o2, i2, e3[u2 + 1], 4, -1530992060), i2 = h(i2, n3, r2, o2, e3[u2 + 4], 11, 1272893353), o2 = h(o2, i2, n3, r2, e3[u2 + 7], 16, -155497632), r2 = h(r2, o2, i2, n3, e3[u2 + 10], 23, -1094730640), n3 = h(n3, r2, o2, i2, e3[u2 + 13], 4, 681279174), i2 = h(i2, n3, r2, o2, e3[u2 + 0], 11, -358537222), o2 = h(o2, i2, n3, r2, e3[u2 + 3], 16, -722521979), r2 = h(r2, o2, i2, n3, e3[u2 + 6], 23, 76029189), n3 = h(n3, r2, o2, i2, e3[u2 + 9], 4, -640364487), i2 = h(i2, n3, r2, o2, e3[u2 + 12], 11, -421815835), o2 = h(o2, i2, n3, r2, e3[u2 + 15], 16, 530742520), n3 = p2(n3, r2 = h(r2, o2, i2, n3, e3[u2 + 2], 23, -995338651), o2, i2, e3[u2 + 0], 6, -198630844), i2 = p2(i2, n3, r2, o2, e3[u2 + 7], 10, 1126891415), o2 = p2(o2, i2, n3, r2, e3[u2 + 14], 15, -1416354905), r2 = p2(r2, o2, i2, n3, e3[u2 + 5], 21, -57434055), n3 = p2(n3, r2, o2, i2, e3[u2 + 12], 6, 1700485571), i2 = p2(i2, n3, r2, o2, e3[u2 + 3], 10, -1894986606), o2 = p2(o2, i2, n3, r2, e3[u2 + 10], 15, -1051523), r2 = p2(r2, o2, i2, n3, e3[u2 + 1], 21, -2054922799), n3 = p2(n3, r2, o2, i2, e3[u2 + 8], 6, 1873313359), i2 = p2(i2, n3, r2, o2, e3[u2 + 15], 10, -30611744), o2 = p2(o2, i2, n3, r2, e3[u2 + 6], 15, -1560198380), r2 = p2(r2, o2, i2, n3, e3[u2 + 13], 21, 1309151649), n3 = p2(n3, r2, o2, i2, e3[u2 + 4], 6, -145523070), i2 = p2(i2, n3, r2, o2, e3[u2 + 11], 10, -1120210379), o2 = p2(o2, i2, n3, r2, e3[u2 + 2], 15, 718787259), r2 = p2(r2, o2, i2, n3, e3[u2 + 9], 21, -343485551), n3 = g(n3, s2), r2 = g(r2, a2), o2 = g(o2, f3), i2 = g(i2, l3);
          }
          return Array(n3, r2, o2, i2);
        }
        function s(e3, t2, n3, r2, o2, i2) {
          return g((t2 = g(g(t2, e3), g(r2, i2))) << o2 | t2 >>> 32 - o2, n3);
        }
        function c(e3, t2, n3, r2, o2, i2, u2) {
          return s(t2 & n3 | ~t2 & r2, e3, t2, o2, i2, u2);
        }
        function d(e3, t2, n3, r2, o2, i2, u2) {
          return s(t2 & r2 | n3 & ~r2, e3, t2, o2, i2, u2);
        }
        function h(e3, t2, n3, r2, o2, i2, u2) {
          return s(t2 ^ n3 ^ r2, e3, t2, o2, i2, u2);
        }
        function p2(e3, t2, n3, r2, o2, i2, u2) {
          return s(n3 ^ (t2 | ~r2), e3, t2, o2, i2, u2);
        }
        function g(e3, t2) {
          var n3 = (65535 & e3) + (65535 & t2);
          return (e3 >> 16) + (t2 >> 16) + (n3 >> 16) << 16 | 65535 & n3;
        }
        b.exports = function(e3) {
          return t.hash(e3, n2, 16);
        };
      }.call(this, w("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, w("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(e, l2, t) {
      !function(e2, t2, n2, r, o, i, u, s, f2) {
        l2.exports = function(e3) {
          for (var t3, n3 = new Array(e3), r2 = 0; r2 < e3; r2++)
            (3 & r2) == 0 && (t3 = 4294967296 * Math.random()), n3[r2] = t3 >>> ((3 & r2) << 3) & 255;
          return n3;
        };
      }.call(this, e("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { buffer: 3, lYpoI2: 11 }], 8: [function(c, d, e) {
      !function(e2, t, n2, r, o, s, a, f2, l2) {
        var i = c("./helpers");
        function u(l3, c2) {
          l3[c2 >> 5] |= 128 << 24 - c2 % 32, l3[15 + (c2 + 64 >> 9 << 4)] = c2;
          for (var e3, t2, n3, r2 = Array(80), o2 = 1732584193, i2 = -271733879, u2 = -1732584194, s2 = 271733878, d2 = -1009589776, h = 0; h < l3.length; h += 16) {
            for (var p2 = o2, g = i2, y = u2, w = s2, b = d2, a2 = 0; a2 < 80; a2++) {
              r2[a2] = a2 < 16 ? l3[h + a2] : v(r2[a2 - 3] ^ r2[a2 - 8] ^ r2[a2 - 14] ^ r2[a2 - 16], 1);
              var f3 = m2(m2(v(o2, 5), (f3 = i2, t2 = u2, n3 = s2, (e3 = a2) < 20 ? f3 & t2 | ~f3 & n3 : !(e3 < 40) && e3 < 60 ? f3 & t2 | f3 & n3 | t2 & n3 : f3 ^ t2 ^ n3)), m2(m2(d2, r2[a2]), (e3 = a2) < 20 ? 1518500249 : e3 < 40 ? 1859775393 : e3 < 60 ? -1894007588 : -899497514)), d2 = s2, s2 = u2, u2 = v(i2, 30), i2 = o2, o2 = f3;
            }
            o2 = m2(o2, p2), i2 = m2(i2, g), u2 = m2(u2, y), s2 = m2(s2, w), d2 = m2(d2, b);
          }
          return Array(o2, i2, u2, s2, d2);
        }
        function m2(e3, t2) {
          var n3 = (65535 & e3) + (65535 & t2);
          return (e3 >> 16) + (t2 >> 16) + (n3 >> 16) << 16 | 65535 & n3;
        }
        function v(e3, t2) {
          return e3 << t2 | e3 >>> 32 - t2;
        }
        d.exports = function(e3) {
          return i.hash(e3, u, 20, true);
        };
      }.call(this, c("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(c, d, e) {
      !function(e2, t, n2, r, u, s, a, f2, l2) {
        function b(e3, t2) {
          var n3 = (65535 & e3) + (65535 & t2);
          return (e3 >> 16) + (t2 >> 16) + (n3 >> 16) << 16 | 65535 & n3;
        }
        function o(e3, l3) {
          var c2, d2 = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), t2 = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), n3 = new Array(64);
          e3[l3 >> 5] |= 128 << 24 - l3 % 32, e3[15 + (l3 + 64 >> 9 << 4)] = l3;
          for (var r2, o2, h = 0; h < e3.length; h += 16) {
            for (var i2 = t2[0], u2 = t2[1], s2 = t2[2], p2 = t2[3], a2 = t2[4], g = t2[5], y = t2[6], w = t2[7], f3 = 0; f3 < 64; f3++)
              n3[f3] = f3 < 16 ? e3[f3 + h] : b(b(b((o2 = n3[f3 - 2], m2(o2, 17) ^ m2(o2, 19) ^ v(o2, 10)), n3[f3 - 7]), (o2 = n3[f3 - 15], m2(o2, 7) ^ m2(o2, 18) ^ v(o2, 3))), n3[f3 - 16]), c2 = b(b(b(b(w, m2(o2 = a2, 6) ^ m2(o2, 11) ^ m2(o2, 25)), a2 & g ^ ~a2 & y), d2[f3]), n3[f3]), r2 = b(m2(r2 = i2, 2) ^ m2(r2, 13) ^ m2(r2, 22), i2 & u2 ^ i2 & s2 ^ u2 & s2), w = y, y = g, g = a2, a2 = b(p2, c2), p2 = s2, s2 = u2, u2 = i2, i2 = b(c2, r2);
            t2[0] = b(i2, t2[0]), t2[1] = b(u2, t2[1]), t2[2] = b(s2, t2[2]), t2[3] = b(p2, t2[3]), t2[4] = b(a2, t2[4]), t2[5] = b(g, t2[5]), t2[6] = b(y, t2[6]), t2[7] = b(w, t2[7]);
          }
          return t2;
        }
        var i = c("./helpers"), m2 = function(e3, t2) {
          return e3 >>> t2 | e3 << 32 - t2;
        }, v = function(e3, t2) {
          return e3 >>> t2;
        };
        d.exports = function(e3) {
          return i.hash(e3, o, 32, true);
        };
      }.call(this, c("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, c("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
    }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(e, t, f2) {
      !function(e2, t2, n2, r, o, i, u, s, a) {
        f2.read = function(e3, t3, n3, r2, o2) {
          var i2, u2, l2 = 8 * o2 - r2 - 1, c = (1 << l2) - 1, d = c >> 1, s2 = -7, a2 = n3 ? o2 - 1 : 0, f3 = n3 ? -1 : 1, o2 = e3[t3 + a2];
          for (a2 += f3, i2 = o2 & (1 << -s2) - 1, o2 >>= -s2, s2 += l2; 0 < s2; i2 = 256 * i2 + e3[t3 + a2], a2 += f3, s2 -= 8)
            ;
          for (u2 = i2 & (1 << -s2) - 1, i2 >>= -s2, s2 += r2; 0 < s2; u2 = 256 * u2 + e3[t3 + a2], a2 += f3, s2 -= 8)
            ;
          if (i2 === 0)
            i2 = 1 - d;
          else {
            if (i2 === c)
              return u2 ? NaN : 1 / 0 * (o2 ? -1 : 1);
            u2 += Math.pow(2, r2), i2 -= d;
          }
          return (o2 ? -1 : 1) * u2 * Math.pow(2, i2 - r2);
        }, f2.write = function(e3, t3, l2, n3, r2, c) {
          var o2, i2, u2 = 8 * c - r2 - 1, s2 = (1 << u2) - 1, a2 = s2 >> 1, d = r2 === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f3 = n3 ? 0 : c - 1, h = n3 ? 1 : -1, c = t3 < 0 || t3 === 0 && 1 / t3 < 0 ? 1 : 0;
          for (t3 = Math.abs(t3), isNaN(t3) || t3 === 1 / 0 ? (i2 = isNaN(t3) ? 1 : 0, o2 = s2) : (o2 = Math.floor(Math.log(t3) / Math.LN2), t3 * (n3 = Math.pow(2, -o2)) < 1 && (o2--, n3 *= 2), 2 <= (t3 += 1 <= o2 + a2 ? d / n3 : d * Math.pow(2, 1 - a2)) * n3 && (o2++, n3 /= 2), s2 <= o2 + a2 ? (i2 = 0, o2 = s2) : 1 <= o2 + a2 ? (i2 = (t3 * n3 - 1) * Math.pow(2, r2), o2 += a2) : (i2 = t3 * Math.pow(2, a2 - 1) * Math.pow(2, r2), o2 = 0)); 8 <= r2; e3[l2 + f3] = 255 & i2, f3 += h, i2 /= 256, r2 -= 8)
            ;
          for (o2 = o2 << r2 | i2, u2 += r2; 0 < u2; e3[l2 + f3] = 255 & o2, f3 += h, o2 /= 256, u2 -= 8)
            ;
          e3[l2 + f3 - h] |= 128 * c;
        };
      }.call(this, e("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
    }, { buffer: 3, lYpoI2: 11 }], 11: [function(e, h, t) {
      !function(e2, t2, n2, r, o, f2, l2, c, d) {
        var i, u, s;
        function a() {
        }
        (e2 = h.exports = {}).nextTick = (u = typeof window != "undefined" && window.setImmediate, s = typeof window != "undefined" && window.postMessage && window.addEventListener, u ? function(e3) {
          return window.setImmediate(e3);
        } : s ? (i = [], window.addEventListener("message", function(e3) {
          var t3 = e3.source;
          t3 !== window && t3 !== null || e3.data !== "process-tick" || (e3.stopPropagation(), 0 < i.length && i.shift()());
        }, true), function(e3) {
          i.push(e3), window.postMessage("process-tick", "*");
        }) : function(e3) {
          setTimeout(e3, 0);
        }), e2.title = "browser", e2.browser = true, e2.env = {}, e2.argv = [], e2.on = a, e2.addListener = a, e2.once = a, e2.off = a, e2.removeListener = a, e2.removeAllListeners = a, e2.emit = a, e2.binding = function(e3) {
          throw new Error("process.binding is not supported");
        }, e2.cwd = function() {
          return "/";
        }, e2.chdir = function(e3) {
          throw new Error("process.chdir is not supported");
        };
      }.call(this, e("lYpoI2"), typeof self != "undefined" ? self : typeof window != "undefined" ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
    }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
  });
})(object_hash);
var hash = object_hash.exports;
var styles$1 = "";
var styles = "";
const ResizingGridLayout = reactGridLayout.exports.WidthProvider(GridLayout);
const MetapageGridLayout = ({
  metapage,
  definition,
  inputs,
  onOutputs,
  onDefinition,
  debug,
  Wrapper,
  ErrorWrapper
}) => {
  var _a, _b, _c, _d, _e2, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  const definitionRef = useRef();
  const [definitionInternal, setDefinitionInternal] = useState();
  const [metapageInternal, setMetapageInternal] = useState();
  const [error, setError] = useState();
  useEffect(() => {
    setMetapageInternal(metapage);
  }, [metapage, setMetapageInternal]);
  useEffect(() => {
    if (!definition) {
      definitionRef.current = void 0;
      setDefinitionInternal(void 0);
      return;
    }
    if (!definitionRef.current) {
      definitionRef.current = {
        definition
      };
      setDefinitionInternal(JSON.parse(JSON.stringify(definition)));
    } else {
      if (!definitionRef.current.hash) {
        definitionRef.current.hash = hash(definitionRef.current.definition);
      }
      const hashDefinition = hash(definition);
      if (hashDefinition !== definitionRef.current.hash) {
        definitionRef.current = {
          definition,
          hash: hashDefinition
        };
        setDefinitionInternal(JSON.parse(JSON.stringify(definition)));
      }
    }
  }, [definition, setDefinitionInternal, definitionRef]);
  useEffect(() => {
    setError(void 0);
    if (!definitionInternal) {
      return;
    }
    if (metapage) {
      return;
    }
    const metapageNew = new tt();
    metapageNew.debug = debug;
    try {
      metapageNew.setDefinition(definitionInternal);
    } catch (err) {
      setMetapageInternal(void 0);
      setError(err);
      return;
    }
    setMetapageInternal(metapageNew);
    return () => {
      metapageNew.dispose();
    };
  }, [metapage, definitionInternal, setMetapageInternal, setError, debug, definitionRef]);
  useEffect(() => {
    if (!metapageInternal) {
      return;
    }
    const disposers = [];
    disposers.push(metapageInternal.addListenerReturnDisposer(N.Error, setError));
    if (onOutputs) {
      disposers.push(metapageInternal.addListenerReturnDisposer(N.Outputs, onOutputs));
    }
    if (onDefinition) {
      disposers.push(metapageInternal.addListenerReturnDisposer(N.Definition, (e) => {
        definitionRef.current = {
          definition: e.definition
        };
        onDefinition(e.definition);
      }));
    }
    return () => {
      while (disposers.length > 0) {
        const disposer = disposers.pop();
        if (disposer) {
          disposer();
        }
      }
    };
  }, [metapageInternal, onOutputs, onDefinition, setError]);
  useEffect(() => {
    if (metapageInternal && !metapageInternal.isDisposed() && inputs) {
      metapageInternal.setInputs(inputs);
    }
  }, [metapageInternal, inputs]);
  const defaultLayout = !metapageInternal ? [] : Object.keys(metapageInternal.getMetaframes()).map((metaframeId, i) => {
    return {
      i: metaframeId,
      x: i % 2 === 0 ? 0 : 6,
      y: Math.floor(i / 2),
      w: 6,
      h: 2
    };
  });
  const rowHeight = metapageInternal && ((_d = (_c = (_b = (_a = definitionInternal == null ? void 0 : definitionInternal.meta) == null ? void 0 : _a.layouts) == null ? void 0 : _b["react-grid-layout"]) == null ? void 0 : _c.props) == null ? void 0 : _d.rowHeight) || 100;
  const containerPadding = metapageInternal && ((_h = (_g = (_f = (_e2 = definitionInternal == null ? void 0 : definitionInternal.meta) == null ? void 0 : _e2.layouts) == null ? void 0 : _f["react-grid-layout"]) == null ? void 0 : _g.props) == null ? void 0 : _h.containerPadding) || [5, 5];
  const cols = metapageInternal && ((_l = (_k = (_j = (_i = definitionInternal == null ? void 0 : definitionInternal.meta) == null ? void 0 : _i.layouts) == null ? void 0 : _j["react-grid-layout"]) == null ? void 0 : _k.props) == null ? void 0 : _l.cols) || 12;
  const margin = metapageInternal && ((_p = (_o = (_n = (_m = definitionInternal == null ? void 0 : definitionInternal.meta) == null ? void 0 : _m.layouts) == null ? void 0 : _n["react-grid-layout"]) == null ? void 0 : _o.props) == null ? void 0 : _p.margin) || [10, 20];
  let layout2 = metapageInternal && ((_s = (_r = (_q = definitionInternal == null ? void 0 : definitionInternal.meta) == null ? void 0 : _q.layouts) == null ? void 0 : _r["react-grid-layout"]) == null ? void 0 : _s.layout) ? [...(_v = (_u = (_t = definitionInternal == null ? void 0 : definitionInternal.meta) == null ? void 0 : _t.layouts) == null ? void 0 : _u["react-grid-layout"]) == null ? void 0 : _v.layout] : defaultLayout;
  const onLayoutChange = useCallback((layout22) => {
    if (!onDefinition || !definitionInternal) {
      return;
    }
    const newDefinition = JSON.parse(JSON.stringify(definitionInternal));
    newDefinition.meta = newDefinition.meta || {};
    newDefinition.meta.layouts = newDefinition.meta.layouts || {};
    const reactGridLayout2 = {
      docs: "https://www.npmjs.com/package/react-grid-layout",
      props: {
        cols,
        margin,
        rowHeight,
        containerPadding
      },
      layout: layout22
    };
    newDefinition.meta.layouts["react-grid-layout"] = reactGridLayout2;
    onDefinition(newDefinition);
  }, [onDefinition, definitionInternal]);
  if (error) {
    if (ErrorWrapper) {
      return /* @__PURE__ */ jsx(ErrorWrapper, {
        error
      });
    } else {
      return /* @__PURE__ */ jsxs("div", {
        children: ["Error: ", `${error}`]
      });
    }
  }
  return /* @__PURE__ */ jsx(ResizingGridLayout, {
    layout: layout2,
    isDraggable: true,
    isResizable: true,
    className: "layout",
    cols,
    containerPadding,
    rowHeight,
    margin,
    onLayoutChange,
    children: !metapageInternal ? [] : Object.keys(metapageInternal.getMetaframes()).map((metaframeId, i) => Wrapper ? /* @__PURE__ */ jsx(Wrapper, {
      height: `${rowHeight}px`,
      children: /* @__PURE__ */ jsx(MetaframeIframe, {
        metaframe: metapageInternal.getMetaframes()[metaframeId]
      }, metaframeId)
    }, metaframeId) : /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(MetaframeIframe, {
        height: `${rowHeight}px`,
        metaframe: metapageInternal.getMetaframes()[metaframeId]
      }, metaframeId)
    }, metaframeId))
  });
};
export { MetaframeIframe, MetaframeStandaloneComponent, MetapageGridLayout };
